import { subDays } from 'date-fns';
export var mockData = [
    {
        id: 1746,
        roomId: 4,
        userId: 10,
        subUserId: null,
        eventId: 4902,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 29).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1745,
        roomId: 4,
        userId: 10,
        subUserId: 11,
        eventId: 4901,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 29).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1744,
        roomId: 4,
        userId: 11,
        subUserId: null,
        eventId: 4900,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 29).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1743,
        roomId: 4,
        userId: 10,
        subUserId: 11,
        eventId: 4899,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 29).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1742,
        roomId: 4,
        userId: 11,
        subUserId: null,
        eventId: 4898,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 29).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1741,
        roomId: 4,
        userId: 11,
        subUserId: 10,
        eventId: 4897,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 29).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1740,
        roomId: 4,
        userId: 10,
        subUserId: null,
        eventId: 4896,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 29).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1739,
        roomId: 4,
        userId: 10,
        subUserId: 11,
        eventId: 4895,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 29).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1738,
        roomId: 4,
        userId: 11,
        subUserId: null,
        eventId: 4894,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 29).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1737,
        roomId: 4,
        userId: 11,
        subUserId: 10,
        eventId: 4893,
        workspaceId: 6,
        action: 'CHAT_REACTION_ADDED',
        date: subDays(new Date(), 29).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1736,
        roomId: 3,
        userId: 9,
        subUserId: null,
        eventId: 4892,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 29).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1735,
        roomId: 3,
        userId: 11,
        subUserId: null,
        eventId: 4891,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 29).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1734,
        roomId: 3,
        userId: 11,
        subUserId: null,
        eventId: 4890,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 29).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1733,
        roomId: 3,
        userId: 11,
        subUserId: null,
        eventId: 4889,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 29).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1732,
        roomId: 3,
        userId: 11,
        subUserId: null,
        eventId: 4888,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 29).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1731,
        roomId: 3,
        userId: 11,
        subUserId: null,
        eventId: 4887,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 29).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1730,
        roomId: 3,
        userId: 11,
        subUserId: null,
        eventId: 4886,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 29).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1729,
        roomId: 3,
        userId: 11,
        subUserId: null,
        eventId: 4885,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 29).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1728,
        roomId: 3,
        userId: 11,
        subUserId: null,
        eventId: 4884,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 29).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1727,
        roomId: 3,
        userId: 11,
        subUserId: null,
        eventId: 4883,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 29).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1726,
        roomId: 3,
        userId: 11,
        subUserId: null,
        eventId: 4880,
        workspaceId: 6,
        action: 'CHAT_REACTION_ADDED',
        date: subDays(new Date(), 29).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1725,
        roomId: 3,
        userId: 11,
        subUserId: null,
        eventId: 4879,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 29).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1724,
        roomId: 3,
        userId: 11,
        subUserId: null,
        eventId: 4878,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 29).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1723,
        roomId: 3,
        userId: 11,
        subUserId: null,
        eventId: 4877,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 29).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1722,
        roomId: 3,
        userId: 11,
        subUserId: null,
        eventId: 4876,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 29).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1721,
        roomId: 3,
        userId: 11,
        subUserId: null,
        eventId: 4875,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 29).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1720,
        roomId: 3,
        userId: 11,
        subUserId: null,
        eventId: 4874,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 29).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1719,
        roomId: 3,
        userId: 11,
        subUserId: null,
        eventId: 4873,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 29).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1718,
        roomId: 3,
        userId: 11,
        subUserId: null,
        eventId: 4872,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 29).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1716,
        roomId: 3,
        userId: 11,
        subUserId: null,
        eventId: 4870,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 29).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1717,
        roomId: 3,
        userId: 11,
        subUserId: null,
        eventId: 4871,
        workspaceId: 6,
        action: 'CHAT_ATTACHMENT_UPLOAD',
        date: subDays(new Date(), 29).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1715,
        roomId: 4,
        userId: 11,
        subUserId: 10,
        eventId: 4869,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 29).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1714,
        roomId: 4,
        userId: 10,
        subUserId: 11,
        eventId: 4868,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 29).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1713,
        roomId: 3,
        userId: 11,
        subUserId: null,
        eventId: 4867,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 29).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1712,
        roomId: 3,
        userId: 11,
        subUserId: null,
        eventId: 4866,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 29).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1711,
        roomId: 3,
        userId: 11,
        subUserId: null,
        eventId: 4865,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 29).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1710,
        roomId: 4,
        userId: 11,
        subUserId: null,
        eventId: 4864,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 29).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1709,
        roomId: 4,
        userId: 11,
        subUserId: 10,
        eventId: 4863,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 28).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1708,
        roomId: 4,
        userId: 10,
        subUserId: null,
        eventId: 4862,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 28).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1707,
        roomId: 4,
        userId: 10,
        subUserId: 11,
        eventId: 4861,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 28).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1706,
        roomId: 4,
        userId: 11,
        subUserId: null,
        eventId: 4860,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 28).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1705,
        roomId: 4,
        userId: 11,
        subUserId: 10,
        eventId: 4859,
        workspaceId: 6,
        action: 'CHAT_REACTION_ADDED',
        date: subDays(new Date(), 28).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1704,
        roomId: 4,
        userId: 11,
        subUserId: 10,
        eventId: 4858,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 28).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1703,
        roomId: 3,
        userId: 11,
        subUserId: null,
        eventId: 4857,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 28).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1702,
        roomId: 3,
        userId: 11,
        subUserId: null,
        eventId: 4856,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 28).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1701,
        roomId: 3,
        userId: 11,
        subUserId: null,
        eventId: 4855,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_EDITED',
        date: subDays(new Date(), 28).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1700,
        roomId: 4,
        userId: 10,
        subUserId: null,
        eventId: 4854,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 28).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1699,
        roomId: 4,
        userId: 10,
        subUserId: 11,
        eventId: 4853,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 28).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1698,
        roomId: 4,
        userId: 11,
        subUserId: null,
        eventId: 4852,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 28).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1697,
        roomId: 4,
        userId: 11,
        subUserId: 10,
        eventId: 4851,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 28).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1696,
        roomId: 4,
        userId: 10,
        subUserId: null,
        eventId: 4850,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 28).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1695,
        roomId: 9,
        userId: 3,
        subUserId: null,
        eventId: 4849,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 28).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 9,
            title: 'developers',
            slugId: 'AAAAqNofp2Q',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1694,
        roomId: 9,
        userId: 9,
        subUserId: null,
        eventId: 4848,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 28).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 9,
            title: 'developers',
            slugId: 'AAAAqNofp2Q',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1693,
        roomId: 9,
        userId: 1,
        subUserId: null,
        eventId: 4847,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 28).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 9,
            title: 'developers',
            slugId: 'AAAAqNofp2Q',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1692,
        roomId: 9,
        userId: 1,
        subUserId: null,
        eventId: 4846,
        workspaceId: 6,
        action: 'CHAT_REACTION_ADDED',
        date: subDays(new Date(), 28).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 9,
            title: 'developers',
            slugId: 'AAAAqNofp2Q',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1691,
        roomId: 9,
        userId: 7,
        subUserId: null,
        eventId: 4845,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 28).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 9,
            title: 'developers',
            slugId: 'AAAAqNofp2Q',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1690,
        roomId: 4,
        userId: 11,
        subUserId: 10,
        eventId: 4844,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 28).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1689,
        roomId: 4,
        userId: 11,
        subUserId: 10,
        eventId: 4843,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 28).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1688,
        roomId: 4,
        userId: 10,
        subUserId: null,
        eventId: 4842,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 28).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1687,
        roomId: 4,
        userId: 11,
        subUserId: 10,
        eventId: 4841,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 28).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1686,
        roomId: 4,
        userId: 10,
        subUserId: null,
        eventId: 4840,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 28).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1685,
        roomId: 4,
        userId: 10,
        subUserId: 11,
        eventId: 4839,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 28).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1684,
        roomId: 4,
        userId: 11,
        subUserId: null,
        eventId: 4838,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 28).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1683,
        roomId: 4,
        userId: 10,
        subUserId: 11,
        eventId: 4837,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 28).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1682,
        roomId: 4,
        userId: 11,
        subUserId: null,
        eventId: 4836,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 28).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1681,
        roomId: 4,
        userId: 10,
        subUserId: 11,
        eventId: 4835,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 28).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1680,
        roomId: 4,
        userId: 10,
        subUserId: 11,
        eventId: 4834,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 28).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1679,
        roomId: 4,
        userId: 11,
        subUserId: null,
        eventId: 4833,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 28).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1678,
        roomId: 4,
        userId: 11,
        subUserId: 10,
        eventId: 4832,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 28).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1677,
        roomId: 4,
        userId: 10,
        subUserId: null,
        eventId: 4831,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 28).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1676,
        roomId: 4,
        userId: 10,
        subUserId: null,
        eventId: 4830,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 28).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1675,
        roomId: 4,
        userId: 11,
        subUserId: 10,
        eventId: 4829,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 28).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1674,
        roomId: 4,
        userId: 10,
        subUserId: null,
        eventId: 4828,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 28).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1673,
        roomId: 4,
        userId: 10,
        subUserId: 11,
        eventId: 4827,
        workspaceId: 6,
        action: 'CHAT_REACTION_ADDED',
        date: subDays(new Date(), 28).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1672,
        roomId: 4,
        userId: 11,
        subUserId: 10,
        eventId: 4826,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 28).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1671,
        roomId: 4,
        userId: 10,
        subUserId: null,
        eventId: 4825,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 28).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1670,
        roomId: 4,
        userId: 10,
        subUserId: 11,
        eventId: 4824,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 28).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1669,
        roomId: 4,
        userId: 11,
        subUserId: null,
        eventId: 4823,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 28).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1668,
        roomId: 4,
        userId: 11,
        subUserId: 10,
        eventId: 4822,
        workspaceId: 6,
        action: 'CHAT_REACTION_ADDED',
        date: subDays(new Date(), 28).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1667,
        roomId: 5,
        userId: 11,
        subUserId: null,
        eventId: 4821,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 28).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 5,
            title: '[Cart2Cart] Journal Feedback',
            slugId: 'AAAA6AlE3c0',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1666,
        roomId: 5,
        userId: 11,
        subUserId: null,
        eventId: 4820,
        workspaceId: 6,
        action: 'CHAT_REACTION_ADDED',
        date: subDays(new Date(), 28).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 5,
            title: '[Cart2Cart] Journal Feedback',
            slugId: 'AAAA6AlE3c0',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1665,
        roomId: 5,
        userId: 9,
        subUserId: null,
        eventId: 4819,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 28).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 5,
            title: '[Cart2Cart] Journal Feedback',
            slugId: 'AAAA6AlE3c0',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1664,
        roomId: 4,
        userId: 10,
        subUserId: 11,
        eventId: 4793,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 28).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1663,
        roomId: 5,
        userId: 11,
        subUserId: null,
        eventId: 4792,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 28).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 5,
            title: '[Cart2Cart] Journal Feedback',
            slugId: 'AAAA6AlE3c0',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1662,
        roomId: 4,
        userId: 11,
        subUserId: null,
        eventId: 4791,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 28).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1661,
        roomId: 4,
        userId: 11,
        subUserId: 10,
        eventId: 4790,
        workspaceId: 6,
        action: 'CHAT_REACTION_ADDED',
        date: subDays(new Date(), 28).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1660,
        roomId: 4,
        userId: 11,
        subUserId: 10,
        eventId: 4789,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 28).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1659,
        roomId: 4,
        userId: 10,
        subUserId: null,
        eventId: 4788,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 28).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1658,
        roomId: 4,
        userId: 11,
        subUserId: 10,
        eventId: 4787,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 28).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1657,
        roomId: 4,
        userId: 10,
        subUserId: null,
        eventId: 4786,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 28).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1656,
        roomId: 4,
        userId: 10,
        subUserId: 11,
        eventId: 4785,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 28).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1655,
        roomId: 4,
        userId: 10,
        subUserId: 11,
        eventId: 4784,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 28).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1654,
        roomId: 4,
        userId: 10,
        subUserId: 11,
        eventId: 4783,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 28).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1653,
        roomId: 4,
        userId: 10,
        subUserId: 11,
        eventId: 4782,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 28).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1652,
        roomId: 4,
        userId: 11,
        subUserId: null,
        eventId: 4781,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 28).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1651,
        roomId: 4,
        userId: 11,
        subUserId: null,
        eventId: 4780,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 28).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1650,
        roomId: 4,
        userId: 10,
        subUserId: 11,
        eventId: 4779,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 28).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1649,
        roomId: 4,
        userId: 11,
        subUserId: null,
        eventId: 4778,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 28).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1648,
        roomId: 4,
        userId: 11,
        subUserId: 10,
        eventId: 4777,
        workspaceId: 6,
        action: 'CHAT_REACTION_ADDED',
        date: subDays(new Date(), 28).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1647,
        roomId: 4,
        userId: 10,
        subUserId: 11,
        eventId: 4776,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 28).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1646,
        roomId: 4,
        userId: 10,
        subUserId: 11,
        eventId: 4775,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 28).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1645,
        roomId: 4,
        userId: 11,
        subUserId: null,
        eventId: 4774,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 28).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1644,
        roomId: 4,
        userId: 11,
        subUserId: 10,
        eventId: 4773,
        workspaceId: 6,
        action: 'CHAT_REACTION_ADDED',
        date: subDays(new Date(), 28).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1643,
        roomId: 4,
        userId: 10,
        subUserId: 11,
        eventId: 4772,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 28).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1642,
        roomId: 4,
        userId: 11,
        subUserId: null,
        eventId: 4771,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 28).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1641,
        roomId: 4,
        userId: 10,
        subUserId: 11,
        eventId: 4770,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 28).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1640,
        roomId: 4,
        userId: 10,
        subUserId: 11,
        eventId: 4769,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 28).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1639,
        roomId: 4,
        userId: 11,
        subUserId: null,
        eventId: 4768,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 28).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1638,
        roomId: 4,
        userId: 11,
        subUserId: 10,
        eventId: 4767,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 28).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1637,
        roomId: 4,
        userId: 10,
        subUserId: null,
        eventId: 4766,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 28).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1636,
        roomId: 4,
        userId: 10,
        subUserId: 11,
        eventId: 4765,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 28).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1635,
        roomId: 4,
        userId: 11,
        subUserId: null,
        eventId: 4764,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 28).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1634,
        roomId: 4,
        userId: 10,
        subUserId: 11,
        eventId: 4763,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 28).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1633,
        roomId: 4,
        userId: 11,
        subUserId: null,
        eventId: 4762,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 28).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1632,
        roomId: 4,
        userId: 11,
        subUserId: 10,
        eventId: 4761,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 28).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1631,
        roomId: 4,
        userId: 10,
        subUserId: null,
        eventId: 4760,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 28).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1630,
        roomId: 4,
        userId: 11,
        subUserId: 10,
        eventId: 4759,
        workspaceId: 6,
        action: 'CHAT_REACTION_ADDED',
        date: subDays(new Date(), 28).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1629,
        roomId: 4,
        userId: 11,
        subUserId: 10,
        eventId: 4758,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 28).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1628,
        roomId: 4,
        userId: 10,
        subUserId: 11,
        eventId: 4757,
        workspaceId: 6,
        action: 'CHAT_REACTION_ADDED',
        date: subDays(new Date(), 28).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1627,
        roomId: 4,
        userId: 10,
        subUserId: null,
        eventId: 4756,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 28).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1626,
        roomId: 4,
        userId: 10,
        subUserId: 11,
        eventId: 4755,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 28).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1625,
        roomId: 4,
        userId: 11,
        subUserId: null,
        eventId: 4754,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 28).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1624,
        roomId: 4,
        userId: 10,
        subUserId: 11,
        eventId: 4753,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 28).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1623,
        roomId: 4,
        userId: 11,
        subUserId: null,
        eventId: 4752,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 28).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1622,
        roomId: 4,
        userId: 11,
        subUserId: 10,
        eventId: 4751,
        workspaceId: 6,
        action: 'CHAT_REACTION_ADDED',
        date: subDays(new Date(), 28).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1621,
        roomId: 4,
        userId: 11,
        subUserId: 10,
        eventId: 4750,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 28).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1620,
        roomId: 4,
        userId: 10,
        subUserId: null,
        eventId: 4749,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 28).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1619,
        roomId: 4,
        userId: 11,
        subUserId: 10,
        eventId: 4748,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 28).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1618,
        roomId: 4,
        userId: 10,
        subUserId: null,
        eventId: 4747,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 28).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1617,
        roomId: 4,
        userId: 10,
        subUserId: 11,
        eventId: 4746,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 28).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1616,
        roomId: 4,
        userId: 11,
        subUserId: null,
        eventId: 4745,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 28).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1615,
        roomId: 4,
        userId: 11,
        subUserId: 10,
        eventId: 4744,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 28).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1614,
        roomId: 4,
        userId: 10,
        subUserId: null,
        eventId: 4743,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 28).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1613,
        roomId: 4,
        userId: 11,
        subUserId: 10,
        eventId: 4742,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 28).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1612,
        roomId: 4,
        userId: 10,
        subUserId: null,
        eventId: 4741,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 28).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1611,
        roomId: 4,
        userId: 11,
        subUserId: 10,
        eventId: 4740,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 28).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1610,
        roomId: 4,
        userId: 10,
        subUserId: null,
        eventId: 4739,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 28).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1609,
        roomId: 4,
        userId: 10,
        subUserId: 11,
        eventId: 4738,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 28).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1608,
        roomId: 4,
        userId: 11,
        subUserId: null,
        eventId: 4737,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 28).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1607,
        roomId: 4,
        userId: 11,
        subUserId: 10,
        eventId: 4736,
        workspaceId: 6,
        action: 'CHAT_REACTION_ADDED',
        date: subDays(new Date(), 28).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1606,
        roomId: 5,
        userId: 11,
        subUserId: null,
        eventId: 4735,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 28).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 5,
            title: '[Cart2Cart] Journal Feedback',
            slugId: 'AAAA6AlE3c0',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1605,
        roomId: 5,
        userId: 11,
        subUserId: null,
        eventId: 4734,
        workspaceId: 6,
        action: 'CHAT_REACTION_ADDED',
        date: subDays(new Date(), 28).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 5,
            title: '[Cart2Cart] Journal Feedback',
            slugId: 'AAAA6AlE3c0',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1604,
        roomId: 4,
        userId: 10,
        subUserId: 11,
        eventId: 4733,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 28).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1603,
        roomId: 5,
        userId: 11,
        subUserId: null,
        eventId: 4732,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 28).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 5,
            title: '[Cart2Cart] Journal Feedback',
            slugId: 'AAAA6AlE3c0',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1602,
        roomId: 5,
        userId: 11,
        subUserId: null,
        eventId: 4731,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 28).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 5,
            title: '[Cart2Cart] Journal Feedback',
            slugId: 'AAAA6AlE3c0',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1601,
        roomId: 4,
        userId: 11,
        subUserId: null,
        eventId: 4730,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 28).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1600,
        roomId: 4,
        userId: 11,
        subUserId: 10,
        eventId: 4729,
        workspaceId: 6,
        action: 'CHAT_REACTION_ADDED',
        date: subDays(new Date(), 28).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1599,
        roomId: 4,
        userId: 11,
        subUserId: 10,
        eventId: 4728,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 28).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1598,
        roomId: 4,
        userId: 10,
        subUserId: null,
        eventId: 4727,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 28).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1597,
        roomId: 4,
        userId: 10,
        subUserId: 11,
        eventId: 4726,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 28).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1596,
        roomId: 4,
        userId: 11,
        subUserId: null,
        eventId: 4725,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 28).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1595,
        roomId: 4,
        userId: 11,
        subUserId: 10,
        eventId: 4724,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 28).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1594,
        roomId: 4,
        userId: 10,
        subUserId: null,
        eventId: 4723,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 28).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1593,
        roomId: 4,
        userId: 10,
        subUserId: 11,
        eventId: 4722,
        workspaceId: 6,
        action: 'CHAT_REACTION_ADDED',
        date: subDays(new Date(), 28).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1592,
        roomId: 4,
        userId: 11,
        subUserId: 10,
        eventId: 4721,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 28).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1591,
        roomId: 4,
        userId: 10,
        subUserId: null,
        eventId: 4720,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 28).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1590,
        roomId: 4,
        userId: 10,
        subUserId: 11,
        eventId: 4719,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 28).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1589,
        roomId: 4,
        userId: 11,
        subUserId: 10,
        eventId: 4718,
        workspaceId: 6,
        action: 'CHAT_REACTION_ADDED',
        date: subDays(new Date(), 28).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1588,
        roomId: 4,
        userId: 11,
        subUserId: null,
        eventId: 4717,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 28).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1587,
        roomId: 5,
        userId: 9,
        subUserId: null,
        eventId: 4716,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 27).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 5,
            title: '[Cart2Cart] Journal Feedback',
            slugId: 'AAAA6AlE3c0',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1586,
        roomId: 9,
        userId: 3,
        subUserId: null,
        eventId: 4715,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 27).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 9,
            title: 'developers',
            slugId: 'AAAAqNofp2Q',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1585,
        roomId: 9,
        userId: 1,
        subUserId: null,
        eventId: 4714,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 27).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 9,
            title: 'developers',
            slugId: 'AAAAqNofp2Q',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1584,
        roomId: 9,
        userId: 1,
        subUserId: null,
        eventId: 4713,
        workspaceId: 6,
        action: 'CHAT_REACTION_ADDED',
        date: subDays(new Date(), 27).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 9,
            title: 'developers',
            slugId: 'AAAAqNofp2Q',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1583,
        roomId: 9,
        userId: 7,
        subUserId: null,
        eventId: 4712,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 27).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 9,
            title: 'developers',
            slugId: 'AAAAqNofp2Q',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1582,
        roomId: 9,
        userId: 7,
        subUserId: null,
        eventId: 4711,
        workspaceId: 6,
        action: 'CHAT_REACTION_ADDED',
        date: subDays(new Date(), 27).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 9,
            title: 'developers',
            slugId: 'AAAAqNofp2Q',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1581,
        roomId: 9,
        userId: 9,
        subUserId: null,
        eventId: 4710,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 27).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 9,
            title: 'developers',
            slugId: 'AAAAqNofp2Q',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1580,
        roomId: 9,
        userId: 9,
        subUserId: null,
        eventId: 4709,
        workspaceId: 6,
        action: 'CHAT_REACTION_ADDED',
        date: subDays(new Date(), 27).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 9,
            title: 'developers',
            slugId: 'AAAAqNofp2Q',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1579,
        roomId: 9,
        userId: 3,
        subUserId: null,
        eventId: 4708,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 27).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 9,
            title: 'developers',
            slugId: 'AAAAqNofp2Q',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1578,
        roomId: 9,
        userId: 9,
        subUserId: null,
        eventId: 4707,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 27).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 9,
            title: 'developers',
            slugId: 'AAAAqNofp2Q',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1577,
        roomId: 9,
        userId: 7,
        subUserId: null,
        eventId: 4706,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 27).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 9,
            title: 'developers',
            slugId: 'AAAAqNofp2Q',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1576,
        roomId: 9,
        userId: 1,
        subUserId: null,
        eventId: 4705,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 27).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 9,
            title: 'developers',
            slugId: 'AAAAqNofp2Q',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1575,
        roomId: 9,
        userId: 3,
        subUserId: null,
        eventId: 4704,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 27).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 9,
            title: 'developers',
            slugId: 'AAAAqNofp2Q',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1574,
        roomId: 9,
        userId: 1,
        subUserId: null,
        eventId: 4703,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 27).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 9,
            title: 'developers',
            slugId: 'AAAAqNofp2Q',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1573,
        roomId: 9,
        userId: 9,
        subUserId: null,
        eventId: 4702,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 27).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 9,
            title: 'developers',
            slugId: 'AAAAqNofp2Q',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1572,
        roomId: 9,
        userId: 7,
        subUserId: null,
        eventId: 4701,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 27).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 9,
            title: 'developers',
            slugId: 'AAAAqNofp2Q',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1571,
        roomId: 4,
        userId: 11,
        subUserId: 10,
        eventId: 4700,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 27).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1570,
        roomId: 4,
        userId: 10,
        subUserId: null,
        eventId: 4699,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 27).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1569,
        roomId: 4,
        userId: 10,
        subUserId: 11,
        eventId: 4698,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 27).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1568,
        roomId: 4,
        userId: 11,
        subUserId: null,
        eventId: 4697,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 27).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1567,
        roomId: 4,
        userId: 11,
        subUserId: 10,
        eventId: 4696,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 27).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1566,
        roomId: 4,
        userId: 10,
        subUserId: null,
        eventId: 4695,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 27).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1565,
        roomId: 4,
        userId: 10,
        subUserId: 11,
        eventId: 4694,
        workspaceId: 6,
        action: 'CHAT_REACTION_ADDED',
        date: subDays(new Date(), 27).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1564,
        roomId: 5,
        userId: 11,
        subUserId: null,
        eventId: 4692,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 27).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 5,
            title: '[Cart2Cart] Journal Feedback',
            slugId: 'AAAA6AlE3c0',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1563,
        roomId: 5,
        userId: 11,
        subUserId: null,
        eventId: 4691,
        workspaceId: 6,
        action: 'CHAT_UNREAD_TIMESTAMP_UPDATED',
        date: subDays(new Date(), 27).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 5,
            title: '[Cart2Cart] Journal Feedback',
            slugId: 'AAAA6AlE3c0',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1562,
        roomId: 6,
        userId: 1,
        subUserId: 11,
        eventId: 4690,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 27).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1561,
        roomId: 6,
        userId: 1,
        subUserId: 11,
        eventId: 4689,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_EDITED',
        date: subDays(new Date(), 27).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1560,
        roomId: 6,
        userId: 11,
        subUserId: null,
        eventId: 4680,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 27).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1559,
        roomId: 6,
        userId: 11,
        subUserId: null,
        eventId: 4679,
        workspaceId: 6,
        action: 'CHAT_UNREAD_TIMESTAMP_UPDATED',
        date: subDays(new Date(), 27).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1558,
        roomId: 5,
        userId: 9,
        subUserId: null,
        eventId: 4678,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 27).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 5,
            title: '[Cart2Cart] Journal Feedback',
            slugId: 'AAAA6AlE3c0',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1556,
        roomId: 6,
        userId: 1,
        subUserId: 11,
        eventId: 4676,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 27).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1557,
        roomId: 6,
        userId: 1,
        subUserId: 11,
        eventId: 4677,
        workspaceId: 6,
        action: 'CHAT_ATTACHMENT_UPLOAD',
        date: subDays(new Date(), 27).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1554,
        roomId: 6,
        userId: 1,
        subUserId: 11,
        eventId: 4674,
        workspaceId: 6,
        action: 'CHAT_ATTACHMENT_UPLOAD',
        date: subDays(new Date(), 27).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1555,
        roomId: 6,
        userId: 1,
        subUserId: 11,
        eventId: 4675,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 27).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1553,
        roomId: 4,
        userId: 10,
        subUserId: 11,
        eventId: 4661,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 27).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1552,
        roomId: 4,
        userId: 11,
        subUserId: null,
        eventId: 4660,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 27).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1551,
        roomId: 4,
        userId: 11,
        subUserId: 10,
        eventId: 4659,
        workspaceId: 6,
        action: 'CHAT_REACTION_ADDED',
        date: subDays(new Date(), 27).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1550,
        roomId: 4,
        userId: 11,
        subUserId: 10,
        eventId: 4658,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 27).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1549,
        roomId: 4,
        userId: 10,
        subUserId: null,
        eventId: 4657,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 27).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1548,
        roomId: 4,
        userId: 10,
        subUserId: 11,
        eventId: 4656,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 27).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1547,
        roomId: 4,
        userId: 11,
        subUserId: null,
        eventId: 4655,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 27).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1546,
        roomId: 4,
        userId: 11,
        subUserId: 10,
        eventId: 4654,
        workspaceId: 6,
        action: 'CHAT_REACTION_ADDED',
        date: subDays(new Date(), 27).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1545,
        roomId: 4,
        userId: 10,
        subUserId: 11,
        eventId: 4653,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 27).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1544,
        roomId: 4,
        userId: 11,
        subUserId: null,
        eventId: 4652,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 27).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1543,
        roomId: 4,
        userId: 11,
        subUserId: 10,
        eventId: 4651,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 27).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1542,
        roomId: 4,
        userId: 10,
        subUserId: null,
        eventId: 4650,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 27).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1541,
        roomId: 4,
        userId: 10,
        subUserId: 11,
        eventId: 4649,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 27).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1540,
        roomId: 4,
        userId: 10,
        subUserId: 11,
        eventId: 4648,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 27).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1539,
        roomId: 4,
        userId: 11,
        subUserId: null,
        eventId: 4647,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 27).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1538,
        roomId: 4,
        userId: 11,
        subUserId: null,
        eventId: 4646,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 27).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1537,
        roomId: 4,
        userId: 10,
        subUserId: 11,
        eventId: 4645,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 27).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1536,
        roomId: 4,
        userId: 11,
        subUserId: null,
        eventId: 4644,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 27).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1535,
        roomId: 4,
        userId: 11,
        subUserId: 10,
        eventId: 4643,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 27).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1534,
        roomId: 4,
        userId: 10,
        subUserId: null,
        eventId: 4642,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 27).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1533,
        roomId: 4,
        userId: 10,
        subUserId: 11,
        eventId: 4641,
        workspaceId: 6,
        action: 'CHAT_REACTION_ADDED',
        date: subDays(new Date(), 27).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1532,
        roomId: 4,
        userId: 10,
        subUserId: null,
        eventId: 4640,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 27).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1531,
        roomId: 5,
        userId: 11,
        subUserId: null,
        eventId: 4639,
        workspaceId: 6,
        action: 'CHAT_UNREAD_TIMESTAMP_UPDATED',
        date: subDays(new Date(), 27).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 5,
            title: '[Cart2Cart] Journal Feedback',
            slugId: 'AAAA6AlE3c0',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1530,
        roomId: 5,
        userId: 11,
        subUserId: null,
        eventId: 4638,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 27).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 5,
            title: '[Cart2Cart] Journal Feedback',
            slugId: 'AAAA6AlE3c0',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1529,
        roomId: 6,
        userId: 11,
        subUserId: null,
        eventId: 4637,
        workspaceId: 6,
        action: 'CHAT_UNREAD_TIMESTAMP_UPDATED',
        date: subDays(new Date(), 27).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1528,
        roomId: 6,
        userId: 11,
        subUserId: null,
        eventId: 4636,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 27).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1527,
        roomId: 6,
        userId: 11,
        subUserId: 1,
        eventId: 4635,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 27).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1526,
        roomId: 6,
        userId: 11,
        subUserId: 1,
        eventId: 4634,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 27).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1525,
        roomId: 6,
        userId: 1,
        subUserId: null,
        eventId: 4633,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 27).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1524,
        roomId: 6,
        userId: 11,
        subUserId: 1,
        eventId: 4632,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 27).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1523,
        roomId: 6,
        userId: 1,
        subUserId: null,
        eventId: 4631,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 27).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1522,
        roomId: 6,
        userId: 11,
        subUserId: 1,
        eventId: 4630,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 27).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1521,
        roomId: 6,
        userId: 1,
        subUserId: null,
        eventId: 4629,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 27).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1520,
        roomId: 6,
        userId: 1,
        subUserId: 11,
        eventId: 4628,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 27).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1519,
        roomId: 6,
        userId: 11,
        subUserId: null,
        eventId: 4627,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 27).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1518,
        roomId: 6,
        userId: 11,
        subUserId: null,
        eventId: 4626,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 27).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1517,
        roomId: 6,
        userId: 11,
        subUserId: 1,
        eventId: 4625,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 27).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1516,
        roomId: 6,
        userId: 11,
        subUserId: 1,
        eventId: 4624,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 27).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1515,
        roomId: 6,
        userId: 11,
        subUserId: 1,
        eventId: 4623,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 27).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1514,
        roomId: 6,
        userId: 1,
        subUserId: null,
        eventId: 4622,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 27).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1512,
        roomId: 6,
        userId: 1,
        subUserId: 11,
        eventId: 4620,
        workspaceId: 6,
        action: 'CHAT_ATTACHMENT_UPLOAD',
        date: subDays(new Date(), 27).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1513,
        roomId: 6,
        userId: 1,
        subUserId: 11,
        eventId: 4621,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 27).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1511,
        roomId: 6,
        userId: 11,
        subUserId: null,
        eventId: 4619,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 27).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1510,
        roomId: 6,
        userId: 1,
        subUserId: 11,
        eventId: 4618,
        workspaceId: 6,
        action: 'CHAT_REACTION_ADDED',
        date: subDays(new Date(), 27).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1509,
        roomId: 3,
        userId: 11,
        subUserId: null,
        eventId: 4617,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 27).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1508,
        roomId: 3,
        userId: 9,
        subUserId: null,
        eventId: 4616,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 27).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1507,
        roomId: 3,
        userId: 11,
        subUserId: null,
        eventId: 4615,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 27).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1506,
        roomId: 3,
        userId: 11,
        subUserId: null,
        eventId: 4614,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 27).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1505,
        roomId: 3,
        userId: 11,
        subUserId: null,
        eventId: 4613,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 27).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1504,
        roomId: 3,
        userId: 11,
        subUserId: null,
        eventId: 4612,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 27).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1503,
        roomId: 3,
        userId: 11,
        subUserId: null,
        eventId: 4611,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 27).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1502,
        roomId: 3,
        userId: 11,
        subUserId: null,
        eventId: 4610,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 27).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1501,
        roomId: 3,
        userId: 11,
        subUserId: null,
        eventId: 4609,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 27).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1500,
        roomId: 3,
        userId: 11,
        subUserId: null,
        eventId: 4608,
        workspaceId: 6,
        action: 'CHAT_REACTION_ADDED',
        date: subDays(new Date(), 27).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1499,
        roomId: 3,
        userId: 11,
        subUserId: null,
        eventId: 4607,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 27).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1498,
        roomId: 3,
        userId: 11,
        subUserId: null,
        eventId: 4606,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 27).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1497,
        roomId: 3,
        userId: 11,
        subUserId: null,
        eventId: 4605,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 27).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1496,
        roomId: 3,
        userId: 11,
        subUserId: null,
        eventId: 4604,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 27).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1495,
        roomId: 3,
        userId: 11,
        subUserId: null,
        eventId: 4603,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 27).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1494,
        roomId: 9,
        userId: 3,
        subUserId: null,
        eventId: 4602,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 26).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 9,
            title: 'developers',
            slugId: 'AAAAqNofp2Q',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1493,
        roomId: 9,
        userId: 9,
        subUserId: null,
        eventId: 4601,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 26).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 9,
            title: 'developers',
            slugId: 'AAAAqNofp2Q',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1492,
        roomId: 9,
        userId: 1,
        subUserId: null,
        eventId: 4600,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 26).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 9,
            title: 'developers',
            slugId: 'AAAAqNofp2Q',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1491,
        roomId: 9,
        userId: 1,
        subUserId: null,
        eventId: 4599,
        workspaceId: 6,
        action: 'CHAT_REACTION_ADDED',
        date: subDays(new Date(), 26).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 9,
            title: 'developers',
            slugId: 'AAAAqNofp2Q',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1490,
        roomId: 9,
        userId: 7,
        subUserId: null,
        eventId: 4598,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 26).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 9,
            title: 'developers',
            slugId: 'AAAAqNofp2Q',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1488,
        roomId: 13,
        userId: 1,
        subUserId: 7,
        eventId: 4596,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 26).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 13,
            title: 'Default Chat',
            slugId: '7MN9dcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1489,
        roomId: 13,
        userId: 1,
        subUserId: 7,
        eventId: 4597,
        workspaceId: 6,
        action: 'CHAT_ATTACHMENT_UPLOAD',
        date: subDays(new Date(), 26).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 13,
            title: 'Default Chat',
            slugId: '7MN9dcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1487,
        roomId: 13,
        userId: 7,
        subUserId: null,
        eventId: 4595,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 26).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 13,
            title: 'Default Chat',
            slugId: '7MN9dcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1485,
        roomId: 13,
        userId: 7,
        subUserId: 1,
        eventId: 4593,
        workspaceId: 6,
        action: 'CHAT_ATTACHMENT_UPLOAD',
        date: subDays(new Date(), 26).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 13,
            title: 'Default Chat',
            slugId: '7MN9dcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1486,
        roomId: 13,
        userId: 7,
        subUserId: 1,
        eventId: 4594,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 26).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 13,
            title: 'Default Chat',
            slugId: '7MN9dcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1484,
        roomId: 13,
        userId: 1,
        subUserId: null,
        eventId: 4592,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 26).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 13,
            title: 'Default Chat',
            slugId: '7MN9dcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1483,
        roomId: 13,
        userId: 1,
        subUserId: 7,
        eventId: 4591,
        workspaceId: 6,
        action: 'CHAT_REACTION_ADDED',
        date: subDays(new Date(), 26).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 13,
            title: 'Default Chat',
            slugId: '7MN9dcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1482,
        roomId: 3,
        userId: 9,
        subUserId: null,
        eventId: 4589,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 26).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1481,
        roomId: 3,
        userId: 11,
        subUserId: null,
        eventId: 4587,
        workspaceId: 6,
        action: 'CHAT_REACTION_ADDED',
        date: subDays(new Date(), 26).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1480,
        roomId: 3,
        userId: 11,
        subUserId: null,
        eventId: 4586,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 26).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1479,
        roomId: 3,
        userId: 11,
        subUserId: null,
        eventId: 4585,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 26).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1478,
        roomId: 3,
        userId: 11,
        subUserId: null,
        eventId: 4584,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 26).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1477,
        roomId: 3,
        userId: 11,
        subUserId: null,
        eventId: 4583,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 26).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1476,
        roomId: 3,
        userId: 11,
        subUserId: null,
        eventId: 4582,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 26).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1475,
        roomId: 3,
        userId: 11,
        subUserId: null,
        eventId: 4581,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 26).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1474,
        roomId: 3,
        userId: 11,
        subUserId: null,
        eventId: 4580,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 26).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1473,
        roomId: 3,
        userId: 11,
        subUserId: null,
        eventId: 4579,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 26).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1472,
        roomId: 3,
        userId: 9,
        subUserId: null,
        eventId: 4573,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 26).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1471,
        roomId: 3,
        userId: 11,
        subUserId: null,
        eventId: 4523,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 26).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1470,
        roomId: 3,
        userId: 11,
        subUserId: null,
        eventId: 4522,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 26).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1469,
        roomId: 3,
        userId: 11,
        subUserId: null,
        eventId: 4521,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 26).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1468,
        roomId: 1,
        userId: 11,
        subUserId: 9,
        eventId: 4514,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 26).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1467,
        roomId: 3,
        userId: 11,
        subUserId: null,
        eventId: 4513,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 26).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1466,
        roomId: 1,
        userId: 9,
        subUserId: null,
        eventId: 4512,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 26).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1465,
        roomId: 1,
        userId: 9,
        subUserId: 11,
        eventId: 4511,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 26).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1464,
        roomId: 3,
        userId: 11,
        subUserId: null,
        eventId: 4510,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 26).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1463,
        roomId: 1,
        userId: 11,
        subUserId: null,
        eventId: 4509,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 26).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1462,
        roomId: 1,
        userId: 11,
        subUserId: 9,
        eventId: 4508,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 26).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1461,
        roomId: 1,
        userId: 9,
        subUserId: null,
        eventId: 4507,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 26).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1460,
        roomId: 3,
        userId: 9,
        subUserId: null,
        eventId: 4506,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 26).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1459,
        roomId: 3,
        userId: 11,
        subUserId: null,
        eventId: 4505,
        workspaceId: 6,
        action: 'CHAT_REACTION_ADDED',
        date: subDays(new Date(), 26).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1458,
        roomId: 3,
        userId: 11,
        subUserId: null,
        eventId: 4503,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 26).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1457,
        roomId: 3,
        userId: 9,
        subUserId: null,
        eventId: 4502,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 26).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1456,
        roomId: 3,
        userId: 11,
        subUserId: null,
        eventId: 4501,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1455,
        roomId: 3,
        userId: 11,
        subUserId: null,
        eventId: 4500,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1454,
        roomId: 3,
        userId: 9,
        subUserId: null,
        eventId: 4499,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1453,
        roomId: 3,
        userId: 11,
        subUserId: null,
        eventId: 4498,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1452,
        roomId: 3,
        userId: 9,
        subUserId: null,
        eventId: 4497,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1451,
        roomId: 4,
        userId: 11,
        subUserId: 10,
        eventId: 4496,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1450,
        roomId: 4,
        userId: 11,
        subUserId: 10,
        eventId: 4495,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1449,
        roomId: 3,
        userId: 9,
        subUserId: null,
        eventId: 4494,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1448,
        roomId: 4,
        userId: 11,
        subUserId: 10,
        eventId: 4493,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1447,
        roomId: 3,
        userId: 11,
        subUserId: null,
        eventId: 4492,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1446,
        roomId: 3,
        userId: 11,
        subUserId: null,
        eventId: 4491,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1445,
        roomId: 3,
        userId: 9,
        subUserId: null,
        eventId: 4490,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1444,
        roomId: 3,
        userId: 11,
        subUserId: null,
        eventId: 4489,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1443,
        roomId: 3,
        userId: 9,
        subUserId: null,
        eventId: 4488,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1442,
        roomId: 3,
        userId: 11,
        subUserId: null,
        eventId: 4487,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1441,
        roomId: 3,
        userId: 9,
        subUserId: null,
        eventId: 4486,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1440,
        roomId: 3,
        userId: 11,
        subUserId: null,
        eventId: 4485,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1439,
        roomId: 3,
        userId: 9,
        subUserId: null,
        eventId: 4484,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1438,
        roomId: 3,
        userId: 11,
        subUserId: null,
        eventId: 4483,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1437,
        roomId: 3,
        userId: 9,
        subUserId: null,
        eventId: 4482,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1436,
        roomId: 3,
        userId: 11,
        subUserId: null,
        eventId: 4481,
        workspaceId: 6,
        action: 'CHAT_REACTION_ADDED',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1435,
        roomId: 3,
        userId: 11,
        subUserId: null,
        eventId: 4480,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1434,
        roomId: 3,
        userId: 9,
        subUserId: null,
        eventId: 4479,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1433,
        roomId: 4,
        userId: 10,
        subUserId: null,
        eventId: 4478,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1432,
        roomId: 4,
        userId: 10,
        subUserId: 11,
        eventId: 4477,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1431,
        roomId: 4,
        userId: 11,
        subUserId: null,
        eventId: 4476,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1430,
        roomId: 4,
        userId: 11,
        subUserId: 10,
        eventId: 4475,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1429,
        roomId: 4,
        userId: 10,
        subUserId: null,
        eventId: 4474,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1428,
        roomId: 4,
        userId: 10,
        subUserId: 11,
        eventId: 4473,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1427,
        roomId: 4,
        userId: 11,
        subUserId: null,
        eventId: 4468,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1426,
        roomId: 16,
        userId: 7,
        subUserId: null,
        eventId: 4467,
        workspaceId: 6,
        action: 'CHAT_ROOM_CREATED',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 16,
            title: 'test space workalizer',
            slugId: 'AAQA-zyipws',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1425,
        roomId: 4,
        userId: 11,
        subUserId: 10,
        eventId: 4466,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1424,
        roomId: 4,
        userId: 10,
        subUserId: null,
        eventId: 4465,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1423,
        roomId: 4,
        userId: 10,
        subUserId: 11,
        eventId: 4464,
        workspaceId: 6,
        action: 'CHAT_REACTION_ADDED',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1422,
        roomId: 16,
        userId: 7,
        subUserId: null,
        eventId: 4463,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 16,
            title: 'test space workalizer',
            slugId: 'AAQA-zyipws',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1421,
        roomId: 3,
        userId: 11,
        subUserId: null,
        eventId: 4462,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1420,
        roomId: 3,
        userId: 9,
        subUserId: null,
        eventId: 4461,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1419,
        roomId: 3,
        userId: 11,
        subUserId: null,
        eventId: 4460,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1418,
        roomId: 3,
        userId: 11,
        subUserId: null,
        eventId: 4459,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1417,
        roomId: 3,
        userId: 9,
        subUserId: null,
        eventId: 4458,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1415,
        roomId: 3,
        userId: 11,
        subUserId: null,
        eventId: 4456,
        workspaceId: 6,
        action: 'CHAT_ATTACHMENT_UPLOAD',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1416,
        roomId: 3,
        userId: 11,
        subUserId: null,
        eventId: 4457,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1414,
        roomId: 3,
        userId: 9,
        subUserId: null,
        eventId: 4455,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1413,
        roomId: 3,
        userId: 11,
        subUserId: null,
        eventId: 4454,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1412,
        roomId: 3,
        userId: 11,
        subUserId: null,
        eventId: 4453,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1411,
        roomId: 3,
        userId: 11,
        subUserId: null,
        eventId: 4452,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1410,
        roomId: 3,
        userId: 11,
        subUserId: null,
        eventId: 4451,
        workspaceId: 6,
        action: 'CHAT_REACTION_ADDED',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1409,
        roomId: 3,
        userId: 9,
        subUserId: null,
        eventId: 4450,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1408,
        roomId: 9,
        userId: 3,
        subUserId: null,
        eventId: 4449,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 9,
            title: 'developers',
            slugId: 'AAAAqNofp2Q',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1407,
        roomId: 9,
        userId: 9,
        subUserId: null,
        eventId: 4448,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 9,
            title: 'developers',
            slugId: 'AAAAqNofp2Q',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1406,
        roomId: 9,
        userId: 1,
        subUserId: null,
        eventId: 4447,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 9,
            title: 'developers',
            slugId: 'AAAAqNofp2Q',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1405,
        roomId: 9,
        userId: 1,
        subUserId: null,
        eventId: 4446,
        workspaceId: 6,
        action: 'CHAT_REACTION_ADDED',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 9,
            title: 'developers',
            slugId: 'AAAAqNofp2Q',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1404,
        roomId: 3,
        userId: 11,
        subUserId: null,
        eventId: 4445,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1403,
        roomId: 3,
        userId: 9,
        subUserId: null,
        eventId: 4444,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1402,
        roomId: 3,
        userId: 11,
        subUserId: null,
        eventId: 4443,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1401,
        roomId: 3,
        userId: 9,
        subUserId: null,
        eventId: 4442,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1400,
        roomId: 3,
        userId: 9,
        subUserId: null,
        eventId: 4441,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1399,
        roomId: 3,
        userId: 11,
        subUserId: null,
        eventId: 4440,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1398,
        roomId: 3,
        userId: 11,
        subUserId: null,
        eventId: 4439,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1397,
        roomId: 3,
        userId: 9,
        subUserId: null,
        eventId: 4438,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1396,
        roomId: 3,
        userId: 11,
        subUserId: null,
        eventId: 4437,
        workspaceId: 6,
        action: 'CHAT_REACTION_ADDED',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1395,
        roomId: 1,
        userId: 11,
        subUserId: 9,
        eventId: 4436,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1394,
        roomId: 1,
        userId: 11,
        subUserId: 9,
        eventId: 4435,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1393,
        roomId: 1,
        userId: 9,
        subUserId: null,
        eventId: 4434,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1392,
        roomId: 1,
        userId: 9,
        subUserId: 11,
        eventId: 4433,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1391,
        roomId: 1,
        userId: 11,
        subUserId: null,
        eventId: 4432,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1390,
        roomId: 1,
        userId: 11,
        subUserId: 9,
        eventId: 4431,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1389,
        roomId: 1,
        userId: 11,
        subUserId: 9,
        eventId: 4430,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1388,
        roomId: 1,
        userId: 9,
        subUserId: null,
        eventId: 4429,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1387,
        roomId: 1,
        userId: 9,
        subUserId: 11,
        eventId: 4428,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1386,
        roomId: 1,
        userId: 11,
        subUserId: null,
        eventId: 4427,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1385,
        roomId: 1,
        userId: 11,
        subUserId: 9,
        eventId: 4426,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1384,
        roomId: 1,
        userId: 9,
        subUserId: null,
        eventId: 4425,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1383,
        roomId: 1,
        userId: 11,
        subUserId: 9,
        eventId: 4424,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1382,
        roomId: 1,
        userId: 9,
        subUserId: null,
        eventId: 4423,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1381,
        roomId: 1,
        userId: 11,
        subUserId: 9,
        eventId: 4422,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1380,
        roomId: 1,
        userId: 9,
        subUserId: null,
        eventId: 4421,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1378,
        roomId: 1,
        userId: 9,
        subUserId: 11,
        eventId: 4419,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1379,
        roomId: 1,
        userId: 9,
        subUserId: 11,
        eventId: 4420,
        workspaceId: 6,
        action: 'CHAT_ATTACHMENT_UPLOAD',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1377,
        roomId: 1,
        userId: 11,
        subUserId: null,
        eventId: 4418,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1376,
        roomId: 1,
        userId: 11,
        subUserId: 9,
        eventId: 4417,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1375,
        roomId: 1,
        userId: 9,
        subUserId: null,
        eventId: 4416,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1374,
        roomId: 1,
        userId: 11,
        subUserId: 9,
        eventId: 4415,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1373,
        roomId: 1,
        userId: 9,
        subUserId: null,
        eventId: 4414,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1372,
        roomId: 1,
        userId: 9,
        subUserId: 11,
        eventId: 4413,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1371,
        roomId: 1,
        userId: 11,
        subUserId: null,
        eventId: 4412,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1370,
        roomId: 1,
        userId: 11,
        subUserId: 9,
        eventId: 4411,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1369,
        roomId: 1,
        userId: 9,
        subUserId: null,
        eventId: 4410,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1368,
        roomId: 1,
        userId: 11,
        subUserId: 9,
        eventId: 4402,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1367,
        roomId: 1,
        userId: 9,
        subUserId: null,
        eventId: 4401,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1366,
        roomId: 1,
        userId: 9,
        subUserId: 11,
        eventId: 4400,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1365,
        roomId: 3,
        userId: 11,
        subUserId: null,
        eventId: 4399,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1364,
        roomId: 3,
        userId: 9,
        subUserId: null,
        eventId: 4398,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1363,
        roomId: 1,
        userId: 11,
        subUserId: null,
        eventId: 4397,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1362,
        roomId: 1,
        userId: 11,
        subUserId: 9,
        eventId: 4396,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1361,
        roomId: 1,
        userId: 11,
        subUserId: 9,
        eventId: 4395,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1360,
        roomId: 1,
        userId: 9,
        subUserId: null,
        eventId: 4394,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1359,
        roomId: 1,
        userId: 9,
        subUserId: 11,
        eventId: 4393,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1358,
        roomId: 3,
        userId: 9,
        subUserId: null,
        eventId: 4392,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1357,
        roomId: 3,
        userId: 11,
        subUserId: null,
        eventId: 4391,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1356,
        roomId: 3,
        userId: 11,
        subUserId: null,
        eventId: 4390,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1355,
        roomId: 3,
        userId: 9,
        subUserId: null,
        eventId: 4389,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1354,
        roomId: 1,
        userId: 11,
        subUserId: null,
        eventId: 4388,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1353,
        roomId: 1,
        userId: 11,
        subUserId: 9,
        eventId: 4387,
        workspaceId: 6,
        action: 'CHAT_REACTION_ADDED',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1352,
        roomId: 1,
        userId: 11,
        subUserId: 9,
        eventId: 4386,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1351,
        roomId: 1,
        userId: 11,
        subUserId: 9,
        eventId: 4385,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1350,
        roomId: 3,
        userId: 9,
        subUserId: null,
        eventId: 4384,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1349,
        roomId: 1,
        userId: 11,
        subUserId: 9,
        eventId: 4383,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1348,
        roomId: 1,
        userId: 9,
        subUserId: null,
        eventId: 4382,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1347,
        roomId: 3,
        userId: 11,
        subUserId: null,
        eventId: 4381,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1346,
        roomId: 3,
        userId: 11,
        subUserId: null,
        eventId: 4380,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1345,
        roomId: 1,
        userId: 9,
        subUserId: 11,
        eventId: 4379,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1344,
        roomId: 3,
        userId: 9,
        subUserId: null,
        eventId: 4378,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1343,
        roomId: 3,
        userId: 11,
        subUserId: null,
        eventId: 4377,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1342,
        roomId: 1,
        userId: 11,
        subUserId: null,
        eventId: 4376,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1341,
        roomId: 1,
        userId: 11,
        subUserId: 9,
        eventId: 4375,
        workspaceId: 6,
        action: 'CHAT_REACTION_ADDED',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1340,
        roomId: 3,
        userId: 9,
        subUserId: null,
        eventId: 4374,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1339,
        roomId: 1,
        userId: 11,
        subUserId: 9,
        eventId: 4373,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1338,
        roomId: 1,
        userId: 11,
        subUserId: 9,
        eventId: 4372,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1337,
        roomId: 3,
        userId: 9,
        subUserId: null,
        eventId: 4371,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1336,
        roomId: 3,
        userId: 11,
        subUserId: null,
        eventId: 4370,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1335,
        roomId: 1,
        userId: 9,
        subUserId: null,
        eventId: 4369,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1334,
        roomId: 1,
        userId: 9,
        subUserId: 11,
        eventId: 4368,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1333,
        roomId: 3,
        userId: 11,
        subUserId: null,
        eventId: 4367,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1332,
        roomId: 1,
        userId: 11,
        subUserId: null,
        eventId: 4366,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1331,
        roomId: 1,
        userId: 11,
        subUserId: 9,
        eventId: 4365,
        workspaceId: 6,
        action: 'CHAT_REACTION_ADDED',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1330,
        roomId: 1,
        userId: 9,
        subUserId: 11,
        eventId: 4364,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1329,
        roomId: 1,
        userId: 11,
        subUserId: null,
        eventId: 4363,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1328,
        roomId: 1,
        userId: 11,
        subUserId: 9,
        eventId: 4362,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1327,
        roomId: 1,
        userId: 9,
        subUserId: null,
        eventId: 4361,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1326,
        roomId: 1,
        userId: 11,
        subUserId: 9,
        eventId: 4360,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1325,
        roomId: 1,
        userId: 9,
        subUserId: null,
        eventId: 4359,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1324,
        roomId: 1,
        userId: 11,
        subUserId: 9,
        eventId: 4358,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1323,
        roomId: 1,
        userId: 9,
        subUserId: null,
        eventId: 4357,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1322,
        roomId: 1,
        userId: 9,
        subUserId: 11,
        eventId: 4356,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1321,
        roomId: 1,
        userId: 11,
        subUserId: null,
        eventId: 4355,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1320,
        roomId: 1,
        userId: 9,
        subUserId: 11,
        eventId: 4354,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_EDITED',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1319,
        roomId: 1,
        userId: 11,
        subUserId: 9,
        eventId: 4353,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1318,
        roomId: 1,
        userId: 9,
        subUserId: null,
        eventId: 4352,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1317,
        roomId: 1,
        userId: 11,
        subUserId: 9,
        eventId: 4351,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1316,
        roomId: 1,
        userId: 9,
        subUserId: null,
        eventId: 4350,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1315,
        roomId: 1,
        userId: 11,
        subUserId: 9,
        eventId: 4349,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1314,
        roomId: 1,
        userId: 9,
        subUserId: null,
        eventId: 4348,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1313,
        roomId: 1,
        userId: 9,
        subUserId: 11,
        eventId: 4347,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1312,
        roomId: 1,
        userId: 11,
        subUserId: null,
        eventId: 4346,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1311,
        roomId: 1,
        userId: 9,
        subUserId: 11,
        eventId: 4345,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1310,
        roomId: 1,
        userId: 11,
        subUserId: null,
        eventId: 4344,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1309,
        roomId: 3,
        userId: 9,
        subUserId: null,
        eventId: 4343,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1308,
        roomId: 1,
        userId: 11,
        subUserId: 9,
        eventId: 4342,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1307,
        roomId: 1,
        userId: 9,
        subUserId: null,
        eventId: 4341,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1306,
        roomId: 1,
        userId: 11,
        subUserId: 9,
        eventId: 4340,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1305,
        roomId: 1,
        userId: 9,
        subUserId: null,
        eventId: 4339,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1304,
        roomId: 1,
        userId: 9,
        subUserId: 11,
        eventId: 4338,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1303,
        roomId: 1,
        userId: 9,
        subUserId: 11,
        eventId: 4337,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1302,
        roomId: 1,
        userId: 11,
        subUserId: null,
        eventId: 4336,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1301,
        roomId: 1,
        userId: 11,
        subUserId: 9,
        eventId: 4335,
        workspaceId: 6,
        action: 'CHAT_REACTION_ADDED',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1300,
        roomId: 1,
        userId: 11,
        subUserId: 9,
        eventId: 4334,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1299,
        roomId: 1,
        userId: 11,
        subUserId: 9,
        eventId: 4333,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1298,
        roomId: 1,
        userId: 9,
        subUserId: null,
        eventId: 4332,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1297,
        roomId: 1,
        userId: 11,
        subUserId: 9,
        eventId: 4331,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1296,
        roomId: 1,
        userId: 9,
        subUserId: null,
        eventId: 4330,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1295,
        roomId: 1,
        userId: 11,
        subUserId: 9,
        eventId: 4329,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1294,
        roomId: 1,
        userId: 9,
        subUserId: null,
        eventId: 4328,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1293,
        roomId: 1,
        userId: 11,
        subUserId: 9,
        eventId: 4327,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_EDITED',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1292,
        roomId: 1,
        userId: 9,
        subUserId: 11,
        eventId: 4326,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1291,
        roomId: 1,
        userId: 11,
        subUserId: null,
        eventId: 4325,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1290,
        roomId: 1,
        userId: 11,
        subUserId: 9,
        eventId: 4324,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1289,
        roomId: 1,
        userId: 9,
        subUserId: null,
        eventId: 4323,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1288,
        roomId: 1,
        userId: 11,
        subUserId: 9,
        eventId: 4322,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1287,
        roomId: 1,
        userId: 9,
        subUserId: null,
        eventId: 4321,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1286,
        roomId: 1,
        userId: 9,
        subUserId: 11,
        eventId: 4320,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1285,
        roomId: 1,
        userId: 9,
        subUserId: 11,
        eventId: 4319,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1284,
        roomId: 1,
        userId: 11,
        subUserId: null,
        eventId: 4318,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1283,
        roomId: 1,
        userId: 11,
        subUserId: 9,
        eventId: 4317,
        workspaceId: 6,
        action: 'CHAT_REACTION_ADDED',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1282,
        roomId: 1,
        userId: 11,
        subUserId: 9,
        eventId: 4316,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1281,
        roomId: 1,
        userId: 9,
        subUserId: null,
        eventId: 4315,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1280,
        roomId: 1,
        userId: 9,
        subUserId: 11,
        eventId: 4314,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1279,
        roomId: 1,
        userId: 11,
        subUserId: null,
        eventId: 4313,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1278,
        roomId: 1,
        userId: 11,
        subUserId: 9,
        eventId: 4312,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1277,
        roomId: 1,
        userId: 9,
        subUserId: null,
        eventId: 4311,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1276,
        roomId: 1,
        userId: 11,
        subUserId: 9,
        eventId: 4310,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1275,
        roomId: 1,
        userId: 9,
        subUserId: null,
        eventId: 4309,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1274,
        roomId: 1,
        userId: 9,
        subUserId: 11,
        eventId: 4308,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1273,
        roomId: 1,
        userId: 11,
        subUserId: null,
        eventId: 4307,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1272,
        roomId: 1,
        userId: 11,
        subUserId: 9,
        eventId: 4306,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1271,
        roomId: 1,
        userId: 11,
        subUserId: 9,
        eventId: 4305,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1270,
        roomId: 1,
        userId: 9,
        subUserId: null,
        eventId: 4304,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1269,
        roomId: 1,
        userId: 9,
        subUserId: 11,
        eventId: 4303,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1268,
        roomId: 1,
        userId: 9,
        subUserId: 11,
        eventId: 4302,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1267,
        roomId: 1,
        userId: 11,
        subUserId: null,
        eventId: 4301,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1266,
        roomId: 1,
        userId: 11,
        subUserId: 9,
        eventId: 4300,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1265,
        roomId: 1,
        userId: 9,
        subUserId: null,
        eventId: 4299,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1264,
        roomId: 1,
        userId: 11,
        subUserId: 9,
        eventId: 4298,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1263,
        roomId: 1,
        userId: 9,
        subUserId: null,
        eventId: 4297,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1262,
        roomId: 1,
        userId: 11,
        subUserId: 9,
        eventId: 4296,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1261,
        roomId: 1,
        userId: 11,
        subUserId: 9,
        eventId: 4295,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1260,
        roomId: 1,
        userId: 11,
        subUserId: 9,
        eventId: 4294,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1259,
        roomId: 1,
        userId: 9,
        subUserId: null,
        eventId: 4293,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1258,
        roomId: 1,
        userId: 9,
        subUserId: 11,
        eventId: 4292,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1257,
        roomId: 1,
        userId: 11,
        subUserId: null,
        eventId: 4291,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1256,
        roomId: 1,
        userId: 11,
        subUserId: 9,
        eventId: 4290,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1255,
        roomId: 1,
        userId: 9,
        subUserId: null,
        eventId: 4289,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1254,
        roomId: 1,
        userId: 9,
        subUserId: 11,
        eventId: 4288,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1253,
        roomId: 1,
        userId: 11,
        subUserId: null,
        eventId: 4287,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1252,
        roomId: 1,
        userId: 9,
        subUserId: 11,
        eventId: 4286,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1251,
        roomId: 1,
        userId: 11,
        subUserId: null,
        eventId: 4285,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1250,
        roomId: 1,
        userId: 9,
        subUserId: 11,
        eventId: 4284,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_EDITED',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1249,
        roomId: 1,
        userId: 9,
        subUserId: 11,
        eventId: 4283,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1248,
        roomId: 1,
        userId: 11,
        subUserId: null,
        eventId: 4282,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1247,
        roomId: 1,
        userId: 9,
        subUserId: 11,
        eventId: 4281,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1246,
        roomId: 1,
        userId: 11,
        subUserId: null,
        eventId: 4280,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1245,
        roomId: 1,
        userId: 9,
        subUserId: 11,
        eventId: 4277,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_EDITED',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1244,
        roomId: 1,
        userId: 9,
        subUserId: 11,
        eventId: 4276,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_EDITED',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1243,
        roomId: 1,
        userId: 11,
        subUserId: 9,
        eventId: 4273,
        workspaceId: 6,
        action: 'CHAT_REACTION_ADDED',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1242,
        roomId: 1,
        userId: 11,
        subUserId: 9,
        eventId: 4271,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1241,
        roomId: 1,
        userId: 11,
        subUserId: 9,
        eventId: 4270,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1240,
        roomId: 1,
        userId: 11,
        subUserId: 9,
        eventId: 4269,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1239,
        roomId: 1,
        userId: 9,
        subUserId: null,
        eventId: 4268,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1238,
        roomId: 1,
        userId: 9,
        subUserId: 11,
        eventId: 4255,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1237,
        roomId: 1,
        userId: 11,
        subUserId: null,
        eventId: 4254,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1236,
        roomId: 1,
        userId: 9,
        subUserId: 11,
        eventId: 4253,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1235,
        roomId: 1,
        userId: 11,
        subUserId: null,
        eventId: 4252,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1234,
        roomId: 1,
        userId: 11,
        subUserId: 9,
        eventId: 4251,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1233,
        roomId: 1,
        userId: 11,
        subUserId: 9,
        eventId: 4250,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1232,
        roomId: 1,
        userId: 11,
        subUserId: 9,
        eventId: 4249,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1231,
        roomId: 1,
        userId: 9,
        subUserId: null,
        eventId: 4248,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1230,
        roomId: 1,
        userId: 9,
        subUserId: 11,
        eventId: 4247,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1229,
        roomId: 1,
        userId: 9,
        subUserId: 11,
        eventId: 4246,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1228,
        roomId: 1,
        userId: 11,
        subUserId: null,
        eventId: 4245,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1227,
        roomId: 1,
        userId: 11,
        subUserId: 9,
        eventId: 4244,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1226,
        roomId: 1,
        userId: 9,
        subUserId: null,
        eventId: 4243,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1225,
        roomId: 1,
        userId: 11,
        subUserId: 9,
        eventId: 4242,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1224,
        roomId: 1,
        userId: 9,
        subUserId: null,
        eventId: 4241,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1223,
        roomId: 1,
        userId: 11,
        subUserId: 9,
        eventId: 4240,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1222,
        roomId: 1,
        userId: 9,
        subUserId: null,
        eventId: 4239,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1221,
        roomId: 1,
        userId: 9,
        subUserId: 11,
        eventId: 4238,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1220,
        roomId: 1,
        userId: 11,
        subUserId: null,
        eventId: 4237,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1219,
        roomId: 1,
        userId: 9,
        subUserId: 11,
        eventId: 4236,
        workspaceId: 6,
        action: 'CHAT_REACTION_ADDED',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1218,
        roomId: 1,
        userId: 11,
        subUserId: 9,
        eventId: 4235,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1217,
        roomId: 1,
        userId: 9,
        subUserId: null,
        eventId: 4234,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1216,
        roomId: 1,
        userId: 11,
        subUserId: 9,
        eventId: 4233,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1215,
        roomId: 1,
        userId: 9,
        subUserId: null,
        eventId: 4232,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1214,
        roomId: 1,
        userId: 9,
        subUserId: 11,
        eventId: 4231,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1213,
        roomId: 1,
        userId: 11,
        subUserId: null,
        eventId: 4230,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1212,
        roomId: 1,
        userId: 11,
        subUserId: 9,
        eventId: 4229,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1211,
        roomId: 1,
        userId: 9,
        subUserId: null,
        eventId: 4228,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1210,
        roomId: 1,
        userId: 9,
        subUserId: 11,
        eventId: 4227,
        workspaceId: 6,
        action: 'CHAT_REACTION_ADDED',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1209,
        roomId: 1,
        userId: 11,
        subUserId: 9,
        eventId: 4226,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1208,
        roomId: 1,
        userId: 9,
        subUserId: null,
        eventId: 4225,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1207,
        roomId: 1,
        userId: 9,
        subUserId: 11,
        eventId: 4224,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1206,
        roomId: 1,
        userId: 9,
        subUserId: 11,
        eventId: 4223,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1205,
        roomId: 1,
        userId: 11,
        subUserId: null,
        eventId: 4222,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1204,
        roomId: 1,
        userId: 11,
        subUserId: 9,
        eventId: 4221,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1203,
        roomId: 1,
        userId: 9,
        subUserId: null,
        eventId: 4220,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1202,
        roomId: 1,
        userId: 11,
        subUserId: 9,
        eventId: 4219,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1201,
        roomId: 1,
        userId: 9,
        subUserId: null,
        eventId: 4218,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1200,
        roomId: 1,
        userId: 9,
        subUserId: 11,
        eventId: 4217,
        workspaceId: 6,
        action: 'CHAT_REACTION_ADDED',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1199,
        roomId: 1,
        userId: 11,
        subUserId: 9,
        eventId: 4216,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1198,
        roomId: 1,
        userId: 9,
        subUserId: null,
        eventId: 4215,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1197,
        roomId: 1,
        userId: 11,
        subUserId: 9,
        eventId: 4214,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1196,
        roomId: 1,
        userId: 9,
        subUserId: null,
        eventId: 4213,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1195,
        roomId: 1,
        userId: 9,
        subUserId: 11,
        eventId: 4212,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1194,
        roomId: 1,
        userId: 11,
        subUserId: null,
        eventId: 4211,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1193,
        roomId: 1,
        userId: 11,
        subUserId: 9,
        eventId: 4210,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1192,
        roomId: 1,
        userId: 9,
        subUserId: null,
        eventId: 4209,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1191,
        roomId: 1,
        userId: 9,
        subUserId: 11,
        eventId: 4208,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1190,
        roomId: 1,
        userId: 11,
        subUserId: null,
        eventId: 4207,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1189,
        roomId: 1,
        userId: 11,
        subUserId: 9,
        eventId: 4206,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1188,
        roomId: 1,
        userId: 9,
        subUserId: null,
        eventId: 4205,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1187,
        roomId: 1,
        userId: 9,
        subUserId: 11,
        eventId: 4204,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1186,
        roomId: 1,
        userId: 11,
        subUserId: null,
        eventId: 4203,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1185,
        roomId: 1,
        userId: 11,
        subUserId: 9,
        eventId: 4202,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1184,
        roomId: 1,
        userId: 11,
        subUserId: 9,
        eventId: 4201,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1183,
        roomId: 1,
        userId: 9,
        subUserId: null,
        eventId: 4200,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1182,
        roomId: 1,
        userId: 9,
        subUserId: 11,
        eventId: 4199,
        workspaceId: 6,
        action: 'CHAT_REACTION_ADDED',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1181,
        roomId: 1,
        userId: 11,
        subUserId: 9,
        eventId: 4198,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1180,
        roomId: 1,
        userId: 11,
        subUserId: 9,
        eventId: 4197,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1179,
        roomId: 1,
        userId: 9,
        subUserId: 11,
        eventId: 4196,
        workspaceId: 6,
        action: 'CHAT_REACTION_ADDED',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1178,
        roomId: 1,
        userId: 9,
        subUserId: null,
        eventId: 4195,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1177,
        roomId: 9,
        userId: 7,
        subUserId: null,
        eventId: 4166,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 9,
            title: 'developers',
            slugId: 'AAAAqNofp2Q',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1176,
        roomId: 3,
        userId: 11,
        subUserId: null,
        eventId: 4165,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1175,
        roomId: 3,
        userId: 11,
        subUserId: null,
        eventId: 4164,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1174,
        roomId: 3,
        userId: 11,
        subUserId: null,
        eventId: 4163,
        workspaceId: 6,
        action: 'CHAT_UNREAD_TIMESTAMP_UPDATED',
        date: subDays(new Date(), 25).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1173,
        roomId: 3,
        userId: 9,
        subUserId: null,
        eventId: 4139,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 24).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1172,
        roomId: 3,
        userId: 11,
        subUserId: null,
        eventId: 4126,
        workspaceId: 6,
        action: 'CHAT_UNREAD_TIMESTAMP_UPDATED',
        date: subDays(new Date(), 24).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1171,
        roomId: 6,
        userId: 11,
        subUserId: 1,
        eventId: 4075,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 23).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1170,
        roomId: 6,
        userId: 1,
        subUserId: null,
        eventId: 4074,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 23).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1169,
        roomId: 6,
        userId: 1,
        subUserId: 11,
        eventId: 4073,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 23).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1168,
        roomId: 6,
        userId: 11,
        subUserId: null,
        eventId: 4072,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 23).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1167,
        roomId: 6,
        userId: 1,
        subUserId: 11,
        eventId: 4071,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 23).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1166,
        roomId: 6,
        userId: 11,
        subUserId: null,
        eventId: 4070,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 23).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1165,
        roomId: 6,
        userId: 11,
        subUserId: 1,
        eventId: 4069,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 23).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1164,
        roomId: 6,
        userId: 1,
        subUserId: null,
        eventId: 4068,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 23).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1163,
        roomId: 6,
        userId: 11,
        subUserId: 1,
        eventId: 4067,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 23).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1162,
        roomId: 6,
        userId: 1,
        subUserId: null,
        eventId: 4066,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 23).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1161,
        roomId: 6,
        userId: 1,
        subUserId: 11,
        eventId: 4065,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 23).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1160,
        roomId: 6,
        userId: 11,
        subUserId: null,
        eventId: 4064,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 23).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1159,
        roomId: 6,
        userId: 11,
        subUserId: 1,
        eventId: 4063,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 23).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1158,
        roomId: 6,
        userId: 1,
        subUserId: null,
        eventId: 4062,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 23).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1157,
        roomId: 6,
        userId: 1,
        subUserId: 11,
        eventId: 4061,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 23).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1156,
        roomId: 6,
        userId: 11,
        subUserId: null,
        eventId: 4060,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 23).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1155,
        roomId: 6,
        userId: 11,
        subUserId: 1,
        eventId: 4059,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 23).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1154,
        roomId: 6,
        userId: 1,
        subUserId: null,
        eventId: 4058,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 23).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1153,
        roomId: 6,
        userId: 1,
        subUserId: 11,
        eventId: 4057,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 23).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1152,
        roomId: 6,
        userId: 11,
        subUserId: null,
        eventId: 4056,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 23).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1151,
        roomId: 6,
        userId: 11,
        subUserId: 1,
        eventId: 4055,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 23).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1150,
        roomId: 6,
        userId: 1,
        subUserId: null,
        eventId: 4054,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 23).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1149,
        roomId: 6,
        userId: 1,
        subUserId: 11,
        eventId: 4053,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 23).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1148,
        roomId: 4,
        userId: 10,
        subUserId: 11,
        eventId: 4052,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 23).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1147,
        roomId: 4,
        userId: 11,
        subUserId: null,
        eventId: 4051,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 23).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1146,
        roomId: 4,
        userId: 11,
        subUserId: 10,
        eventId: 4050,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 23).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1145,
        roomId: 4,
        userId: 10,
        subUserId: null,
        eventId: 4049,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 23).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1144,
        roomId: 6,
        userId: 1,
        subUserId: 11,
        eventId: 4048,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 23).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1143,
        roomId: 6,
        userId: 11,
        subUserId: null,
        eventId: 4047,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 23).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1142,
        roomId: 6,
        userId: 11,
        subUserId: 1,
        eventId: 4046,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 23).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1141,
        roomId: 6,
        userId: 11,
        subUserId: 1,
        eventId: 4045,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 23).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1140,
        roomId: 6,
        userId: 1,
        subUserId: null,
        eventId: 4044,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 23).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1139,
        roomId: 6,
        userId: 1,
        subUserId: 11,
        eventId: 4043,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 23).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1138,
        roomId: 6,
        userId: 1,
        subUserId: 11,
        eventId: 4042,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 23).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1137,
        roomId: 6,
        userId: 11,
        subUserId: null,
        eventId: 4041,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 23).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1135,
        roomId: 6,
        userId: 11,
        subUserId: 1,
        eventId: 4039,
        workspaceId: 6,
        action: 'CHAT_ATTACHMENT_UPLOAD',
        date: subDays(new Date(), 23).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1136,
        roomId: 6,
        userId: 11,
        subUserId: 1,
        eventId: 4040,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 23).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1134,
        roomId: 6,
        userId: 11,
        subUserId: 1,
        eventId: 4038,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 23).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1133,
        roomId: 6,
        userId: 11,
        subUserId: 1,
        eventId: 4037,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 23).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1132,
        roomId: 6,
        userId: 1,
        subUserId: null,
        eventId: 4036,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 23).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1130,
        roomId: 6,
        userId: 1,
        subUserId: 11,
        eventId: 4034,
        workspaceId: 6,
        action: 'CHAT_ATTACHMENT_UPLOAD',
        date: subDays(new Date(), 23).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1131,
        roomId: 6,
        userId: 1,
        subUserId: 11,
        eventId: 4035,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 23).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1129,
        roomId: 4,
        userId: 10,
        subUserId: 11,
        eventId: 4033,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 23).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1128,
        roomId: 6,
        userId: 11,
        subUserId: null,
        eventId: 4032,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 23).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1127,
        roomId: 4,
        userId: 10,
        subUserId: 11,
        eventId: 4031,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 23).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1126,
        roomId: 6,
        userId: 11,
        subUserId: 1,
        eventId: 4030,
        workspaceId: 6,
        action: 'CHAT_REACTION_ADDED',
        date: subDays(new Date(), 23).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1125,
        roomId: 4,
        userId: 11,
        subUserId: null,
        eventId: 4029,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 23).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1124,
        roomId: 4,
        userId: 11,
        subUserId: 10,
        eventId: 4028,
        workspaceId: 6,
        action: 'CHAT_REACTION_ADDED',
        date: subDays(new Date(), 23).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1123,
        roomId: 3,
        userId: 11,
        subUserId: null,
        eventId: 3999,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 23).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1122,
        roomId: 3,
        userId: 9,
        subUserId: null,
        eventId: 3998,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 23).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1121,
        roomId: 15,
        userId: 11,
        subUserId: 8,
        eventId: 3997,
        workspaceId: 6,
        action: 'CHAT_ADD_ROOM_MEMBER',
        date: subDays(new Date(), 23).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 15,
            title: '',
            slugId: 'nhHp-8AAAAE',
            workspaceId: 6,
            type: 'UNKNOWN',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1119,
        roomId: 15,
        userId: 11,
        subUserId: 8,
        eventId: 3995,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 23).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 15,
            title: '',
            slugId: 'nhHp-8AAAAE',
            workspaceId: 6,
            type: 'UNKNOWN',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1120,
        roomId: 15,
        userId: 11,
        subUserId: 8,
        eventId: 3996,
        workspaceId: 6,
        action: 'CHAT_DIRECT_MESSAGE_STARTED',
        date: subDays(new Date(), 23).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 15,
            title: '',
            slugId: 'nhHp-8AAAAE',
            workspaceId: 6,
            type: 'UNKNOWN',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1118,
        roomId: 15,
        userId: 11,
        subUserId: 8,
        eventId: 3994,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_EDITED',
        date: subDays(new Date(), 23).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 15,
            title: '',
            slugId: 'nhHp-8AAAAE',
            workspaceId: 6,
            type: 'UNKNOWN',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1117,
        roomId: 4,
        userId: 10,
        subUserId: 11,
        eventId: 3984,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 23).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1116,
        roomId: 4,
        userId: 10,
        subUserId: 11,
        eventId: 3983,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 23).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1115,
        roomId: 4,
        userId: 11,
        subUserId: null,
        eventId: 3982,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 23).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1114,
        roomId: 4,
        userId: 11,
        subUserId: 10,
        eventId: 3981,
        workspaceId: 6,
        action: 'CHAT_REACTION_ADDED',
        date: subDays(new Date(), 23).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1113,
        roomId: 4,
        userId: 11,
        subUserId: 10,
        eventId: 3980,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 23).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1112,
        roomId: 4,
        userId: 10,
        subUserId: null,
        eventId: 3979,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 23).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1111,
        roomId: 4,
        userId: 11,
        subUserId: 10,
        eventId: 3978,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 23).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1110,
        roomId: 4,
        userId: 10,
        subUserId: 11,
        eventId: 3977,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 23).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1109,
        roomId: 4,
        userId: 10,
        subUserId: null,
        eventId: 3976,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 23).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1108,
        roomId: 4,
        userId: 11,
        subUserId: null,
        eventId: 3975,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 23).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1107,
        roomId: 4,
        userId: 10,
        subUserId: 11,
        eventId: 3974,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 23).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1106,
        roomId: 4,
        userId: 11,
        subUserId: null,
        eventId: 3973,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 23).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1105,
        roomId: 4,
        userId: 11,
        subUserId: 10,
        eventId: 3972,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 23).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1104,
        roomId: 4,
        userId: 10,
        subUserId: null,
        eventId: 3971,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 23).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1102,
        roomId: 3,
        userId: 11,
        subUserId: null,
        eventId: 3960,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 22).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1103,
        roomId: 3,
        userId: 11,
        subUserId: null,
        eventId: 3961,
        workspaceId: 6,
        action: 'CHAT_ATTACHMENT_UPLOAD',
        date: subDays(new Date(), 22).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1101,
        roomId: 3,
        userId: 11,
        subUserId: null,
        eventId: 3959,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 22).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1100,
        roomId: 3,
        userId: 9,
        subUserId: null,
        eventId: 3958,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 22).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1099,
        roomId: 3,
        userId: 9,
        subUserId: null,
        eventId: 3957,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 22).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1098,
        roomId: 1,
        userId: 9,
        subUserId: 11,
        eventId: 3956,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 22).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1097,
        roomId: 1,
        userId: 9,
        subUserId: 11,
        eventId: 3955,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 22).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1096,
        roomId: 1,
        userId: 11,
        subUserId: null,
        eventId: 3954,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 22).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1095,
        roomId: 1,
        userId: 11,
        subUserId: 9,
        eventId: 3953,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 22).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1094,
        roomId: 1,
        userId: 9,
        subUserId: null,
        eventId: 3952,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 22).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1093,
        roomId: 1,
        userId: 9,
        subUserId: 11,
        eventId: 3951,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 22).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1092,
        roomId: 1,
        userId: 11,
        subUserId: null,
        eventId: 3950,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 22).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1091,
        roomId: 1,
        userId: 9,
        subUserId: 11,
        eventId: 3949,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 22).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1090,
        roomId: 1,
        userId: 11,
        subUserId: null,
        eventId: 3948,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 22).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1089,
        roomId: 1,
        userId: 11,
        subUserId: 9,
        eventId: 3947,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 22).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1088,
        roomId: 1,
        userId: 9,
        subUserId: null,
        eventId: 3946,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 22).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1087,
        roomId: 1,
        userId: 9,
        subUserId: 11,
        eventId: 3945,
        workspaceId: 6,
        action: 'CHAT_REACTION_ADDED',
        date: subDays(new Date(), 22).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1086,
        roomId: 1,
        userId: 11,
        subUserId: 9,
        eventId: 3944,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 22).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1085,
        roomId: 1,
        userId: 9,
        subUserId: null,
        eventId: 3943,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 22).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1084,
        roomId: 1,
        userId: 9,
        subUserId: 11,
        eventId: 3942,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 22).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1083,
        roomId: 1,
        userId: 11,
        subUserId: 9,
        eventId: 3941,
        workspaceId: 6,
        action: 'CHAT_REACTION_ADDED',
        date: subDays(new Date(), 22).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1082,
        roomId: 1,
        userId: 11,
        subUserId: null,
        eventId: 3940,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 22).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1081,
        roomId: 1,
        userId: 11,
        subUserId: 9,
        eventId: 3939,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 22).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1080,
        roomId: 1,
        userId: 11,
        subUserId: 9,
        eventId: 3938,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 22).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1079,
        roomId: 1,
        userId: 11,
        subUserId: 9,
        eventId: 3937,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 22).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1078,
        roomId: 1,
        userId: 9,
        subUserId: null,
        eventId: 3936,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 22).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1077,
        roomId: 1,
        userId: 9,
        subUserId: 11,
        eventId: 3935,
        workspaceId: 6,
        action: 'CHAT_REACTION_ADDED',
        date: subDays(new Date(), 22).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1076,
        roomId: 8,
        userId: 3,
        subUserId: 11,
        eventId: 3933,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 22).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 8,
            title: 'Default Chat',
            slugId: 'm0JbdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1075,
        roomId: 8,
        userId: 11,
        subUserId: null,
        eventId: 3932,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 22).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 8,
            title: 'Default Chat',
            slugId: 'm0JbdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1074,
        roomId: 8,
        userId: 11,
        subUserId: 3,
        eventId: 3931,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 22).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 8,
            title: 'Default Chat',
            slugId: 'm0JbdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1073,
        roomId: 8,
        userId: 11,
        subUserId: 3,
        eventId: 3930,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 22).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 8,
            title: 'Default Chat',
            slugId: 'm0JbdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1072,
        roomId: 8,
        userId: 3,
        subUserId: null,
        eventId: 3929,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 22).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 8,
            title: 'Default Chat',
            slugId: 'm0JbdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1071,
        roomId: 5,
        userId: 11,
        subUserId: null,
        eventId: 3893,
        workspaceId: 6,
        action: 'CHAT_REACTION_ADDED',
        date: subDays(new Date(), 22).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 5,
            title: '[Cart2Cart] Journal Feedback',
            slugId: 'AAAA6AlE3c0',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1070,
        roomId: 5,
        userId: 11,
        subUserId: null,
        eventId: 3892,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 22).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 5,
            title: '[Cart2Cart] Journal Feedback',
            slugId: 'AAAA6AlE3c0',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1069,
        roomId: 5,
        userId: 9,
        subUserId: null,
        eventId: 3891,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 22).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 5,
            title: '[Cart2Cart] Journal Feedback',
            slugId: 'AAAA6AlE3c0',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1068,
        roomId: 5,
        userId: 9,
        subUserId: null,
        eventId: 3890,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 22).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 5,
            title: '[Cart2Cart] Journal Feedback',
            slugId: 'AAAA6AlE3c0',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1067,
        roomId: 3,
        userId: 11,
        subUserId: null,
        eventId: 3889,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 22).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1066,
        roomId: 3,
        userId: 9,
        subUserId: null,
        eventId: 3888,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 22).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1065,
        roomId: 3,
        userId: 11,
        subUserId: null,
        eventId: 3887,
        workspaceId: 6,
        action: 'CHAT_REACTION_ADDED',
        date: subDays(new Date(), 22).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1064,
        roomId: 3,
        userId: 11,
        subUserId: null,
        eventId: 3886,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 22).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1063,
        roomId: 3,
        userId: 9,
        subUserId: null,
        eventId: 3885,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 22).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1062,
        roomId: 3,
        userId: 9,
        subUserId: null,
        eventId: 3884,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 22).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1061,
        roomId: 3,
        userId: 11,
        subUserId: null,
        eventId: 3883,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 22).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1059,
        roomId: 13,
        userId: 7,
        subUserId: 1,
        eventId: 3863,
        workspaceId: 6,
        action: 'CHAT_ATTACHMENT_UPLOAD',
        date: subDays(new Date(), 21).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 13,
            title: 'Default Chat',
            slugId: '7MN9dcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1060,
        roomId: 13,
        userId: 7,
        subUserId: 1,
        eventId: 3864,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 21).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 13,
            title: 'Default Chat',
            slugId: '7MN9dcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1058,
        roomId: 13,
        userId: 1,
        subUserId: null,
        eventId: 3862,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 21).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 13,
            title: 'Default Chat',
            slugId: '7MN9dcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1057,
        roomId: 13,
        userId: 1,
        subUserId: 7,
        eventId: 3861,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 21).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 13,
            title: 'Default Chat',
            slugId: '7MN9dcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1056,
        roomId: 13,
        userId: 7,
        subUserId: null,
        eventId: 3860,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 21).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 13,
            title: 'Default Chat',
            slugId: '7MN9dcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1055,
        roomId: 13,
        userId: 7,
        subUserId: 1,
        eventId: 3859,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 21).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 13,
            title: 'Default Chat',
            slugId: '7MN9dcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1054,
        roomId: 13,
        userId: 1,
        subUserId: null,
        eventId: 3857,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 21).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 13,
            title: 'Default Chat',
            slugId: '7MN9dcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1053,
        roomId: 13,
        userId: 1,
        subUserId: null,
        eventId: 3855,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 21).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 13,
            title: 'Default Chat',
            slugId: '7MN9dcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1052,
        roomId: 9,
        userId: 3,
        subUserId: null,
        eventId: 3853,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 21).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 9,
            title: 'developers',
            slugId: 'AAAAqNofp2Q',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1051,
        roomId: 9,
        userId: 9,
        subUserId: null,
        eventId: 3851,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 21).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 9,
            title: 'developers',
            slugId: 'AAAAqNofp2Q',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1050,
        roomId: 9,
        userId: 1,
        subUserId: null,
        eventId: 3850,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 21).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 9,
            title: 'developers',
            slugId: 'AAAAqNofp2Q',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1049,
        roomId: 9,
        userId: 1,
        subUserId: null,
        eventId: 3849,
        workspaceId: 6,
        action: 'CHAT_REACTION_ADDED',
        date: subDays(new Date(), 21).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 9,
            title: 'developers',
            slugId: 'AAAAqNofp2Q',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1048,
        roomId: 9,
        userId: 7,
        subUserId: null,
        eventId: 3650,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 21).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 9,
            title: 'developers',
            slugId: 'AAAAqNofp2Q',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1047,
        roomId: 3,
        userId: 9,
        subUserId: null,
        eventId: 3639,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 21).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1046,
        roomId: 3,
        userId: 9,
        subUserId: null,
        eventId: 3638,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 21).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1045,
        roomId: 3,
        userId: 11,
        subUserId: null,
        eventId: 3637,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 20).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1044,
        roomId: 3,
        userId: 11,
        subUserId: null,
        eventId: 3636,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 20).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1043,
        roomId: 3,
        userId: 9,
        subUserId: null,
        eventId: 3635,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 20).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1042,
        roomId: 3,
        userId: 9,
        subUserId: null,
        eventId: 3634,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 20).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1041,
        roomId: 3,
        userId: 9,
        subUserId: null,
        eventId: 3633,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 20).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1040,
        roomId: 3,
        userId: 11,
        subUserId: null,
        eventId: 3632,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 20).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1039,
        roomId: 3,
        userId: 11,
        subUserId: null,
        eventId: 3631,
        workspaceId: 6,
        action: 'CHAT_REACTION_ADDED',
        date: subDays(new Date(), 20).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1038,
        roomId: 3,
        userId: 11,
        subUserId: null,
        eventId: 3630,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 20).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1037,
        roomId: 3,
        userId: 9,
        subUserId: null,
        eventId: 3629,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 20).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1036,
        roomId: 3,
        userId: 11,
        subUserId: null,
        eventId: 3628,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 20).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1035,
        roomId: 3,
        userId: 9,
        subUserId: null,
        eventId: 3627,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 20).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1034,
        roomId: 3,
        userId: 9,
        subUserId: null,
        eventId: 3626,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 20).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1033,
        roomId: 3,
        userId: 9,
        subUserId: null,
        eventId: 3625,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 20).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1032,
        roomId: 3,
        userId: 11,
        subUserId: null,
        eventId: 3624,
        workspaceId: 6,
        action: 'CHAT_REACTION_ADDED',
        date: subDays(new Date(), 20).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1031,
        roomId: 3,
        userId: 11,
        subUserId: null,
        eventId: 3623,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 20).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1030,
        roomId: 3,
        userId: 9,
        subUserId: null,
        eventId: 3622,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 20).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1028,
        roomId: 6,
        userId: 11,
        subUserId: 1,
        eventId: 3620,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 20).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1029,
        roomId: 6,
        userId: 11,
        subUserId: 1,
        eventId: 3621,
        workspaceId: 6,
        action: 'CHAT_ATTACHMENT_UPLOAD',
        date: subDays(new Date(), 20).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1027,
        roomId: 6,
        userId: 11,
        subUserId: 1,
        eventId: 3619,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 20).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1026,
        roomId: 6,
        userId: 1,
        subUserId: null,
        eventId: 3618,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 20).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1025,
        roomId: 6,
        userId: 1,
        subUserId: 11,
        eventId: 3617,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 20).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1024,
        roomId: 6,
        userId: 11,
        subUserId: null,
        eventId: 3616,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 20).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1023,
        roomId: 6,
        userId: 1,
        subUserId: 11,
        eventId: 3615,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 20).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1022,
        roomId: 6,
        userId: 11,
        subUserId: null,
        eventId: 3568,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 20).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1021,
        roomId: 5,
        userId: 9,
        subUserId: null,
        eventId: 3566,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 20).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 5,
            title: '[Cart2Cart] Journal Feedback',
            slugId: 'AAAA6AlE3c0',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1020,
        roomId: 5,
        userId: 11,
        subUserId: null,
        eventId: 3565,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 20).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 5,
            title: '[Cart2Cart] Journal Feedback',
            slugId: 'AAAA6AlE3c0',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1019,
        roomId: 5,
        userId: 11,
        subUserId: null,
        eventId: 3564,
        workspaceId: 6,
        action: 'CHAT_REACTION_ADDED',
        date: subDays(new Date(), 20).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 5,
            title: '[Cart2Cart] Journal Feedback',
            slugId: 'AAAA6AlE3c0',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1018,
        roomId: 5,
        userId: 11,
        subUserId: null,
        eventId: 3563,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 20).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 5,
            title: '[Cart2Cart] Journal Feedback',
            slugId: 'AAAA6AlE3c0',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1017,
        roomId: 5,
        userId: 9,
        subUserId: null,
        eventId: 3562,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 20).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 5,
            title: '[Cart2Cart] Journal Feedback',
            slugId: 'AAAA6AlE3c0',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1016,
        roomId: 5,
        userId: 9,
        subUserId: null,
        eventId: 3561,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 20).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 5,
            title: '[Cart2Cart] Journal Feedback',
            slugId: 'AAAA6AlE3c0',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1015,
        roomId: 3,
        userId: 9,
        subUserId: null,
        eventId: 3530,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 20).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1014,
        roomId: 3,
        userId: 11,
        subUserId: null,
        eventId: 3529,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 20).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1013,
        roomId: 3,
        userId: 11,
        subUserId: null,
        eventId: 3528,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 20).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1012,
        roomId: 3,
        userId: 11,
        subUserId: null,
        eventId: 3527,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 20).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1011,
        roomId: 3,
        userId: 9,
        subUserId: null,
        eventId: 3526,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 20).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1010,
        roomId: 3,
        userId: 11,
        subUserId: null,
        eventId: 3525,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 20).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1009,
        roomId: 3,
        userId: 9,
        subUserId: null,
        eventId: 3524,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 20).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1008,
        roomId: 3,
        userId: 11,
        subUserId: null,
        eventId: 3523,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 20).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1007,
        roomId: 3,
        userId: 11,
        subUserId: null,
        eventId: 3522,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 20).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1006,
        roomId: 4,
        userId: 11,
        subUserId: 10,
        eventId: 3521,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 20).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1005,
        roomId: 4,
        userId: 11,
        subUserId: 10,
        eventId: 3520,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 20).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1004,
        roomId: 3,
        userId: 11,
        subUserId: null,
        eventId: 3519,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 20).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1003,
        roomId: 3,
        userId: 11,
        subUserId: null,
        eventId: 3518,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 20).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1002,
        roomId: 5,
        userId: 9,
        subUserId: null,
        eventId: 3456,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 20).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 5,
            title: '[Cart2Cart] Journal Feedback',
            slugId: 'AAAA6AlE3c0',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1001,
        roomId: 5,
        userId: 9,
        subUserId: null,
        eventId: 3455,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 20).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 5,
            title: '[Cart2Cart] Journal Feedback',
            slugId: 'AAAA6AlE3c0',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1000,
        roomId: 5,
        userId: 9,
        subUserId: null,
        eventId: 3454,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 20).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 5,
            title: '[Cart2Cart] Journal Feedback',
            slugId: 'AAAA6AlE3c0',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 999,
        roomId: 9,
        userId: 1,
        subUserId: null,
        eventId: 3453,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 20).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 9,
            title: 'developers',
            slugId: 'AAAAqNofp2Q',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 998,
        roomId: 9,
        userId: 9,
        subUserId: null,
        eventId: 3452,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 20).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 9,
            title: 'developers',
            slugId: 'AAAAqNofp2Q',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 997,
        roomId: 9,
        userId: 7,
        subUserId: null,
        eventId: 3451,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 20).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 9,
            title: 'developers',
            slugId: 'AAAAqNofp2Q',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 996,
        roomId: 9,
        userId: 7,
        subUserId: null,
        eventId: 3450,
        workspaceId: 6,
        action: 'CHAT_REACTION_ADDED',
        date: subDays(new Date(), 20).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 9,
            title: 'developers',
            slugId: 'AAAAqNofp2Q',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 995,
        roomId: 3,
        userId: 9,
        subUserId: null,
        eventId: 3279,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 19).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 994,
        roomId: 3,
        userId: 11,
        subUserId: null,
        eventId: 3277,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 19).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 993,
        roomId: 3,
        userId: 11,
        subUserId: null,
        eventId: 3275,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 19).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 992,
        roomId: 3,
        userId: 9,
        subUserId: null,
        eventId: 3273,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 19).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 991,
        roomId: 5,
        userId: 11,
        subUserId: null,
        eventId: 3271,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 19).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 5,
            title: '[Cart2Cart] Journal Feedback',
            slugId: 'AAAA6AlE3c0',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 990,
        roomId: 5,
        userId: 11,
        subUserId: null,
        eventId: 3269,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 19).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 5,
            title: '[Cart2Cart] Journal Feedback',
            slugId: 'AAAA6AlE3c0',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 989,
        roomId: 5,
        userId: 11,
        subUserId: null,
        eventId: 3267,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 19).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 5,
            title: '[Cart2Cart] Journal Feedback',
            slugId: 'AAAA6AlE3c0',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 988,
        roomId: 3,
        userId: 9,
        subUserId: null,
        eventId: 3266,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 19).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 987,
        roomId: 3,
        userId: 9,
        subUserId: null,
        eventId: 3264,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 19).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 986,
        roomId: 5,
        userId: 11,
        subUserId: null,
        eventId: 3262,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 19).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 5,
            title: '[Cart2Cart] Journal Feedback',
            slugId: 'AAAA6AlE3c0',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 985,
        roomId: 3,
        userId: 11,
        subUserId: null,
        eventId: 3260,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 19).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 984,
        roomId: 3,
        userId: 11,
        subUserId: null,
        eventId: 3258,
        workspaceId: 6,
        action: 'CHAT_REACTION_ADDED',
        date: subDays(new Date(), 19).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 983,
        roomId: 3,
        userId: 11,
        subUserId: null,
        eventId: 3256,
        workspaceId: 6,
        action: 'CHAT_REACTION_ADDED',
        date: subDays(new Date(), 19).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 982,
        roomId: 3,
        userId: 11,
        subUserId: null,
        eventId: 3254,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 19).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 981,
        roomId: 3,
        userId: 9,
        subUserId: null,
        eventId: 3252,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 19).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 980,
        roomId: 3,
        userId: 11,
        subUserId: null,
        eventId: 3250,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 19).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 979,
        roomId: 3,
        userId: 9,
        subUserId: null,
        eventId: 3248,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 19).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 978,
        roomId: 3,
        userId: 9,
        subUserId: null,
        eventId: 3246,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 19).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 977,
        roomId: 3,
        userId: 9,
        subUserId: null,
        eventId: 3244,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 19).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 976,
        roomId: 3,
        userId: 11,
        subUserId: null,
        eventId: 3242,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 19).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 975,
        roomId: 3,
        userId: 11,
        subUserId: null,
        eventId: 3240,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 19).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 974,
        roomId: 3,
        userId: 9,
        subUserId: null,
        eventId: 3238,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 19).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 973,
        roomId: 3,
        userId: 11,
        subUserId: null,
        eventId: 3236,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 19).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 972,
        roomId: 3,
        userId: 9,
        subUserId: null,
        eventId: 3234,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 19).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 971,
        roomId: 3,
        userId: 9,
        subUserId: null,
        eventId: 3233,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 19).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 970,
        roomId: 3,
        userId: 11,
        subUserId: null,
        eventId: 3231,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 19).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 969,
        roomId: 3,
        userId: 11,
        subUserId: null,
        eventId: 3229,
        workspaceId: 6,
        action: 'CHAT_REACTION_ADDED',
        date: subDays(new Date(), 19).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 968,
        roomId: 3,
        userId: 9,
        subUserId: null,
        eventId: 3227,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 19).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 967,
        roomId: 3,
        userId: 9,
        subUserId: null,
        eventId: 3035,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 19).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 966,
        roomId: 3,
        userId: 9,
        subUserId: null,
        eventId: 3033,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 19).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 965,
        roomId: 3,
        userId: 9,
        subUserId: null,
        eventId: 3031,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 19).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 964,
        roomId: 3,
        userId: 9,
        subUserId: null,
        eventId: 2941,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 19).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 963,
        roomId: 3,
        userId: 9,
        subUserId: null,
        eventId: 2940,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_EDITED',
        date: subDays(new Date(), 19).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 962,
        roomId: 3,
        userId: 9,
        subUserId: null,
        eventId: 2939,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 19).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 961,
        roomId: 3,
        userId: 11,
        subUserId: null,
        eventId: 2938,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 19).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 960,
        roomId: 3,
        userId: 11,
        subUserId: null,
        eventId: 2937,
        workspaceId: 6,
        action: 'CHAT_REACTION_ADDED',
        date: subDays(new Date(), 19).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 959,
        roomId: 9,
        userId: 3,
        subUserId: null,
        eventId: 2936,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 19).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 9,
            title: 'developers',
            slugId: 'AAAAqNofp2Q',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 958,
        roomId: 9,
        userId: 3,
        subUserId: null,
        eventId: 2935,
        workspaceId: 6,
        action: 'CHAT_REACTION_ADDED',
        date: subDays(new Date(), 19).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 9,
            title: 'developers',
            slugId: 'AAAAqNofp2Q',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 957,
        roomId: 4,
        userId: 10,
        subUserId: null,
        eventId: 2934,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 19).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 956,
        roomId: 4,
        userId: 10,
        subUserId: 11,
        eventId: 2933,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 19).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 955,
        roomId: 4,
        userId: 11,
        subUserId: null,
        eventId: 2932,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 19).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 954,
        roomId: 4,
        userId: 11,
        subUserId: 10,
        eventId: 2931,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 19).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 953,
        roomId: 4,
        userId: 10,
        subUserId: null,
        eventId: 2930,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 19).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 952,
        roomId: 4,
        userId: 10,
        subUserId: 11,
        eventId: 2929,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 19).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 951,
        roomId: 4,
        userId: 10,
        subUserId: 11,
        eventId: 2928,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 19).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 950,
        roomId: 4,
        userId: 11,
        subUserId: null,
        eventId: 2927,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 19).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 949,
        roomId: 4,
        userId: 11,
        subUserId: 10,
        eventId: 2926,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 19).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 948,
        roomId: 4,
        userId: 10,
        subUserId: null,
        eventId: 2925,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 19).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 947,
        roomId: 4,
        userId: 10,
        subUserId: 11,
        eventId: 2924,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 19).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 946,
        roomId: 4,
        userId: 11,
        subUserId: null,
        eventId: 2923,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 19).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 945,
        roomId: 4,
        userId: 11,
        subUserId: 10,
        eventId: 2922,
        workspaceId: 6,
        action: 'CHAT_REACTION_ADDED',
        date: subDays(new Date(), 19).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 944,
        roomId: 4,
        userId: 11,
        subUserId: 10,
        eventId: 2921,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 19).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 943,
        roomId: 4,
        userId: 11,
        subUserId: 10,
        eventId: 2920,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 19).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 942,
        roomId: 4,
        userId: 10,
        subUserId: null,
        eventId: 2919,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 19).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 941,
        roomId: 3,
        userId: 9,
        subUserId: null,
        eventId: 2913,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 19).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 940,
        roomId: 3,
        userId: 11,
        subUserId: null,
        eventId: 2912,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 19).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 939,
        roomId: 3,
        userId: 11,
        subUserId: null,
        eventId: 2911,
        workspaceId: 6,
        action: 'CHAT_REACTION_ADDED',
        date: subDays(new Date(), 19).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 938,
        roomId: 3,
        userId: 9,
        subUserId: null,
        eventId: 2910,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 19).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 937,
        roomId: 3,
        userId: 9,
        subUserId: null,
        eventId: 2909,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 19).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 936,
        roomId: 3,
        userId: 9,
        subUserId: null,
        eventId: 2908,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 19).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 935,
        roomId: 3,
        userId: 9,
        subUserId: null,
        eventId: 2907,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 19).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 934,
        roomId: 3,
        userId: 11,
        subUserId: null,
        eventId: 2906,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 19).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 933,
        roomId: 3,
        userId: 11,
        subUserId: null,
        eventId: 2905,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 19).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 932,
        roomId: 3,
        userId: 9,
        subUserId: null,
        eventId: 2904,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 19).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 931,
        roomId: 3,
        userId: 9,
        subUserId: null,
        eventId: 2856,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 19).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 930,
        roomId: 3,
        userId: 9,
        subUserId: null,
        eventId: 2855,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 19).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 929,
        roomId: 5,
        userId: 9,
        subUserId: null,
        eventId: 2853,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 18).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 5,
            title: '[Cart2Cart] Journal Feedback',
            slugId: 'AAAA6AlE3c0',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 928,
        roomId: 5,
        userId: 11,
        subUserId: null,
        eventId: 2852,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 18).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 5,
            title: '[Cart2Cart] Journal Feedback',
            slugId: 'AAAA6AlE3c0',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 927,
        roomId: 5,
        userId: 11,
        subUserId: null,
        eventId: 2841,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 18).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 5,
            title: '[Cart2Cart] Journal Feedback',
            slugId: 'AAAA6AlE3c0',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 926,
        roomId: 5,
        userId: 9,
        subUserId: null,
        eventId: 2840,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 18).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 5,
            title: '[Cart2Cart] Journal Feedback',
            slugId: 'AAAA6AlE3c0',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 925,
        roomId: 9,
        userId: 3,
        subUserId: null,
        eventId: 2834,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 18).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 9,
            title: 'developers',
            slugId: 'AAAAqNofp2Q',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 924,
        roomId: 9,
        userId: 9,
        subUserId: null,
        eventId: 2833,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 18).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 9,
            title: 'developers',
            slugId: 'AAAAqNofp2Q',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 923,
        roomId: 9,
        userId: 1,
        subUserId: null,
        eventId: 2832,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 18).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 9,
            title: 'developers',
            slugId: 'AAAAqNofp2Q',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 922,
        roomId: 9,
        userId: 1,
        subUserId: null,
        eventId: 2831,
        workspaceId: 6,
        action: 'CHAT_REACTION_ADDED',
        date: subDays(new Date(), 18).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 9,
            title: 'developers',
            slugId: 'AAAAqNofp2Q',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 921,
        roomId: 13,
        userId: 1,
        subUserId: 7,
        eventId: 2808,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 18).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 13,
            title: 'Default Chat',
            slugId: '7MN9dcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 920,
        roomId: 13,
        userId: 1,
        subUserId: 7,
        eventId: 2807,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 18).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 13,
            title: 'Default Chat',
            slugId: '7MN9dcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 919,
        roomId: 13,
        userId: 1,
        subUserId: 7,
        eventId: 2806,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 18).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 13,
            title: 'Default Chat',
            slugId: '7MN9dcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 918,
        roomId: 13,
        userId: 1,
        subUserId: 7,
        eventId: 2805,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 18).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 13,
            title: 'Default Chat',
            slugId: '7MN9dcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 917,
        roomId: 13,
        userId: 7,
        subUserId: null,
        eventId: 2804,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 18).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 13,
            title: 'Default Chat',
            slugId: '7MN9dcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 916,
        roomId: 13,
        userId: 1,
        subUserId: 7,
        eventId: 2803,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 18).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 13,
            title: 'Default Chat',
            slugId: '7MN9dcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 915,
        roomId: 13,
        userId: 7,
        subUserId: null,
        eventId: 2802,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 18).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 13,
            title: 'Default Chat',
            slugId: '7MN9dcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 914,
        roomId: 13,
        userId: 7,
        subUserId: 1,
        eventId: 2801,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 18).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 13,
            title: 'Default Chat',
            slugId: '7MN9dcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 913,
        roomId: 13,
        userId: 1,
        subUserId: null,
        eventId: 2800,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 18).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 13,
            title: 'Default Chat',
            slugId: '7MN9dcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 912,
        roomId: 13,
        userId: 1,
        subUserId: 7,
        eventId: 2799,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_EDITED',
        date: subDays(new Date(), 18).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 13,
            title: 'Default Chat',
            slugId: '7MN9dcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 911,
        roomId: 13,
        userId: 1,
        subUserId: 7,
        eventId: 2798,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 18).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 13,
            title: 'Default Chat',
            slugId: '7MN9dcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 910,
        roomId: 13,
        userId: 7,
        subUserId: null,
        eventId: 2797,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 18).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 13,
            title: 'Default Chat',
            slugId: '7MN9dcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 909,
        roomId: 13,
        userId: 7,
        subUserId: 1,
        eventId: 2796,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 18).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 13,
            title: 'Default Chat',
            slugId: '7MN9dcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 908,
        roomId: 13,
        userId: 1,
        subUserId: null,
        eventId: 2795,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 18).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 13,
            title: 'Default Chat',
            slugId: '7MN9dcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 907,
        roomId: 13,
        userId: 1,
        subUserId: 7,
        eventId: 2794,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 18).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 13,
            title: 'Default Chat',
            slugId: '7MN9dcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 906,
        roomId: 13,
        userId: 7,
        subUserId: null,
        eventId: 2793,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 18).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 13,
            title: 'Default Chat',
            slugId: '7MN9dcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 905,
        roomId: 13,
        userId: 1,
        subUserId: 7,
        eventId: 2792,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 18).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 13,
            title: 'Default Chat',
            slugId: '7MN9dcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 904,
        roomId: 13,
        userId: 7,
        subUserId: null,
        eventId: 2791,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 18).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 13,
            title: 'Default Chat',
            slugId: '7MN9dcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 903,
        roomId: 13,
        userId: 1,
        subUserId: 7,
        eventId: 2790,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 18).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 13,
            title: 'Default Chat',
            slugId: '7MN9dcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 902,
        roomId: 13,
        userId: 7,
        subUserId: null,
        eventId: 2789,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 18).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 13,
            title: 'Default Chat',
            slugId: '7MN9dcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 901,
        roomId: 13,
        userId: 1,
        subUserId: 7,
        eventId: 2788,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 18).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 13,
            title: 'Default Chat',
            slugId: '7MN9dcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 900,
        roomId: 13,
        userId: 7,
        subUserId: null,
        eventId: 2787,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 18).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 13,
            title: 'Default Chat',
            slugId: '7MN9dcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 899,
        roomId: 13,
        userId: 1,
        subUserId: 7,
        eventId: 2786,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 18).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 13,
            title: 'Default Chat',
            slugId: '7MN9dcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 898,
        roomId: 13,
        userId: 7,
        subUserId: null,
        eventId: 2785,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 18).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 13,
            title: 'Default Chat',
            slugId: '7MN9dcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 897,
        roomId: 13,
        userId: 7,
        subUserId: 1,
        eventId: 2784,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 18).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 13,
            title: 'Default Chat',
            slugId: '7MN9dcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 896,
        roomId: 13,
        userId: 1,
        subUserId: null,
        eventId: 2783,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 18).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 13,
            title: 'Default Chat',
            slugId: '7MN9dcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 895,
        roomId: 13,
        userId: 1,
        subUserId: 7,
        eventId: 2782,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 18).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 13,
            title: 'Default Chat',
            slugId: '7MN9dcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 894,
        roomId: 13,
        userId: 7,
        subUserId: null,
        eventId: 2781,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 18).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 13,
            title: 'Default Chat',
            slugId: '7MN9dcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 893,
        roomId: 13,
        userId: 7,
        subUserId: 1,
        eventId: 2780,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 18).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 13,
            title: 'Default Chat',
            slugId: '7MN9dcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 892,
        roomId: 13,
        userId: 1,
        subUserId: null,
        eventId: 2779,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 18).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 13,
            title: 'Default Chat',
            slugId: '7MN9dcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 891,
        roomId: 13,
        userId: 1,
        subUserId: 7,
        eventId: 2778,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 18).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 13,
            title: 'Default Chat',
            slugId: '7MN9dcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 890,
        roomId: 13,
        userId: 7,
        subUserId: null,
        eventId: 2777,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 18).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 13,
            title: 'Default Chat',
            slugId: '7MN9dcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 889,
        roomId: 13,
        userId: 1,
        subUserId: 7,
        eventId: 2776,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 18).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 13,
            title: 'Default Chat',
            slugId: '7MN9dcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 888,
        roomId: 13,
        userId: 7,
        subUserId: null,
        eventId: 2775,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 18).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 13,
            title: 'Default Chat',
            slugId: '7MN9dcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 887,
        roomId: 13,
        userId: 1,
        subUserId: 7,
        eventId: 2774,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 18).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 13,
            title: 'Default Chat',
            slugId: '7MN9dcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 886,
        roomId: 13,
        userId: 7,
        subUserId: null,
        eventId: 2773,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 18).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 13,
            title: 'Default Chat',
            slugId: '7MN9dcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 885,
        roomId: 13,
        userId: 1,
        subUserId: 7,
        eventId: 2771,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 18).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 13,
            title: 'Default Chat',
            slugId: '7MN9dcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 884,
        roomId: 13,
        userId: 7,
        subUserId: null,
        eventId: 2769,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 18).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 13,
            title: 'Default Chat',
            slugId: '7MN9dcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 883,
        roomId: 13,
        userId: 1,
        subUserId: 7,
        eventId: 2767,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 18).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 13,
            title: 'Default Chat',
            slugId: '7MN9dcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 882,
        roomId: 13,
        userId: 7,
        subUserId: null,
        eventId: 2765,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 18).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 13,
            title: 'Default Chat',
            slugId: '7MN9dcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 881,
        roomId: 13,
        userId: 7,
        subUserId: 1,
        eventId: 2761,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 18).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 13,
            title: 'Default Chat',
            slugId: '7MN9dcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 880,
        roomId: 13,
        userId: 1,
        subUserId: null,
        eventId: 2759,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 18).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 13,
            title: 'Default Chat',
            slugId: '7MN9dcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 879,
        roomId: 13,
        userId: 1,
        subUserId: 7,
        eventId: 2758,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 18).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 13,
            title: 'Default Chat',
            slugId: '7MN9dcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 878,
        roomId: 13,
        userId: 7,
        subUserId: null,
        eventId: 2756,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 18).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 13,
            title: 'Default Chat',
            slugId: '7MN9dcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 877,
        roomId: 13,
        userId: 1,
        subUserId: 7,
        eventId: 2755,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 18).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 13,
            title: 'Default Chat',
            slugId: '7MN9dcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 876,
        roomId: 13,
        userId: 7,
        subUserId: null,
        eventId: 2754,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 18).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 13,
            title: 'Default Chat',
            slugId: '7MN9dcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 875,
        roomId: 13,
        userId: 7,
        subUserId: 1,
        eventId: 2753,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 18).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 13,
            title: 'Default Chat',
            slugId: '7MN9dcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 874,
        roomId: 13,
        userId: 1,
        subUserId: null,
        eventId: 2752,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 18).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 13,
            title: 'Default Chat',
            slugId: '7MN9dcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 873,
        roomId: 13,
        userId: 1,
        subUserId: 7,
        eventId: 2751,
        workspaceId: 6,
        action: 'CHAT_REACTION_ADDED',
        date: subDays(new Date(), 18).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 13,
            title: 'Default Chat',
            slugId: '7MN9dcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 872,
        roomId: 6,
        userId: 11,
        subUserId: 1,
        eventId: 2745,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 18).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 871,
        roomId: 6,
        userId: 1,
        subUserId: null,
        eventId: 2741,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 18).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 870,
        roomId: 6,
        userId: 1,
        subUserId: 11,
        eventId: 2740,
        workspaceId: 6,
        action: 'CHAT_REACTION_ADDED',
        date: subDays(new Date(), 18).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 869,
        roomId: 5,
        userId: 11,
        subUserId: null,
        eventId: 2712,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 18).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 5,
            title: '[Cart2Cart] Journal Feedback',
            slugId: 'AAAA6AlE3c0',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 868,
        roomId: 5,
        userId: 9,
        subUserId: null,
        eventId: 2711,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 18).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 5,
            title: '[Cart2Cart] Journal Feedback',
            slugId: 'AAAA6AlE3c0',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 867,
        roomId: 5,
        userId: 9,
        subUserId: null,
        eventId: 2710,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 18).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 5,
            title: '[Cart2Cart] Journal Feedback',
            slugId: 'AAAA6AlE3c0',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 863,
        roomId: 13,
        userId: 7,
        subUserId: 1,
        eventId: 2705,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 18).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 13,
            title: 'Default Chat',
            slugId: '7MN9dcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 864,
        roomId: 13,
        userId: 7,
        subUserId: 1,
        eventId: 2706,
        workspaceId: 6,
        action: 'CHAT_ATTACHMENT_UPLOAD',
        date: subDays(new Date(), 18).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 13,
            title: 'Default Chat',
            slugId: '7MN9dcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 865,
        roomId: 13,
        userId: 7,
        subUserId: 1,
        eventId: 2707,
        workspaceId: 6,
        action: 'CHAT_ATTACHMENT_UPLOAD',
        date: subDays(new Date(), 18).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 13,
            title: 'Default Chat',
            slugId: '7MN9dcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 866,
        roomId: 13,
        userId: 7,
        subUserId: 1,
        eventId: 2708,
        workspaceId: 6,
        action: 'CHAT_ATTACHMENT_UPLOAD',
        date: subDays(new Date(), 18).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 13,
            title: 'Default Chat',
            slugId: '7MN9dcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 862,
        roomId: 9,
        userId: 7,
        subUserId: null,
        eventId: 2611,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 9,
            title: 'developers',
            slugId: 'AAAAqNofp2Q',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 861,
        roomId: 7,
        userId: 9,
        subUserId: null,
        eventId: 2541,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 7,
            title: '[Cart2Cart] ETL',
            slugId: 'AAAArpJpqHw',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 860,
        roomId: 13,
        userId: 1,
        subUserId: null,
        eventId: 2540,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 13,
            title: 'Default Chat',
            slugId: '7MN9dcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 859,
        roomId: 13,
        userId: 1,
        subUserId: 7,
        eventId: 2539,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 13,
            title: 'Default Chat',
            slugId: '7MN9dcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 858,
        roomId: 13,
        userId: 1,
        subUserId: 7,
        eventId: 2538,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 13,
            title: 'Default Chat',
            slugId: '7MN9dcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 857,
        roomId: 13,
        userId: 7,
        subUserId: null,
        eventId: 2537,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 13,
            title: 'Default Chat',
            slugId: '7MN9dcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 855,
        roomId: 13,
        userId: 7,
        subUserId: 1,
        eventId: 2535,
        workspaceId: 6,
        action: 'CHAT_ATTACHMENT_UPLOAD',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 13,
            title: 'Default Chat',
            slugId: '7MN9dcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 856,
        roomId: 13,
        userId: 7,
        subUserId: 1,
        eventId: 2536,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 13,
            title: 'Default Chat',
            slugId: '7MN9dcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 854,
        roomId: 13,
        userId: 1,
        subUserId: null,
        eventId: 2534,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 13,
            title: 'Default Chat',
            slugId: '7MN9dcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 853,
        roomId: 7,
        userId: 11,
        subUserId: null,
        eventId: 2533,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 7,
            title: '[Cart2Cart] ETL',
            slugId: 'AAAArpJpqHw',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 852,
        roomId: 7,
        userId: 11,
        subUserId: null,
        eventId: 2532,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 7,
            title: '[Cart2Cart] ETL',
            slugId: 'AAAArpJpqHw',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 851,
        roomId: 7,
        userId: 11,
        subUserId: null,
        eventId: 2531,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 7,
            title: '[Cart2Cart] ETL',
            slugId: 'AAAArpJpqHw',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 850,
        roomId: 7,
        userId: 9,
        subUserId: null,
        eventId: 2530,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 7,
            title: '[Cart2Cart] ETL',
            slugId: 'AAAArpJpqHw',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 849,
        roomId: 7,
        userId: 9,
        subUserId: null,
        eventId: 2529,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 7,
            title: '[Cart2Cart] ETL',
            slugId: 'AAAArpJpqHw',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 848,
        roomId: 13,
        userId: 1,
        subUserId: 7,
        eventId: 2528,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 13,
            title: 'Default Chat',
            slugId: '7MN9dcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 847,
        roomId: 13,
        userId: 7,
        subUserId: null,
        eventId: 2527,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 13,
            title: 'Default Chat',
            slugId: '7MN9dcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 846,
        roomId: 13,
        userId: 7,
        subUserId: 1,
        eventId: 2526,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 13,
            title: 'Default Chat',
            slugId: '7MN9dcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 845,
        roomId: 13,
        userId: 1,
        subUserId: null,
        eventId: 2525,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 13,
            title: 'Default Chat',
            slugId: '7MN9dcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 844,
        roomId: 13,
        userId: 1,
        subUserId: 7,
        eventId: 2524,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 13,
            title: 'Default Chat',
            slugId: '7MN9dcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 843,
        roomId: 13,
        userId: 7,
        subUserId: null,
        eventId: 2523,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 13,
            title: 'Default Chat',
            slugId: '7MN9dcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 842,
        roomId: 13,
        userId: 7,
        subUserId: 1,
        eventId: 2522,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 13,
            title: 'Default Chat',
            slugId: '7MN9dcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 841,
        roomId: 13,
        userId: 1,
        subUserId: null,
        eventId: 2521,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 13,
            title: 'Default Chat',
            slugId: '7MN9dcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 840,
        roomId: 13,
        userId: 1,
        subUserId: 7,
        eventId: 2520,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 13,
            title: 'Default Chat',
            slugId: '7MN9dcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 839,
        roomId: 13,
        userId: 7,
        subUserId: null,
        eventId: 2519,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 13,
            title: 'Default Chat',
            slugId: '7MN9dcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 838,
        roomId: 13,
        userId: 7,
        subUserId: 1,
        eventId: 2518,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 13,
            title: 'Default Chat',
            slugId: '7MN9dcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 837,
        roomId: 10,
        userId: 1,
        subUserId: 3,
        eventId: 2517,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 10,
            title: 'Default Chat',
            slugId: '09ux9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 836,
        roomId: 10,
        userId: 1,
        subUserId: 3,
        eventId: 2516,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 10,
            title: 'Default Chat',
            slugId: '09ux9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 835,
        roomId: 13,
        userId: 1,
        subUserId: null,
        eventId: 2515,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 13,
            title: 'Default Chat',
            slugId: '7MN9dcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 834,
        roomId: 13,
        userId: 1,
        subUserId: 7,
        eventId: 2514,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 13,
            title: 'Default Chat',
            slugId: '7MN9dcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 833,
        roomId: 13,
        userId: 1,
        subUserId: 7,
        eventId: 2513,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 13,
            title: 'Default Chat',
            slugId: '7MN9dcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 832,
        roomId: 13,
        userId: 1,
        subUserId: 7,
        eventId: 2512,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 13,
            title: 'Default Chat',
            slugId: '7MN9dcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 831,
        roomId: 13,
        userId: 7,
        subUserId: null,
        eventId: 2511,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 13,
            title: 'Default Chat',
            slugId: '7MN9dcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 830,
        roomId: 13,
        userId: 7,
        subUserId: null,
        eventId: 2510,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 13,
            title: 'Default Chat',
            slugId: '7MN9dcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 829,
        roomId: 13,
        userId: 7,
        subUserId: 1,
        eventId: 2509,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 13,
            title: 'Default Chat',
            slugId: '7MN9dcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 828,
        roomId: 13,
        userId: 1,
        subUserId: null,
        eventId: 2508,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 13,
            title: 'Default Chat',
            slugId: '7MN9dcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 827,
        roomId: 13,
        userId: 1,
        subUserId: 7,
        eventId: 2507,
        workspaceId: 6,
        action: 'CHAT_REACTION_ADDED',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 13,
            title: 'Default Chat',
            slugId: '7MN9dcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 826,
        roomId: 3,
        userId: 9,
        subUserId: null,
        eventId: 2506,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 825,
        roomId: 3,
        userId: 11,
        subUserId: null,
        eventId: 2505,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 824,
        roomId: 3,
        userId: 11,
        subUserId: null,
        eventId: 2504,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 823,
        roomId: 3,
        userId: 9,
        subUserId: null,
        eventId: 2503,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 822,
        roomId: 3,
        userId: 11,
        subUserId: null,
        eventId: 2502,
        workspaceId: 6,
        action: 'CHAT_REACTION_ADDED',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 821,
        roomId: 1,
        userId: 11,
        subUserId: 9,
        eventId: 2501,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 820,
        roomId: 1,
        userId: 9,
        subUserId: null,
        eventId: 2500,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 819,
        roomId: 1,
        userId: 9,
        subUserId: 11,
        eventId: 2499,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 818,
        roomId: 1,
        userId: 11,
        subUserId: null,
        eventId: 2498,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 817,
        roomId: 1,
        userId: 11,
        subUserId: 9,
        eventId: 2497,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 816,
        roomId: 1,
        userId: 9,
        subUserId: null,
        eventId: 2496,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 815,
        roomId: 1,
        userId: 11,
        subUserId: 9,
        eventId: 2495,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 814,
        roomId: 1,
        userId: 9,
        subUserId: null,
        eventId: 2494,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 813,
        roomId: 1,
        userId: 9,
        subUserId: 11,
        eventId: 2493,
        workspaceId: 6,
        action: 'CHAT_REACTION_ADDED',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 812,
        roomId: 1,
        userId: 11,
        subUserId: 9,
        eventId: 2492,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 811,
        roomId: 1,
        userId: 9,
        subUserId: null,
        eventId: 2491,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 810,
        roomId: 1,
        userId: 9,
        subUserId: 11,
        eventId: 2490,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 809,
        roomId: 1,
        userId: 11,
        subUserId: null,
        eventId: 2489,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 808,
        roomId: 1,
        userId: 11,
        subUserId: 9,
        eventId: 2488,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 807,
        roomId: 1,
        userId: 9,
        subUserId: null,
        eventId: 2487,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 806,
        roomId: 1,
        userId: 11,
        subUserId: 9,
        eventId: 2486,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 805,
        roomId: 1,
        userId: 9,
        subUserId: null,
        eventId: 2485,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 804,
        roomId: 1,
        userId: 11,
        subUserId: 9,
        eventId: 2484,
        workspaceId: 6,
        action: 'CHAT_REACTION_ADDED',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 803,
        roomId: 1,
        userId: 9,
        subUserId: 11,
        eventId: 2483,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 802,
        roomId: 1,
        userId: 11,
        subUserId: null,
        eventId: 2482,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 801,
        roomId: 1,
        userId: 11,
        subUserId: 9,
        eventId: 2481,
        workspaceId: 6,
        action: 'CHAT_REACTION_ADDED',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 799,
        roomId: 1,
        userId: 9,
        subUserId: 11,
        eventId: 2479,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 800,
        roomId: 1,
        userId: 9,
        subUserId: 11,
        eventId: 2480,
        workspaceId: 6,
        action: 'CHAT_ATTACHMENT_UPLOAD',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 798,
        roomId: 3,
        userId: 11,
        subUserId: null,
        eventId: 2478,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 797,
        roomId: 1,
        userId: 11,
        subUserId: null,
        eventId: 2477,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 796,
        roomId: 1,
        userId: 11,
        subUserId: 9,
        eventId: 2476,
        workspaceId: 6,
        action: 'CHAT_REACTION_ADDED',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 795,
        roomId: 1,
        userId: 11,
        subUserId: 9,
        eventId: 2475,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 794,
        roomId: 1,
        userId: 9,
        subUserId: null,
        eventId: 2474,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 793,
        roomId: 1,
        userId: 11,
        subUserId: 9,
        eventId: 2473,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 792,
        roomId: 1,
        userId: 9,
        subUserId: null,
        eventId: 2464,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 791,
        roomId: 1,
        userId: 9,
        subUserId: 11,
        eventId: 2463,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 790,
        roomId: 1,
        userId: 11,
        subUserId: null,
        eventId: 2462,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 789,
        roomId: 1,
        userId: 11,
        subUserId: 9,
        eventId: 2461,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 788,
        roomId: 1,
        userId: 9,
        subUserId: null,
        eventId: 2460,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 787,
        roomId: 1,
        userId: 11,
        subUserId: 9,
        eventId: 2459,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 786,
        roomId: 1,
        userId: 9,
        subUserId: null,
        eventId: 2458,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 785,
        roomId: 1,
        userId: 11,
        subUserId: 9,
        eventId: 2457,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 784,
        roomId: 1,
        userId: 9,
        subUserId: null,
        eventId: 2456,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 783,
        roomId: 1,
        userId: 9,
        subUserId: 11,
        eventId: 2455,
        workspaceId: 6,
        action: 'CHAT_REACTION_ADDED',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 782,
        roomId: 1,
        userId: 11,
        subUserId: 9,
        eventId: 2454,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 781,
        roomId: 1,
        userId: 9,
        subUserId: null,
        eventId: 2453,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 780,
        roomId: 1,
        userId: 11,
        subUserId: 9,
        eventId: 2452,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 779,
        roomId: 1,
        userId: 9,
        subUserId: null,
        eventId: 2451,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 778,
        roomId: 1,
        userId: 9,
        subUserId: 11,
        eventId: 2450,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 777,
        roomId: 1,
        userId: 11,
        subUserId: null,
        eventId: 2449,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 776,
        roomId: 1,
        userId: 11,
        subUserId: 9,
        eventId: 2448,
        workspaceId: 6,
        action: 'CHAT_REACTION_ADDED',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 774,
        roomId: 4,
        userId: 11,
        subUserId: 10,
        eventId: 2446,
        workspaceId: 6,
        action: 'CHAT_ATTACHMENT_UPLOAD',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 775,
        roomId: 4,
        userId: 11,
        subUserId: 10,
        eventId: 2447,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 773,
        roomId: 4,
        userId: 10,
        subUserId: null,
        eventId: 2445,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 772,
        roomId: 1,
        userId: 9,
        subUserId: 11,
        eventId: 2444,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 771,
        roomId: 4,
        userId: 11,
        subUserId: 10,
        eventId: 2443,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 770,
        roomId: 4,
        userId: 11,
        subUserId: 10,
        eventId: 2442,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 769,
        roomId: 1,
        userId: 11,
        subUserId: null,
        eventId: 2441,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 768,
        roomId: 1,
        userId: 11,
        subUserId: 9,
        eventId: 2440,
        workspaceId: 6,
        action: 'CHAT_REACTION_ADDED',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 767,
        roomId: 4,
        userId: 10,
        subUserId: null,
        eventId: 2439,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 766,
        roomId: 1,
        userId: 11,
        subUserId: 9,
        eventId: 2438,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 765,
        roomId: 4,
        userId: 10,
        subUserId: 11,
        eventId: 2437,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 764,
        roomId: 1,
        userId: 9,
        subUserId: null,
        eventId: 2436,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 763,
        roomId: 1,
        userId: 9,
        subUserId: 11,
        eventId: 2435,
        workspaceId: 6,
        action: 'CHAT_REACTION_ADDED',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 762,
        roomId: 4,
        userId: 11,
        subUserId: null,
        eventId: 2434,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 761,
        roomId: 4,
        userId: 11,
        subUserId: 10,
        eventId: 2433,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 760,
        roomId: 4,
        userId: 10,
        subUserId: null,
        eventId: 2432,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 759,
        roomId: 4,
        userId: 11,
        subUserId: 10,
        eventId: 2431,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 758,
        roomId: 4,
        userId: 10,
        subUserId: null,
        eventId: 2430,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 757,
        roomId: 4,
        userId: 11,
        subUserId: 10,
        eventId: 2429,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 756,
        roomId: 4,
        userId: 11,
        subUserId: 10,
        eventId: 2428,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 755,
        roomId: 4,
        userId: 10,
        subUserId: null,
        eventId: 2427,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 754,
        roomId: 4,
        userId: 10,
        subUserId: 11,
        eventId: 2426,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 753,
        roomId: 4,
        userId: 10,
        subUserId: 11,
        eventId: 2425,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 752,
        roomId: 4,
        userId: 11,
        subUserId: null,
        eventId: 2424,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 751,
        roomId: 4,
        userId: 11,
        subUserId: 10,
        eventId: 2423,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 750,
        roomId: 4,
        userId: 10,
        subUserId: null,
        eventId: 2422,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 749,
        roomId: 4,
        userId: 10,
        subUserId: 11,
        eventId: 2421,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 748,
        roomId: 4,
        userId: 11,
        subUserId: 10,
        eventId: 2420,
        workspaceId: 6,
        action: 'CHAT_REACTION_ADDED',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 747,
        roomId: 4,
        userId: 11,
        subUserId: null,
        eventId: 2419,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 746,
        roomId: 1,
        userId: 11,
        subUserId: 9,
        eventId: 2418,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 745,
        roomId: 1,
        userId: 11,
        subUserId: 9,
        eventId: 2417,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 744,
        roomId: 1,
        userId: 11,
        subUserId: 9,
        eventId: 2416,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 743,
        roomId: 1,
        userId: 9,
        subUserId: null,
        eventId: 2415,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 741,
        roomId: 4,
        userId: 11,
        subUserId: 10,
        eventId: 2413,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 742,
        roomId: 4,
        userId: 11,
        subUserId: 10,
        eventId: 2414,
        workspaceId: 6,
        action: 'CHAT_ATTACHMENT_UPLOAD',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 740,
        roomId: 4,
        userId: 10,
        subUserId: null,
        eventId: 2412,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 739,
        roomId: 4,
        userId: 10,
        subUserId: 11,
        eventId: 2411,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 738,
        roomId: 4,
        userId: 11,
        subUserId: null,
        eventId: 2410,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 737,
        roomId: 4,
        userId: 11,
        subUserId: 10,
        eventId: 2409,
        workspaceId: 6,
        action: 'CHAT_REACTION_ADDED',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 736,
        roomId: 4,
        userId: 10,
        subUserId: 11,
        eventId: 2408,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 735,
        roomId: 4,
        userId: 11,
        subUserId: null,
        eventId: 2407,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 734,
        roomId: 4,
        userId: 11,
        subUserId: 10,
        eventId: 2406,
        workspaceId: 6,
        action: 'CHAT_REACTION_ADDED',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 733,
        roomId: 4,
        userId: 11,
        subUserId: 10,
        eventId: 2405,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 732,
        roomId: 1,
        userId: 9,
        subUserId: 11,
        eventId: 2404,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 731,
        roomId: 1,
        userId: 11,
        subUserId: null,
        eventId: 2403,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 730,
        roomId: 1,
        userId: 11,
        subUserId: 9,
        eventId: 2402,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 729,
        roomId: 1,
        userId: 11,
        subUserId: 9,
        eventId: 2401,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 728,
        roomId: 1,
        userId: 9,
        subUserId: null,
        eventId: 2400,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 727,
        roomId: 1,
        userId: 9,
        subUserId: 11,
        eventId: 2399,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 726,
        roomId: 1,
        userId: 11,
        subUserId: null,
        eventId: 2398,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 725,
        roomId: 1,
        userId: 9,
        subUserId: 11,
        eventId: 2397,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 724,
        roomId: 1,
        userId: 11,
        subUserId: null,
        eventId: 2396,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 723,
        roomId: 1,
        userId: 11,
        subUserId: 9,
        eventId: 2395,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 722,
        roomId: 1,
        userId: 9,
        subUserId: null,
        eventId: 2394,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 721,
        roomId: 1,
        userId: 11,
        subUserId: 9,
        eventId: 2393,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 720,
        roomId: 1,
        userId: 9,
        subUserId: null,
        eventId: 2392,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 719,
        roomId: 4,
        userId: 10,
        subUserId: null,
        eventId: 2391,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 718,
        roomId: 7,
        userId: 11,
        subUserId: null,
        eventId: 2390,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 7,
            title: '[Cart2Cart] ETL',
            slugId: 'AAAArpJpqHw',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 717,
        roomId: 7,
        userId: 11,
        subUserId: null,
        eventId: 2389,
        workspaceId: 6,
        action: 'CHAT_REACTION_ADDED',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 7,
            title: '[Cart2Cart] ETL',
            slugId: 'AAAArpJpqHw',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 716,
        roomId: 1,
        userId: 9,
        subUserId: 11,
        eventId: 2388,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 715,
        roomId: 1,
        userId: 11,
        subUserId: null,
        eventId: 2387,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 714,
        roomId: 1,
        userId: 11,
        subUserId: 9,
        eventId: 2386,
        workspaceId: 6,
        action: 'CHAT_REACTION_ADDED',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 713,
        roomId: 1,
        userId: 9,
        subUserId: 11,
        eventId: 2385,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 712,
        roomId: 4,
        userId: 11,
        subUserId: 10,
        eventId: 2384,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 711,
        roomId: 1,
        userId: 11,
        subUserId: null,
        eventId: 2383,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 710,
        roomId: 1,
        userId: 11,
        subUserId: 9,
        eventId: 2382,
        workspaceId: 6,
        action: 'CHAT_REACTION_ADDED',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 709,
        roomId: 4,
        userId: 10,
        subUserId: null,
        eventId: 2381,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 708,
        roomId: 4,
        userId: 10,
        subUserId: 11,
        eventId: 2380,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 707,
        roomId: 4,
        userId: 11,
        subUserId: null,
        eventId: 2379,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 706,
        roomId: 4,
        userId: 11,
        subUserId: 10,
        eventId: 2378,
        workspaceId: 6,
        action: 'CHAT_REACTION_ADDED',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 705,
        roomId: 1,
        userId: 9,
        subUserId: 11,
        eventId: 2377,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 704,
        roomId: 1,
        userId: 11,
        subUserId: null,
        eventId: 2376,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 703,
        roomId: 1,
        userId: 11,
        subUserId: 9,
        eventId: 2375,
        workspaceId: 6,
        action: 'CHAT_REACTION_ADDED',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 702,
        roomId: 1,
        userId: 11,
        subUserId: 9,
        eventId: 2374,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 701,
        roomId: 1,
        userId: 9,
        subUserId: null,
        eventId: 2373,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 700,
        roomId: 1,
        userId: 9,
        subUserId: 11,
        eventId: 2372,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 699,
        roomId: 1,
        userId: 11,
        subUserId: null,
        eventId: 2371,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 698,
        roomId: 1,
        userId: 9,
        subUserId: 11,
        eventId: 2370,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 697,
        roomId: 1,
        userId: 11,
        subUserId: null,
        eventId: 2369,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 696,
        roomId: 1,
        userId: 11,
        subUserId: 9,
        eventId: 2368,
        workspaceId: 6,
        action: 'CHAT_REACTION_ADDED',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 695,
        roomId: 1,
        userId: 9,
        subUserId: 11,
        eventId: 2367,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 694,
        roomId: 1,
        userId: 11,
        subUserId: null,
        eventId: 2366,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 693,
        roomId: 1,
        userId: 11,
        subUserId: 9,
        eventId: 2365,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 692,
        roomId: 1,
        userId: 9,
        subUserId: null,
        eventId: 2364,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 691,
        roomId: 1,
        userId: 11,
        subUserId: 9,
        eventId: 2363,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 690,
        roomId: 1,
        userId: 9,
        subUserId: null,
        eventId: 2362,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 689,
        roomId: 1,
        userId: 9,
        subUserId: 11,
        eventId: 2361,
        workspaceId: 6,
        action: 'CHAT_REACTION_ADDED',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 688,
        roomId: 4,
        userId: 11,
        subUserId: 10,
        eventId: 2360,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 687,
        roomId: 4,
        userId: 10,
        subUserId: null,
        eventId: 2359,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 686,
        roomId: 4,
        userId: 11,
        subUserId: 10,
        eventId: 2358,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 685,
        roomId: 4,
        userId: 10,
        subUserId: null,
        eventId: 2357,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 684,
        roomId: 4,
        userId: 10,
        subUserId: 11,
        eventId: 2356,
        workspaceId: 6,
        action: 'CHAT_REACTION_ADDED',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 683,
        roomId: 13,
        userId: 7,
        subUserId: 1,
        eventId: 2355,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 13,
            title: 'Default Chat',
            slugId: '7MN9dcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 682,
        roomId: 14,
        userId: 7,
        subUserId: 11,
        eventId: 2354,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 14,
            title: 'Default Chat',
            slugId: 'pSEpjcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 681,
        roomId: 7,
        userId: 11,
        subUserId: null,
        eventId: 2353,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 7,
            title: '[Cart2Cart] ETL',
            slugId: 'AAAArpJpqHw',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 680,
        roomId: 14,
        userId: 11,
        subUserId: null,
        eventId: 2352,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 14,
            title: 'Default Chat',
            slugId: 'pSEpjcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 679,
        roomId: 7,
        userId: 9,
        subUserId: null,
        eventId: 2351,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 7,
            title: '[Cart2Cart] ETL',
            slugId: 'AAAArpJpqHw',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 678,
        roomId: 14,
        userId: 11,
        subUserId: 7,
        eventId: 2350,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 14,
            title: 'Default Chat',
            slugId: 'pSEpjcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 677,
        roomId: 14,
        userId: 7,
        subUserId: null,
        eventId: 2349,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 14,
            title: 'Default Chat',
            slugId: 'pSEpjcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 676,
        roomId: 14,
        userId: 7,
        subUserId: 11,
        eventId: 2348,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 14,
            title: 'Default Chat',
            slugId: 'pSEpjcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 675,
        roomId: 14,
        userId: 11,
        subUserId: null,
        eventId: 2347,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 14,
            title: 'Default Chat',
            slugId: 'pSEpjcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 674,
        roomId: 7,
        userId: 9,
        subUserId: null,
        eventId: 2346,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 7,
            title: '[Cart2Cart] ETL',
            slugId: 'AAAArpJpqHw',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 673,
        roomId: 7,
        userId: 11,
        subUserId: null,
        eventId: 2345,
        workspaceId: 6,
        action: 'CHAT_REACTION_ADDED',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 7,
            title: '[Cart2Cart] ETL',
            slugId: 'AAAArpJpqHw',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 672,
        roomId: 3,
        userId: 9,
        subUserId: null,
        eventId: 2344,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 671,
        roomId: 10,
        userId: 3,
        subUserId: null,
        eventId: 2343,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 10,
            title: 'Default Chat',
            slugId: '09ux9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 670,
        roomId: 8,
        userId: 3,
        subUserId: 11,
        eventId: 2342,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 8,
            title: 'Default Chat',
            slugId: 'm0JbdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 669,
        roomId: 8,
        userId: 3,
        subUserId: 11,
        eventId: 2341,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 8,
            title: 'Default Chat',
            slugId: 'm0JbdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 668,
        roomId: 8,
        userId: 11,
        subUserId: null,
        eventId: 2340,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 8,
            title: 'Default Chat',
            slugId: 'm0JbdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 667,
        roomId: 8,
        userId: 11,
        subUserId: 3,
        eventId: 2339,
        workspaceId: 6,
        action: 'CHAT_REACTION_ADDED',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 8,
            title: 'Default Chat',
            slugId: 'm0JbdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 666,
        roomId: 6,
        userId: 11,
        subUserId: 1,
        eventId: 2338,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 665,
        roomId: 13,
        userId: 1,
        subUserId: null,
        eventId: 2337,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 13,
            title: 'Default Chat',
            slugId: '7MN9dcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 664,
        roomId: 6,
        userId: 1,
        subUserId: null,
        eventId: 2336,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 663,
        roomId: 6,
        userId: 11,
        subUserId: 1,
        eventId: 2335,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 662,
        roomId: 6,
        userId: 1,
        subUserId: null,
        eventId: 2334,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 661,
        roomId: 6,
        userId: 11,
        subUserId: 1,
        eventId: 2333,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 660,
        roomId: 6,
        userId: 1,
        subUserId: null,
        eventId: 2332,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 659,
        roomId: 6,
        userId: 1,
        subUserId: 11,
        eventId: 2331,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 658,
        roomId: 6,
        userId: 11,
        subUserId: null,
        eventId: 2330,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 657,
        roomId: 6,
        userId: 11,
        subUserId: 1,
        eventId: 2329,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 656,
        roomId: 6,
        userId: 1,
        subUserId: null,
        eventId: 2328,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 655,
        roomId: 6,
        userId: 11,
        subUserId: 1,
        eventId: 2327,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 654,
        roomId: 6,
        userId: 11,
        subUserId: 1,
        eventId: 2326,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 653,
        roomId: 6,
        userId: 1,
        subUserId: null,
        eventId: 2325,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 652,
        roomId: 6,
        userId: 1,
        subUserId: 11,
        eventId: 2324,
        workspaceId: 6,
        action: 'CHAT_REACTION_ADDED',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 651,
        roomId: 6,
        userId: 11,
        subUserId: 1,
        eventId: 2323,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 650,
        roomId: 6,
        userId: 1,
        subUserId: null,
        eventId: 2322,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 649,
        roomId: 6,
        userId: 11,
        subUserId: 1,
        eventId: 2321,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 648,
        roomId: 6,
        userId: 1,
        subUserId: null,
        eventId: 2320,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 647,
        roomId: 6,
        userId: 11,
        subUserId: 1,
        eventId: 2319,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 646,
        roomId: 6,
        userId: 1,
        subUserId: null,
        eventId: 2318,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 645,
        roomId: 6,
        userId: 1,
        subUserId: 11,
        eventId: 2317,
        workspaceId: 6,
        action: 'CHAT_REACTION_ADDED',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 644,
        roomId: 12,
        userId: 1,
        subUserId: null,
        eventId: 2316,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 12,
            title: 'Default Chat',
            slugId: '721rNcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_APP_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 643,
        roomId: 6,
        userId: 11,
        subUserId: 1,
        eventId: 2315,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 642,
        roomId: 6,
        userId: 1,
        subUserId: null,
        eventId: 2314,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 641,
        roomId: 6,
        userId: 1,
        subUserId: 11,
        eventId: 2313,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 640,
        roomId: 6,
        userId: 11,
        subUserId: null,
        eventId: 2312,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 639,
        roomId: 6,
        userId: 11,
        subUserId: 1,
        eventId: 2311,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 638,
        roomId: 6,
        userId: 11,
        subUserId: 1,
        eventId: 2310,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 637,
        roomId: 6,
        userId: 1,
        subUserId: null,
        eventId: 2309,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 636,
        roomId: 6,
        userId: 1,
        subUserId: 11,
        eventId: 2308,
        workspaceId: 6,
        action: 'CHAT_REACTION_ADDED',
        date: subDays(new Date(), 16).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 635,
        roomId: 10,
        userId: 3,
        subUserId: 1,
        eventId: 2307,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 15).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 10,
            title: 'Default Chat',
            slugId: '09ux9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 634,
        roomId: 10,
        userId: 1,
        subUserId: null,
        eventId: 2306,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 15).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 10,
            title: 'Default Chat',
            slugId: '09ux9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 633,
        roomId: 10,
        userId: 1,
        subUserId: 3,
        eventId: 2305,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 15).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 10,
            title: 'Default Chat',
            slugId: '09ux9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 632,
        roomId: 7,
        userId: 9,
        subUserId: null,
        eventId: 2304,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 15).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 7,
            title: '[Cart2Cart] ETL',
            slugId: 'AAAArpJpqHw',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 631,
        roomId: 4,
        userId: 10,
        subUserId: 11,
        eventId: 2303,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 15).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 630,
        roomId: 4,
        userId: 11,
        subUserId: null,
        eventId: 2302,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 15).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 629,
        roomId: 4,
        userId: 11,
        subUserId: 10,
        eventId: 2301,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 15).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 628,
        roomId: 3,
        userId: 11,
        subUserId: null,
        eventId: 2300,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 15).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 627,
        roomId: 4,
        userId: 10,
        subUserId: null,
        eventId: 2299,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 15).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 626,
        roomId: 4,
        userId: 10,
        subUserId: 11,
        eventId: 2298,
        workspaceId: 6,
        action: 'CHAT_REACTION_ADDED',
        date: subDays(new Date(), 15).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 625,
        roomId: 7,
        userId: 11,
        subUserId: null,
        eventId: 2297,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 15).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 7,
            title: '[Cart2Cart] ETL',
            slugId: 'AAAArpJpqHw',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 624,
        roomId: 4,
        userId: 10,
        subUserId: 11,
        eventId: 2296,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 15).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 623,
        roomId: 4,
        userId: 11,
        subUserId: null,
        eventId: 2295,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 15).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 622,
        roomId: 4,
        userId: 10,
        subUserId: 11,
        eventId: 2294,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 15).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 621,
        roomId: 4,
        userId: 11,
        subUserId: null,
        eventId: 2293,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 15).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 620,
        roomId: 1,
        userId: 11,
        subUserId: 9,
        eventId: 2292,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 15).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 619,
        roomId: 1,
        userId: 9,
        subUserId: null,
        eventId: 2291,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 15).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 618,
        roomId: 1,
        userId: 11,
        subUserId: 9,
        eventId: 2290,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 15).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 617,
        roomId: 1,
        userId: 9,
        subUserId: null,
        eventId: 2289,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 15).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 616,
        roomId: 1,
        userId: 9,
        subUserId: 11,
        eventId: 2286,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 15).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 615,
        roomId: 1,
        userId: 11,
        subUserId: null,
        eventId: 2280,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 15).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 614,
        roomId: 1,
        userId: 11,
        subUserId: 9,
        eventId: 2279,
        workspaceId: 6,
        action: 'CHAT_REACTION_ADDED',
        date: subDays(new Date(), 15).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 613,
        roomId: 1,
        userId: 11,
        subUserId: 9,
        eventId: 2278,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 15).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 612,
        roomId: 1,
        userId: 9,
        subUserId: null,
        eventId: 2277,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 15).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 611,
        roomId: 4,
        userId: 11,
        subUserId: 10,
        eventId: 2276,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 15).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 610,
        roomId: 4,
        userId: 10,
        subUserId: null,
        eventId: 2275,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 15).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 609,
        roomId: 4,
        userId: 11,
        subUserId: 10,
        eventId: 2274,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 15).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 608,
        roomId: 4,
        userId: 10,
        subUserId: null,
        eventId: 2273,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 15).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 607,
        roomId: 4,
        userId: 10,
        subUserId: 11,
        eventId: 2272,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 15).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 606,
        roomId: 4,
        userId: 11,
        subUserId: null,
        eventId: 2271,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 15).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 605,
        roomId: 1,
        userId: 9,
        subUserId: 11,
        eventId: 2270,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 15).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 604,
        roomId: 1,
        userId: 9,
        subUserId: 11,
        eventId: 2268,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 15).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 603,
        roomId: 1,
        userId: 9,
        subUserId: 11,
        eventId: 2267,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 15).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 602,
        roomId: 1,
        userId: 9,
        subUserId: 11,
        eventId: 2266,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 15).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 601,
        roomId: 1,
        userId: 11,
        subUserId: null,
        eventId: 2265,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 15).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 600,
        roomId: 1,
        userId: 11,
        subUserId: 9,
        eventId: 2264,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 15).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 599,
        roomId: 1,
        userId: 11,
        subUserId: 9,
        eventId: 2263,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 15).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 598,
        roomId: 1,
        userId: 9,
        subUserId: null,
        eventId: 2262,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 15).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 597,
        roomId: 1,
        userId: 9,
        subUserId: 11,
        eventId: 2261,
        workspaceId: 6,
        action: 'CHAT_REACTION_ADDED',
        date: subDays(new Date(), 15).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 596,
        roomId: 1,
        userId: 9,
        subUserId: 11,
        eventId: 2260,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 15).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 595,
        roomId: 1,
        userId: 11,
        subUserId: null,
        eventId: 2259,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 15).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 594,
        roomId: 1,
        userId: 11,
        subUserId: 9,
        eventId: 2258,
        workspaceId: 6,
        action: 'CHAT_REACTION_ADDED',
        date: subDays(new Date(), 15).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 593,
        roomId: 1,
        userId: 9,
        subUserId: 11,
        eventId: 2257,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 15).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 592,
        roomId: 6,
        userId: 11,
        subUserId: 1,
        eventId: 2256,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 15).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 591,
        roomId: 6,
        userId: 1,
        subUserId: null,
        eventId: 2255,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 15).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 590,
        roomId: 6,
        userId: 1,
        subUserId: 11,
        eventId: 2254,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 15).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 589,
        roomId: 6,
        userId: 11,
        subUserId: null,
        eventId: 2253,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 15).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 588,
        roomId: 6,
        userId: 11,
        subUserId: 1,
        eventId: 2252,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 15).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 587,
        roomId: 6,
        userId: 1,
        subUserId: null,
        eventId: 2251,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 15).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 586,
        roomId: 1,
        userId: 11,
        subUserId: null,
        eventId: 2250,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 15).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 585,
        roomId: 1,
        userId: 11,
        subUserId: 9,
        eventId: 2249,
        workspaceId: 6,
        action: 'CHAT_REACTION_ADDED',
        date: subDays(new Date(), 15).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 584,
        roomId: 1,
        userId: 11,
        subUserId: 9,
        eventId: 2248,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 15).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 583,
        roomId: 1,
        userId: 11,
        subUserId: 9,
        eventId: 2247,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 15).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 582,
        roomId: 1,
        userId: 9,
        subUserId: null,
        eventId: 2246,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 15).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 581,
        roomId: 1,
        userId: 9,
        subUserId: null,
        eventId: 2245,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 15).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 580,
        roomId: 1,
        userId: 11,
        subUserId: 9,
        eventId: 2244,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 15).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 579,
        roomId: 1,
        userId: 9,
        subUserId: null,
        eventId: 2243,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 15).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 578,
        roomId: 1,
        userId: 9,
        subUserId: 11,
        eventId: 2242,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 15).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 577,
        roomId: 6,
        userId: 11,
        subUserId: 1,
        eventId: 2241,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 15).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 576,
        roomId: 6,
        userId: 1,
        subUserId: null,
        eventId: 2240,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 15).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 575,
        roomId: 6,
        userId: 11,
        subUserId: 1,
        eventId: 2239,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 15).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 574,
        roomId: 6,
        userId: 1,
        subUserId: null,
        eventId: 2238,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 15).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 573,
        roomId: 6,
        userId: 11,
        subUserId: 1,
        eventId: 2237,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 15).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 572,
        roomId: 6,
        userId: 1,
        subUserId: null,
        eventId: 2236,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 15).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 571,
        roomId: 6,
        userId: 11,
        subUserId: 1,
        eventId: 2235,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 15).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 570,
        roomId: 6,
        userId: 1,
        subUserId: null,
        eventId: 2234,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 15).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 569,
        roomId: 6,
        userId: 1,
        subUserId: 11,
        eventId: 2233,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 15).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 568,
        roomId: 1,
        userId: 9,
        subUserId: 11,
        eventId: 2232,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 15).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 567,
        roomId: 10,
        userId: 3,
        subUserId: null,
        eventId: 2231,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 15).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 10,
            title: 'Default Chat',
            slugId: '09ux9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 566,
        roomId: 3,
        userId: 9,
        subUserId: null,
        eventId: 2227,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 15).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 565,
        roomId: 3,
        userId: 9,
        subUserId: null,
        eventId: 2226,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 15).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 564,
        roomId: 8,
        userId: 3,
        subUserId: 11,
        eventId: 2225,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 15).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 8,
            title: 'Default Chat',
            slugId: 'm0JbdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 563,
        roomId: 3,
        userId: 11,
        subUserId: null,
        eventId: 2224,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 15).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 562,
        roomId: 1,
        userId: 11,
        subUserId: null,
        eventId: 2223,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 15).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 561,
        roomId: 6,
        userId: 11,
        subUserId: null,
        eventId: 2222,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 15).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 560,
        roomId: 8,
        userId: 11,
        subUserId: null,
        eventId: 2221,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 15).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 8,
            title: 'Default Chat',
            slugId: 'm0JbdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 559,
        roomId: 1,
        userId: 11,
        subUserId: 9,
        eventId: 2213,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 15).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 558,
        roomId: 1,
        userId: 11,
        subUserId: 9,
        eventId: 2212,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 15).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 557,
        roomId: 1,
        userId: 9,
        subUserId: null,
        eventId: 2211,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 15).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 556,
        roomId: 1,
        userId: 9,
        subUserId: 11,
        eventId: 2210,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 15).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 555,
        roomId: 1,
        userId: 9,
        subUserId: 11,
        eventId: 2209,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 15).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 553,
        roomId: 1,
        userId: 9,
        subUserId: 11,
        eventId: 2207,
        workspaceId: 6,
        action: 'CHAT_ATTACHMENT_UPLOAD',
        date: subDays(new Date(), 15).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 554,
        roomId: 1,
        userId: 9,
        subUserId: 11,
        eventId: 2208,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 15).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 552,
        roomId: 1,
        userId: 11,
        subUserId: null,
        eventId: 2206,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 15).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 551,
        roomId: 1,
        userId: 11,
        subUserId: 9,
        eventId: 2205,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 15).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 550,
        roomId: 1,
        userId: 9,
        subUserId: null,
        eventId: 2204,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 15).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 549,
        roomId: 1,
        userId: 9,
        subUserId: 11,
        eventId: 2202,
        workspaceId: 6,
        action: 'CHAT_REACTION_ADDED',
        date: subDays(new Date(), 15).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 548,
        roomId: 4,
        userId: 11,
        subUserId: 10,
        eventId: 2201,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 15).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 547,
        roomId: 4,
        userId: 10,
        subUserId: null,
        eventId: 2199,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 15).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 546,
        roomId: 4,
        userId: 10,
        subUserId: 11,
        eventId: 2198,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 15).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 545,
        roomId: 4,
        userId: 11,
        subUserId: null,
        eventId: 2197,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 15).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 544,
        roomId: 4,
        userId: 11,
        subUserId: 10,
        eventId: 2196,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 15).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 543,
        roomId: 4,
        userId: 10,
        subUserId: null,
        eventId: 2195,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 15).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 542,
        roomId: 5,
        userId: 11,
        subUserId: null,
        eventId: 2194,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 15).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 5,
            title: '[Cart2Cart] Journal Feedback',
            slugId: 'AAAA6AlE3c0',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 541,
        roomId: 5,
        userId: 11,
        subUserId: null,
        eventId: 2193,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 15).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 5,
            title: '[Cart2Cart] Journal Feedback',
            slugId: 'AAAA6AlE3c0',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 540,
        roomId: 4,
        userId: 10,
        subUserId: 11,
        eventId: 2192,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 15).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 538,
        roomId: 4,
        userId: 10,
        subUserId: 11,
        eventId: 2190,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 15).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 539,
        roomId: 4,
        userId: 10,
        subUserId: 11,
        eventId: 2191,
        workspaceId: 6,
        action: 'CHAT_ATTACHMENT_UPLOAD',
        date: subDays(new Date(), 15).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 537,
        roomId: 4,
        userId: 10,
        subUserId: 11,
        eventId: 2189,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 15).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 536,
        roomId: 4,
        userId: 11,
        subUserId: null,
        eventId: 2188,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 15).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 535,
        roomId: 4,
        userId: 11,
        subUserId: null,
        eventId: 2187,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 15).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 534,
        roomId: 4,
        userId: 11,
        subUserId: 10,
        eventId: 2186,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 15).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 533,
        roomId: 4,
        userId: 11,
        subUserId: 10,
        eventId: 2185,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 15).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 532,
        roomId: 4,
        userId: 10,
        subUserId: null,
        eventId: 2184,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 15).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 531,
        roomId: 4,
        userId: 10,
        subUserId: 11,
        eventId: 2183,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 15).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 530,
        roomId: 4,
        userId: 11,
        subUserId: null,
        eventId: 2182,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 15).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 529,
        roomId: 4,
        userId: 11,
        subUserId: 10,
        eventId: 2181,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 15).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 528,
        roomId: 4,
        userId: 10,
        subUserId: null,
        eventId: 2180,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 15).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 526,
        roomId: 4,
        userId: 10,
        subUserId: 11,
        eventId: 2178,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 15).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 527,
        roomId: 4,
        userId: 10,
        subUserId: 11,
        eventId: 2179,
        workspaceId: 6,
        action: 'CHAT_ATTACHMENT_UPLOAD',
        date: subDays(new Date(), 15).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 524,
        roomId: 4,
        userId: 10,
        subUserId: 11,
        eventId: 2176,
        workspaceId: 6,
        action: 'CHAT_ATTACHMENT_UPLOAD',
        date: subDays(new Date(), 15).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 525,
        roomId: 4,
        userId: 10,
        subUserId: 11,
        eventId: 2177,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 15).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 523,
        roomId: 4,
        userId: 10,
        subUserId: 11,
        eventId: 2175,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 15).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 522,
        roomId: 5,
        userId: 9,
        subUserId: null,
        eventId: 2174,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 15).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 5,
            title: '[Cart2Cart] Journal Feedback',
            slugId: 'AAAA6AlE3c0',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 521,
        roomId: 5,
        userId: 9,
        subUserId: null,
        eventId: 2173,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 15).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 5,
            title: '[Cart2Cart] Journal Feedback',
            slugId: 'AAAA6AlE3c0',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 520,
        roomId: 4,
        userId: 11,
        subUserId: null,
        eventId: 2172,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 15).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 519,
        roomId: 4,
        userId: 11,
        subUserId: 10,
        eventId: 2171,
        workspaceId: 6,
        action: 'CHAT_REACTION_ADDED',
        date: subDays(new Date(), 15).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 518,
        roomId: 4,
        userId: 11,
        subUserId: null,
        eventId: 2170,
        workspaceId: 6,
        action: 'CHAT_ATTACHMENT_DOWNLOAD',
        date: subDays(new Date(), 15).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 516,
        roomId: 1,
        userId: 11,
        subUserId: 9,
        eventId: 2168,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 15).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 517,
        roomId: 1,
        userId: 11,
        subUserId: 9,
        eventId: 2169,
        workspaceId: 6,
        action: 'CHAT_ATTACHMENT_UPLOAD',
        date: subDays(new Date(), 15).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 515,
        roomId: 1,
        userId: 11,
        subUserId: 9,
        eventId: 2167,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 15).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 514,
        roomId: 1,
        userId: 11,
        subUserId: 9,
        eventId: 2166,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 15).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 513,
        roomId: 1,
        userId: 11,
        subUserId: 9,
        eventId: 2163,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 15).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 512,
        roomId: 1,
        userId: 11,
        subUserId: 9,
        eventId: 2162,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 15).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 511,
        roomId: 11,
        userId: 9,
        subUserId: null,
        eventId: 2132,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 15).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 11,
            title: 'Default Chat',
            slugId: '15wvrcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_APP_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 510,
        roomId: 1,
        userId: 9,
        subUserId: null,
        eventId: 2131,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 15).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 509,
        roomId: 1,
        userId: 9,
        subUserId: 11,
        eventId: 2130,
        workspaceId: 6,
        action: 'CHAT_REACTION_ADDED',
        date: subDays(new Date(), 15).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 508,
        roomId: 1,
        userId: 9,
        subUserId: 11,
        eventId: 2129,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 15).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 507,
        roomId: 1,
        userId: 11,
        subUserId: null,
        eventId: 2117,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 15).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 506,
        roomId: 9,
        userId: 3,
        subUserId: null,
        eventId: 1838,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 14).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 9,
            title: 'developers',
            slugId: 'AAAAqNofp2Q',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 505,
        roomId: 9,
        userId: 1,
        subUserId: null,
        eventId: 1837,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 14).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 9,
            title: 'developers',
            slugId: 'AAAAqNofp2Q',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 504,
        roomId: 9,
        userId: 1,
        subUserId: null,
        eventId: 1836,
        workspaceId: 6,
        action: 'CHAT_REACTION_ADDED',
        date: subDays(new Date(), 14).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 9,
            title: 'developers',
            slugId: 'AAAAqNofp2Q',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 503,
        roomId: 9,
        userId: 9,
        subUserId: null,
        eventId: 1835,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 14).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 9,
            title: 'developers',
            slugId: 'AAAAqNofp2Q',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 502,
        roomId: 9,
        userId: 9,
        subUserId: null,
        eventId: 1834,
        workspaceId: 6,
        action: 'CHAT_REACTION_ADDED',
        date: subDays(new Date(), 14).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 9,
            title: 'developers',
            slugId: 'AAAAqNofp2Q',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 501,
        roomId: 9,
        userId: 7,
        subUserId: null,
        eventId: 1833,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 14).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 9,
            title: 'developers',
            slugId: 'AAAAqNofp2Q',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 500,
        roomId: 9,
        userId: 7,
        subUserId: null,
        eventId: 1832,
        workspaceId: 6,
        action: 'CHAT_REACTION_ADDED',
        date: subDays(new Date(), 14).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 9,
            title: 'developers',
            slugId: 'AAAAqNofp2Q',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 499,
        roomId: 10,
        userId: 1,
        subUserId: 3,
        eventId: 1831,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 14).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 10,
            title: 'Default Chat',
            slugId: '09ux9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 498,
        roomId: 10,
        userId: 3,
        subUserId: null,
        eventId: 1830,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 14).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 10,
            title: 'Default Chat',
            slugId: '09ux9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 497,
        roomId: 10,
        userId: 3,
        subUserId: 1,
        eventId: 1829,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 14).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 10,
            title: 'Default Chat',
            slugId: '09ux9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 496,
        roomId: 10,
        userId: 1,
        subUserId: null,
        eventId: 1828,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 14).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 10,
            title: 'Default Chat',
            slugId: '09ux9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 495,
        roomId: 10,
        userId: 1,
        subUserId: 3,
        eventId: 1827,
        workspaceId: 6,
        action: 'CHAT_REACTION_ADDED',
        date: subDays(new Date(), 14).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 10,
            title: 'Default Chat',
            slugId: '09ux9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 494,
        roomId: 9,
        userId: 9,
        subUserId: null,
        eventId: 1826,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 14).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 9,
            title: 'developers',
            slugId: 'AAAAqNofp2Q',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 493,
        roomId: 9,
        userId: 3,
        subUserId: null,
        eventId: 1819,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 14).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 9,
            title: 'developers',
            slugId: 'AAAAqNofp2Q',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 492,
        roomId: 9,
        userId: 3,
        subUserId: null,
        eventId: 1818,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 14).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 9,
            title: 'developers',
            slugId: 'AAAAqNofp2Q',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 491,
        roomId: 9,
        userId: 9,
        subUserId: null,
        eventId: 1817,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 14).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 9,
            title: 'developers',
            slugId: 'AAAAqNofp2Q',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 490,
        roomId: 9,
        userId: 9,
        subUserId: null,
        eventId: 1816,
        workspaceId: 6,
        action: 'CHAT_REACTION_ADDED',
        date: subDays(new Date(), 14).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 9,
            title: 'developers',
            slugId: 'AAAAqNofp2Q',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 489,
        roomId: 9,
        userId: 3,
        subUserId: null,
        eventId: 1815,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 14).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 9,
            title: 'developers',
            slugId: 'AAAAqNofp2Q',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 488,
        roomId: 9,
        userId: 3,
        subUserId: null,
        eventId: 1814,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 14).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 9,
            title: 'developers',
            slugId: 'AAAAqNofp2Q',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 487,
        roomId: 9,
        userId: 1,
        subUserId: null,
        eventId: 1813,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 14).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 9,
            title: 'developers',
            slugId: 'AAAAqNofp2Q',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 486,
        roomId: 9,
        userId: 9,
        subUserId: null,
        eventId: 1812,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 14).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 9,
            title: 'developers',
            slugId: 'AAAAqNofp2Q',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 485,
        roomId: 3,
        userId: 9,
        subUserId: null,
        eventId: 1811,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 14).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 484,
        roomId: 3,
        userId: 9,
        subUserId: null,
        eventId: 1810,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 14).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 483,
        roomId: 3,
        userId: 11,
        subUserId: null,
        eventId: 1809,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 14).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 482,
        roomId: 3,
        userId: 11,
        subUserId: null,
        eventId: 1808,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 14).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 481,
        roomId: 5,
        userId: 9,
        subUserId: null,
        eventId: 1807,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 14).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 5,
            title: '[Cart2Cart] Journal Feedback',
            slugId: 'AAAA6AlE3c0',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 480,
        roomId: 5,
        userId: 11,
        subUserId: null,
        eventId: 1806,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 14).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 5,
            title: '[Cart2Cart] Journal Feedback',
            slugId: 'AAAA6AlE3c0',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 479,
        roomId: 5,
        userId: 11,
        subUserId: null,
        eventId: 1805,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 14).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 5,
            title: '[Cart2Cart] Journal Feedback',
            slugId: 'AAAA6AlE3c0',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 478,
        roomId: 5,
        userId: 9,
        subUserId: null,
        eventId: 1804,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 14).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 5,
            title: '[Cart2Cart] Journal Feedback',
            slugId: 'AAAA6AlE3c0',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 477,
        roomId: 1,
        userId: 11,
        subUserId: 9,
        eventId: 1803,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 14).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 476,
        roomId: 1,
        userId: 9,
        subUserId: null,
        eventId: 1802,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 14).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 475,
        roomId: 1,
        userId: 11,
        subUserId: 9,
        eventId: 1801,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 14).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 474,
        roomId: 1,
        userId: 9,
        subUserId: null,
        eventId: 1800,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 14).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 473,
        roomId: 1,
        userId: 11,
        subUserId: 9,
        eventId: 1799,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 14).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 472,
        roomId: 1,
        userId: 9,
        subUserId: null,
        eventId: 1798,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 14).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 471,
        roomId: 1,
        userId: 9,
        subUserId: 11,
        eventId: 1797,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 14).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 470,
        roomId: 1,
        userId: 11,
        subUserId: null,
        eventId: 1796,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 14).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 469,
        roomId: 1,
        userId: 11,
        subUserId: null,
        eventId: 1795,
        workspaceId: 6,
        action: 'CHAT_REACTION_ADDED',
        date: subDays(new Date(), 14).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 468,
        roomId: 5,
        userId: 9,
        subUserId: null,
        eventId: 1794,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 14).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 5,
            title: '[Cart2Cart] Journal Feedback',
            slugId: 'AAAA6AlE3c0',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 467,
        roomId: 5,
        userId: 11,
        subUserId: null,
        eventId: 1793,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 14).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 5,
            title: '[Cart2Cart] Journal Feedback',
            slugId: 'AAAA6AlE3c0',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 466,
        roomId: 5,
        userId: 11,
        subUserId: null,
        eventId: 1792,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 14).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 5,
            title: '[Cart2Cart] Journal Feedback',
            slugId: 'AAAA6AlE3c0',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 465,
        roomId: 5,
        userId: 9,
        subUserId: null,
        eventId: 1791,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 14).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 5,
            title: '[Cart2Cart] Journal Feedback',
            slugId: 'AAAA6AlE3c0',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 464,
        roomId: 6,
        userId: 11,
        subUserId: 1,
        eventId: 1790,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 14).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 463,
        roomId: 6,
        userId: 11,
        subUserId: 1,
        eventId: 1789,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 14).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 462,
        roomId: 6,
        userId: 1,
        subUserId: null,
        eventId: 1779,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 14).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 461,
        roomId: 6,
        userId: 1,
        subUserId: 11,
        eventId: 1778,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 14).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 460,
        roomId: 6,
        userId: 11,
        subUserId: null,
        eventId: 1752,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 14).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 458,
        roomId: 1,
        userId: 9,
        subUserId: 11,
        eventId: 1690,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 14).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 459,
        roomId: 1,
        userId: 9,
        subUserId: 11,
        eventId: 1691,
        workspaceId: 6,
        action: 'CHAT_ATTACHMENT_UPLOAD',
        date: subDays(new Date(), 14).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 457,
        roomId: 1,
        userId: 11,
        subUserId: null,
        eventId: 1679,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 14).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 456,
        roomId: 1,
        userId: 11,
        subUserId: 9,
        eventId: 1678,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 14).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 455,
        roomId: 1,
        userId: 11,
        subUserId: 9,
        eventId: 1677,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 14).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 453,
        roomId: 6,
        userId: 1,
        subUserId: 11,
        eventId: 1675,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 14).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 454,
        roomId: 6,
        userId: 1,
        subUserId: 11,
        eventId: 1676,
        workspaceId: 6,
        action: 'CHAT_ATTACHMENT_UPLOAD',
        date: subDays(new Date(), 14).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 452,
        roomId: 6,
        userId: 11,
        subUserId: null,
        eventId: 1674,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 14).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 451,
        roomId: 6,
        userId: 11,
        subUserId: 1,
        eventId: 1673,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 14).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 450,
        roomId: 6,
        userId: 11,
        subUserId: 1,
        eventId: 1672,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 14).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 449,
        roomId: 6,
        userId: 11,
        subUserId: 1,
        eventId: 1671,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 14).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 448,
        roomId: 6,
        userId: 1,
        subUserId: null,
        eventId: 1670,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 14).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 446,
        roomId: 6,
        userId: 1,
        subUserId: 11,
        eventId: 1668,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 14).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 447,
        roomId: 6,
        userId: 1,
        subUserId: 11,
        eventId: 1669,
        workspaceId: 6,
        action: 'CHAT_ATTACHMENT_UPLOAD',
        date: subDays(new Date(), 14).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 445,
        roomId: 6,
        userId: 11,
        subUserId: null,
        eventId: 1667,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 14).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 444,
        roomId: 6,
        userId: 1,
        subUserId: 11,
        eventId: 1666,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 14).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 443,
        roomId: 6,
        userId: 11,
        subUserId: null,
        eventId: 1665,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 14).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 442,
        roomId: 6,
        userId: 11,
        subUserId: 1,
        eventId: 1664,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 14).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 441,
        roomId: 6,
        userId: 1,
        subUserId: null,
        eventId: 1663,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 14).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 440,
        roomId: 6,
        userId: 11,
        subUserId: 1,
        eventId: 1662,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 14).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 439,
        roomId: 6,
        userId: 1,
        subUserId: null,
        eventId: 1661,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 14).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 438,
        roomId: 6,
        userId: 1,
        subUserId: 11,
        eventId: 1660,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 14).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 436,
        roomId: 6,
        userId: 1,
        subUserId: 11,
        eventId: 1658,
        workspaceId: 6,
        action: 'CHAT_ATTACHMENT_UPLOAD',
        date: subDays(new Date(), 14).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 437,
        roomId: 6,
        userId: 1,
        subUserId: 11,
        eventId: 1659,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 14).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 435,
        roomId: 6,
        userId: 11,
        subUserId: null,
        eventId: 1657,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 14).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 434,
        roomId: 6,
        userId: 11,
        subUserId: 1,
        eventId: 1656,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 14).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 433,
        roomId: 6,
        userId: 11,
        subUserId: 1,
        eventId: 1655,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 14).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 432,
        roomId: 6,
        userId: 1,
        subUserId: null,
        eventId: 1654,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 14).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 431,
        roomId: 6,
        userId: 11,
        subUserId: 1,
        eventId: 1653,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 14).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 430,
        roomId: 6,
        userId: 1,
        subUserId: null,
        eventId: 1652,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 14).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 429,
        roomId: 6,
        userId: 11,
        subUserId: 1,
        eventId: 1651,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 14).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 428,
        roomId: 6,
        userId: 1,
        subUserId: null,
        eventId: 1650,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 14).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 427,
        roomId: 6,
        userId: 1,
        subUserId: null,
        eventId: 1649,
        workspaceId: 6,
        action: 'CHAT_REACTION_ADDED',
        date: subDays(new Date(), 14).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 426,
        roomId: 1,
        userId: 9,
        subUserId: null,
        eventId: 1648,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 14).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 425,
        roomId: 5,
        userId: 11,
        subUserId: null,
        eventId: 1647,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 14).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 5,
            title: '[Cart2Cart] Journal Feedback',
            slugId: 'AAAA6AlE3c0',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 424,
        roomId: 5,
        userId: 11,
        subUserId: null,
        eventId: 1646,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 14).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 5,
            title: '[Cart2Cart] Journal Feedback',
            slugId: 'AAAA6AlE3c0',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 423,
        roomId: 5,
        userId: 9,
        subUserId: null,
        eventId: 1645,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 14).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 5,
            title: '[Cart2Cart] Journal Feedback',
            slugId: 'AAAA6AlE3c0',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 422,
        roomId: 5,
        userId: 9,
        subUserId: null,
        eventId: 1644,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 14).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 5,
            title: '[Cart2Cart] Journal Feedback',
            slugId: 'AAAA6AlE3c0',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 421,
        roomId: 1,
        userId: 9,
        subUserId: 11,
        eventId: 1643,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 14).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 420,
        roomId: 1,
        userId: 11,
        subUserId: null,
        eventId: 1642,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 14).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 419,
        roomId: 3,
        userId: 9,
        subUserId: null,
        eventId: 1635,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 13).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 418,
        roomId: 5,
        userId: 9,
        subUserId: null,
        eventId: 1634,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 13).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 5,
            title: '[Cart2Cart] Journal Feedback',
            slugId: 'AAAA6AlE3c0',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 417,
        roomId: 1,
        userId: 9,
        subUserId: 11,
        eventId: 1633,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 13).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 416,
        roomId: 1,
        userId: 11,
        subUserId: null,
        eventId: 1632,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 13).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 415,
        roomId: 1,
        userId: 11,
        subUserId: 9,
        eventId: 1631,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 13).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 414,
        roomId: 1,
        userId: 11,
        subUserId: 9,
        eventId: 1630,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 13).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 413,
        roomId: 1,
        userId: 9,
        subUserId: null,
        eventId: 1629,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 13).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 412,
        roomId: 1,
        userId: 9,
        subUserId: null,
        eventId: 1628,
        workspaceId: 6,
        action: 'CHAT_REACTION_ADDED',
        date: subDays(new Date(), 13).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 411,
        roomId: 5,
        userId: 11,
        subUserId: null,
        eventId: 1627,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 13).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 5,
            title: '[Cart2Cart] Journal Feedback',
            slugId: 'AAAA6AlE3c0',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 410,
        roomId: 10,
        userId: 3,
        subUserId: 1,
        eventId: 1620,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 13).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 10,
            title: 'Default Chat',
            slugId: '09ux9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 409,
        roomId: 5,
        userId: 11,
        subUserId: null,
        eventId: 1619,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 13).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 5,
            title: '[Cart2Cart] Journal Feedback',
            slugId: 'AAAA6AlE3c0',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 408,
        roomId: 5,
        userId: 11,
        subUserId: null,
        eventId: 1618,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 13).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 5,
            title: '[Cart2Cart] Journal Feedback',
            slugId: 'AAAA6AlE3c0',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 407,
        roomId: 3,
        userId: 11,
        subUserId: null,
        eventId: 1616,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 13).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 406,
        roomId: 7,
        userId: 9,
        subUserId: null,
        eventId: 1615,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 13).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 7,
            title: '[Cart2Cart] ETL',
            slugId: 'AAAArpJpqHw',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 405,
        roomId: 3,
        userId: 9,
        subUserId: null,
        eventId: 1614,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 13).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 404,
        roomId: 5,
        userId: 11,
        subUserId: null,
        eventId: 1613,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 13).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 5,
            title: '[Cart2Cart] Journal Feedback',
            slugId: 'AAAA6AlE3c0',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 403,
        roomId: 3,
        userId: 11,
        subUserId: null,
        eventId: 1612,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 13).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 402,
        roomId: 3,
        userId: 11,
        subUserId: null,
        eventId: 1611,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 13).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 401,
        roomId: 3,
        userId: 11,
        subUserId: null,
        eventId: 1610,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 13).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 400,
        roomId: 3,
        userId: 11,
        subUserId: null,
        eventId: 1609,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 13).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 399,
        roomId: 3,
        userId: 11,
        subUserId: null,
        eventId: 1608,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 13).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 398,
        roomId: 3,
        userId: 11,
        subUserId: null,
        eventId: 1607,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 13).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 397,
        roomId: 3,
        userId: 11,
        subUserId: null,
        eventId: 1606,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 13).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 396,
        roomId: 3,
        userId: 11,
        subUserId: null,
        eventId: 1605,
        workspaceId: 6,
        action: 'CHAT_REACTION_ADDED',
        date: subDays(new Date(), 13).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 395,
        roomId: 10,
        userId: 1,
        subUserId: null,
        eventId: 1602,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 13).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 10,
            title: 'Default Chat',
            slugId: '09ux9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 394,
        roomId: 10,
        userId: 1,
        subUserId: 3,
        eventId: 1601,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 13).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 10,
            title: 'Default Chat',
            slugId: '09ux9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 393,
        roomId: 6,
        userId: 11,
        subUserId: 1,
        eventId: 1589,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 13).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 392,
        roomId: 6,
        userId: 11,
        subUserId: 1,
        eventId: 1588,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 13).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 391,
        roomId: 6,
        userId: 1,
        subUserId: null,
        eventId: 1586,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 13).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 390,
        roomId: 6,
        userId: 1,
        subUserId: 11,
        eventId: 1585,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 13).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 388,
        roomId: 6,
        userId: 1,
        subUserId: 11,
        eventId: 1583,
        workspaceId: 6,
        action: 'CHAT_ATTACHMENT_UPLOAD',
        date: subDays(new Date(), 13).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 389,
        roomId: 6,
        userId: 1,
        subUserId: 11,
        eventId: 1584,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 13).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 387,
        roomId: 6,
        userId: 11,
        subUserId: null,
        eventId: 1582,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 13).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 386,
        roomId: 6,
        userId: 11,
        subUserId: 1,
        eventId: 1581,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 13).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 385,
        roomId: 6,
        userId: 1,
        subUserId: null,
        eventId: 1580,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 13).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 384,
        roomId: 6,
        userId: 11,
        subUserId: 1,
        eventId: 1579,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 13).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 383,
        roomId: 6,
        userId: 1,
        subUserId: null,
        eventId: 1578,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 13).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 382,
        roomId: 6,
        userId: 11,
        subUserId: 1,
        eventId: 1577,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 13).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 381,
        roomId: 6,
        userId: 1,
        subUserId: null,
        eventId: 1576,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 13).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 379,
        roomId: 6,
        userId: 1,
        subUserId: 11,
        eventId: 1574,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 13).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 380,
        roomId: 6,
        userId: 1,
        subUserId: 11,
        eventId: 1575,
        workspaceId: 6,
        action: 'CHAT_ATTACHMENT_UPLOAD',
        date: subDays(new Date(), 13).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 378,
        roomId: 6,
        userId: 1,
        subUserId: 11,
        eventId: 1573,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 13).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 377,
        roomId: 6,
        userId: 11,
        subUserId: null,
        eventId: 1572,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 13).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 376,
        roomId: 10,
        userId: 3,
        subUserId: null,
        eventId: 1503,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 13).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 10,
            title: 'Default Chat',
            slugId: '09ux9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 375,
        roomId: 6,
        userId: 11,
        subUserId: null,
        eventId: 1491,
        workspaceId: 6,
        action: 'CHAT_REACTION_ADDED',
        date: subDays(new Date(), 13).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 374,
        roomId: 6,
        userId: 11,
        subUserId: 1,
        eventId: 1490,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 13).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 373,
        roomId: 6,
        userId: 11,
        subUserId: 1,
        eventId: 1489,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_EDITED',
        date: subDays(new Date(), 13).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 372,
        roomId: 6,
        userId: 1,
        subUserId: null,
        eventId: 1488,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 13).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 371,
        roomId: 6,
        userId: 1,
        subUserId: 11,
        eventId: 1487,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 13).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 370,
        roomId: 6,
        userId: 1,
        subUserId: 11,
        eventId: 1486,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_EDITED',
        date: subDays(new Date(), 13).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 369,
        roomId: 9,
        userId: 1,
        subUserId: null,
        eventId: 1485,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 13).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 9,
            title: 'developers',
            slugId: 'AAAAqNofp2Q',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 368,
        roomId: 3,
        userId: 9,
        subUserId: null,
        eventId: 1484,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 12).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 367,
        roomId: 3,
        userId: 11,
        subUserId: null,
        eventId: 1483,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 12).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 366,
        roomId: 9,
        userId: 9,
        subUserId: null,
        eventId: 1482,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 12).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 9,
            title: 'developers',
            slugId: 'AAAAqNofp2Q',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 365,
        roomId: 3,
        userId: 11,
        subUserId: null,
        eventId: 1481,
        workspaceId: 6,
        action: 'CHAT_REACTION_ADDED',
        date: subDays(new Date(), 12).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 364,
        roomId: 3,
        userId: 11,
        subUserId: null,
        eventId: 1480,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 12).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 363,
        roomId: 3,
        userId: 9,
        subUserId: null,
        eventId: 1479,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 12).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 362,
        roomId: 3,
        userId: 11,
        subUserId: null,
        eventId: 1478,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 12).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 361,
        roomId: 3,
        userId: 9,
        subUserId: null,
        eventId: 1477,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 12).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 360,
        roomId: 3,
        userId: 9,
        subUserId: null,
        eventId: 1476,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 12).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 359,
        roomId: 3,
        userId: 9,
        subUserId: null,
        eventId: 1475,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 12).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 358,
        roomId: 3,
        userId: 11,
        subUserId: null,
        eventId: 1474,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 12).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 357,
        roomId: 3,
        userId: 9,
        subUserId: null,
        eventId: 1473,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 12).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 356,
        roomId: 3,
        userId: 9,
        subUserId: null,
        eventId: 1472,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 12).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 355,
        roomId: 3,
        userId: 11,
        subUserId: null,
        eventId: 1471,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 12).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 354,
        roomId: 6,
        userId: 11,
        subUserId: null,
        eventId: 1470,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 12).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 353,
        roomId: 3,
        userId: 9,
        subUserId: null,
        eventId: 1469,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 12).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 352,
        roomId: 3,
        userId: 9,
        subUserId: null,
        eventId: 1468,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 12).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 351,
        roomId: 3,
        userId: 9,
        subUserId: null,
        eventId: 1467,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 12).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 350,
        roomId: 3,
        userId: 9,
        subUserId: null,
        eventId: 1466,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 12).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 349,
        roomId: 3,
        userId: 9,
        subUserId: null,
        eventId: 1465,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 12).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 348,
        roomId: 9,
        userId: 3,
        subUserId: null,
        eventId: 1464,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 12).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 9,
            title: 'developers',
            slugId: 'AAAAqNofp2Q',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 347,
        roomId: 3,
        userId: 11,
        subUserId: null,
        eventId: 1463,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 12).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 346,
        roomId: 3,
        userId: 11,
        subUserId: null,
        eventId: 1462,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 12).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 345,
        roomId: 9,
        userId: 3,
        subUserId: null,
        eventId: 1461,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 12).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 9,
            title: 'developers',
            slugId: 'AAAAqNofp2Q',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 344,
        roomId: 9,
        userId: 9,
        subUserId: null,
        eventId: 1460,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 12).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 9,
            title: 'developers',
            slugId: 'AAAAqNofp2Q',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 343,
        roomId: 9,
        userId: 9,
        subUserId: null,
        eventId: 1459,
        workspaceId: 6,
        action: 'CHAT_REACTION_ADDED',
        date: subDays(new Date(), 12).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 9,
            title: 'developers',
            slugId: 'AAAAqNofp2Q',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 342,
        roomId: 9,
        userId: 1,
        subUserId: null,
        eventId: 1458,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 12).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 9,
            title: 'developers',
            slugId: 'AAAAqNofp2Q',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 341,
        roomId: 3,
        userId: 11,
        subUserId: null,
        eventId: 1457,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 12).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 340,
        roomId: 3,
        userId: 9,
        subUserId: null,
        eventId: 1456,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 12).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 339,
        roomId: 3,
        userId: 11,
        subUserId: null,
        eventId: 1455,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 12).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 338,
        roomId: 3,
        userId: 9,
        subUserId: null,
        eventId: 1453,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 12).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 337,
        roomId: 1,
        userId: 9,
        subUserId: 11,
        eventId: 1443,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 12).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 336,
        roomId: 1,
        userId: 11,
        subUserId: null,
        eventId: 1442,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 12).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 335,
        roomId: 1,
        userId: 11,
        subUserId: 9,
        eventId: 1441,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 12).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 334,
        roomId: 1,
        userId: 9,
        subUserId: null,
        eventId: 1440,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 12).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 333,
        roomId: 1,
        userId: 11,
        subUserId: 9,
        eventId: 1439,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 12).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 332,
        roomId: 1,
        userId: 9,
        subUserId: null,
        eventId: 1438,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 12).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 331,
        roomId: 1,
        userId: 11,
        subUserId: 9,
        eventId: 1437,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 12).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 330,
        roomId: 1,
        userId: 9,
        subUserId: null,
        eventId: 1436,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 12).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 328,
        roomId: 1,
        userId: 9,
        subUserId: 11,
        eventId: 1434,
        workspaceId: 6,
        action: 'CHAT_ATTACHMENT_UPLOAD',
        date: subDays(new Date(), 12).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 329,
        roomId: 1,
        userId: 9,
        subUserId: 11,
        eventId: 1435,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 12).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 327,
        roomId: 1,
        userId: 11,
        subUserId: null,
        eventId: 1433,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 12).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 326,
        roomId: 1,
        userId: 11,
        subUserId: 9,
        eventId: 1432,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 12).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 325,
        roomId: 1,
        userId: 9,
        subUserId: null,
        eventId: 1431,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 12).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 324,
        roomId: 1,
        userId: 9,
        subUserId: 11,
        eventId: 1430,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 12).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 323,
        roomId: 1,
        userId: 9,
        subUserId: 11,
        eventId: 1429,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 12).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 322,
        roomId: 1,
        userId: 11,
        subUserId: null,
        eventId: 1428,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 12).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 321,
        roomId: 1,
        userId: 11,
        subUserId: null,
        eventId: 1427,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 12).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 320,
        roomId: 1,
        userId: 11,
        subUserId: 9,
        eventId: 1426,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 12).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 319,
        roomId: 1,
        userId: 9,
        subUserId: null,
        eventId: 1425,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 12).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 318,
        roomId: 1,
        userId: 11,
        subUserId: 9,
        eventId: 1424,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 12).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 317,
        roomId: 1,
        userId: 9,
        subUserId: null,
        eventId: 1423,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 12).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 316,
        roomId: 1,
        userId: 9,
        subUserId: 11,
        eventId: 1422,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 12).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 315,
        roomId: 1,
        userId: 11,
        subUserId: null,
        eventId: 1421,
        workspaceId: 6,
        action: 'CHAT_REACTION_ADDED',
        date: subDays(new Date(), 12).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 314,
        roomId: 1,
        userId: 11,
        subUserId: null,
        eventId: 1420,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 12).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 313,
        roomId: 1,
        userId: 11,
        subUserId: 9,
        eventId: 1419,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 12).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 312,
        roomId: 1,
        userId: 9,
        subUserId: null,
        eventId: 1418,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 12).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 311,
        roomId: 9,
        userId: 1,
        subUserId: null,
        eventId: 1417,
        workspaceId: 6,
        action: 'CHAT_REACTION_ADDED',
        date: subDays(new Date(), 12).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 9,
            title: 'developers',
            slugId: 'AAAAqNofp2Q',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 310,
        roomId: 9,
        userId: 7,
        subUserId: null,
        eventId: 1416,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 12).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 9,
            title: 'developers',
            slugId: 'AAAAqNofp2Q',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 309,
        roomId: 7,
        userId: 11,
        subUserId: null,
        eventId: 1415,
        workspaceId: 6,
        action: 'CHAT_REACTION_ADDED',
        date: subDays(new Date(), 12).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 7,
            title: '[Cart2Cart] ETL',
            slugId: 'AAAArpJpqHw',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 308,
        roomId: 7,
        userId: 11,
        subUserId: null,
        eventId: 1414,
        workspaceId: 6,
        action: 'CHAT_REACTION_ADDED',
        date: subDays(new Date(), 12).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 7,
            title: '[Cart2Cart] ETL',
            slugId: 'AAAArpJpqHw',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 307,
        roomId: 7,
        userId: 11,
        subUserId: null,
        eventId: 1413,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 12).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 7,
            title: '[Cart2Cart] ETL',
            slugId: 'AAAArpJpqHw',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 306,
        roomId: 7,
        userId: 9,
        subUserId: null,
        eventId: 1379,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 12).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 7,
            title: '[Cart2Cart] ETL',
            slugId: 'AAAArpJpqHw',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 305,
        roomId: 3,
        userId: 9,
        subUserId: null,
        eventId: 1378,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 12).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 304,
        roomId: 3,
        userId: 9,
        subUserId: null,
        eventId: 1377,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 12).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 303,
        roomId: 3,
        userId: 11,
        subUserId: null,
        eventId: 1376,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 12).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 302,
        roomId: 3,
        userId: 11,
        subUserId: null,
        eventId: 1375,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 12).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 301,
        roomId: 3,
        userId: 11,
        subUserId: null,
        eventId: 1374,
        workspaceId: 6,
        action: 'CHAT_REACTION_ADDED',
        date: subDays(new Date(), 12).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 300,
        roomId: 3,
        userId: 11,
        subUserId: null,
        eventId: 1373,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 12).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 299,
        roomId: 3,
        userId: 9,
        subUserId: null,
        eventId: 1372,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 12).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 298,
        roomId: 3,
        userId: 9,
        subUserId: null,
        eventId: 1371,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 12).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 297,
        roomId: 3,
        userId: 9,
        subUserId: null,
        eventId: 1370,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 12).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 296,
        roomId: 3,
        userId: 9,
        subUserId: null,
        eventId: 1369,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 12).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 295,
        roomId: 3,
        userId: 9,
        subUserId: null,
        eventId: 1368,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 12).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 294,
        roomId: 3,
        userId: 9,
        subUserId: null,
        eventId: 1367,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 12).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 293,
        roomId: 3,
        userId: 9,
        subUserId: null,
        eventId: 1366,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 12).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 292,
        roomId: 3,
        userId: 9,
        subUserId: null,
        eventId: 1365,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 12).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 291,
        roomId: 3,
        userId: 9,
        subUserId: null,
        eventId: 1364,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 12).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 290,
        roomId: 3,
        userId: 9,
        subUserId: null,
        eventId: 1363,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 12).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 289,
        roomId: 3,
        userId: 9,
        subUserId: null,
        eventId: 1362,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 12).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 288,
        roomId: 3,
        userId: 9,
        subUserId: null,
        eventId: 1361,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 12).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 285,
        roomId: 3,
        userId: 9,
        subUserId: null,
        eventId: 1358,
        workspaceId: 6,
        action: 'CHAT_ATTACHMENT_UPLOAD',
        date: subDays(new Date(), 12).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 286,
        roomId: 3,
        userId: 9,
        subUserId: null,
        eventId: 1359,
        workspaceId: 6,
        action: 'CHAT_ATTACHMENT_UPLOAD',
        date: subDays(new Date(), 12).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 287,
        roomId: 3,
        userId: 9,
        subUserId: null,
        eventId: 1360,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 12).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 284,
        roomId: 3,
        userId: 9,
        subUserId: null,
        eventId: 1357,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 12).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 283,
        roomId: 3,
        userId: 9,
        subUserId: null,
        eventId: 1356,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 12).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 282,
        roomId: 3,
        userId: 9,
        subUserId: null,
        eventId: 1355,
        workspaceId: 6,
        action: 'CHAT_REACTION_ADDED',
        date: subDays(new Date(), 12).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 281,
        roomId: 3,
        userId: 11,
        subUserId: null,
        eventId: 1354,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 12).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 280,
        roomId: 3,
        userId: 11,
        subUserId: null,
        eventId: 1353,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 12).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 279,
        roomId: 3,
        userId: 11,
        subUserId: null,
        eventId: 1352,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 12).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 278,
        roomId: 3,
        userId: 9,
        subUserId: null,
        eventId: 1351,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 12).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 276,
        roomId: 1,
        userId: 9,
        subUserId: 11,
        eventId: 1344,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 11).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 277,
        roomId: 1,
        userId: 9,
        subUserId: 11,
        eventId: 1345,
        workspaceId: 6,
        action: 'CHAT_ATTACHMENT_UPLOAD',
        date: subDays(new Date(), 11).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 275,
        roomId: 1,
        userId: 11,
        subUserId: null,
        eventId: 1343,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 11).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 274,
        roomId: 1,
        userId: 9,
        subUserId: 11,
        eventId: 1342,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 11).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 273,
        roomId: 1,
        userId: 11,
        subUserId: null,
        eventId: 1341,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 11).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 272,
        roomId: 1,
        userId: 9,
        subUserId: 11,
        eventId: 1340,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 11).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 271,
        roomId: 1,
        userId: 11,
        subUserId: 9,
        eventId: 1339,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 11).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 270,
        roomId: 1,
        userId: 9,
        subUserId: null,
        eventId: 1338,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 11).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 269,
        roomId: 1,
        userId: 11,
        subUserId: null,
        eventId: 1337,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 11).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 268,
        roomId: 1,
        userId: 9,
        subUserId: null,
        eventId: 1336,
        workspaceId: 6,
        action: 'CHAT_REACTION_ADDED',
        date: subDays(new Date(), 11).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 267,
        roomId: 1,
        userId: 11,
        subUserId: 9,
        eventId: 1335,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 11).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 266,
        roomId: 1,
        userId: 9,
        subUserId: null,
        eventId: 1334,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 11).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 265,
        roomId: 1,
        userId: 11,
        subUserId: 9,
        eventId: 1333,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_EDITED',
        date: subDays(new Date(), 11).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 264,
        roomId: 1,
        userId: 9,
        subUserId: 11,
        eventId: 1332,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 11).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 263,
        roomId: 1,
        userId: 9,
        subUserId: 11,
        eventId: 1331,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 11).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 262,
        roomId: 1,
        userId: 9,
        subUserId: 11,
        eventId: 1330,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 11).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 261,
        roomId: 1,
        userId: 11,
        subUserId: null,
        eventId: 1329,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 11).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 260,
        roomId: 1,
        userId: 11,
        subUserId: 9,
        eventId: 1328,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 11).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 259,
        roomId: 1,
        userId: 11,
        subUserId: 9,
        eventId: 1327,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 11).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 258,
        roomId: 1,
        userId: 11,
        subUserId: null,
        eventId: 1326,
        workspaceId: 6,
        action: 'CHAT_REACTION_ADDED',
        date: subDays(new Date(), 11).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 257,
        roomId: 1,
        userId: 9,
        subUserId: null,
        eventId: 1325,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 11).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 256,
        roomId: 1,
        userId: 9,
        subUserId: 11,
        eventId: 1324,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 11).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 255,
        roomId: 1,
        userId: 11,
        subUserId: null,
        eventId: 1323,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 11).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 254,
        roomId: 1,
        userId: 11,
        subUserId: 9,
        eventId: 1322,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 11).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 253,
        roomId: 1,
        userId: 9,
        subUserId: null,
        eventId: 1321,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 11).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 252,
        roomId: 1,
        userId: 11,
        subUserId: 9,
        eventId: 1320,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 11).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 251,
        roomId: 1,
        userId: 9,
        subUserId: null,
        eventId: 1319,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 11).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 250,
        roomId: 1,
        userId: 9,
        subUserId: 11,
        eventId: 1318,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 11).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 249,
        roomId: 1,
        userId: 11,
        subUserId: null,
        eventId: 1317,
        workspaceId: 6,
        action: 'CHAT_REACTION_ADDED',
        date: subDays(new Date(), 11).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 248,
        roomId: 1,
        userId: 11,
        subUserId: null,
        eventId: 1316,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 11).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 247,
        roomId: 1,
        userId: 11,
        subUserId: 9,
        eventId: 1315,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 11).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 246,
        roomId: 1,
        userId: 9,
        subUserId: null,
        eventId: 1314,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 11).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 245,
        roomId: 1,
        userId: 11,
        subUserId: 9,
        eventId: 1313,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 11).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 244,
        roomId: 1,
        userId: 9,
        subUserId: null,
        eventId: 1312,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 11).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 243,
        roomId: 1,
        userId: 11,
        subUserId: 9,
        eventId: 1311,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 11).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 242,
        roomId: 1,
        userId: 9,
        subUserId: null,
        eventId: 1310,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 11).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 241,
        roomId: 1,
        userId: 11,
        subUserId: 9,
        eventId: 1309,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 11).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 240,
        roomId: 1,
        userId: 9,
        subUserId: null,
        eventId: 1308,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 11).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 239,
        roomId: 1,
        userId: 11,
        subUserId: 9,
        eventId: 1307,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 11).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 238,
        roomId: 1,
        userId: 11,
        subUserId: 9,
        eventId: 1306,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 11).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 237,
        roomId: 1,
        userId: 9,
        subUserId: null,
        eventId: 1305,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 11).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 236,
        roomId: 1,
        userId: 9,
        subUserId: null,
        eventId: 1304,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 11).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 235,
        roomId: 1,
        userId: 9,
        subUserId: null,
        eventId: 1303,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 11).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 234,
        roomId: 1,
        userId: 9,
        subUserId: null,
        eventId: 1302,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 11).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 233,
        roomId: 1,
        userId: 9,
        subUserId: 11,
        eventId: 1301,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 11).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 232,
        roomId: 1,
        userId: 9,
        subUserId: 11,
        eventId: 1300,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 11).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 231,
        roomId: 1,
        userId: 11,
        subUserId: null,
        eventId: 1299,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 11).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 230,
        roomId: 1,
        userId: 11,
        subUserId: 9,
        eventId: 1298,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 11).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 229,
        roomId: 1,
        userId: 9,
        subUserId: null,
        eventId: 1297,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 11).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 228,
        roomId: 1,
        userId: 11,
        subUserId: 9,
        eventId: 1296,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 11).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 227,
        roomId: 1,
        userId: 9,
        subUserId: null,
        eventId: 1295,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 11).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 226,
        roomId: 1,
        userId: 9,
        subUserId: 11,
        eventId: 1294,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 11).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 225,
        roomId: 1,
        userId: 11,
        subUserId: null,
        eventId: 1293,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 11).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 224,
        roomId: 1,
        userId: 11,
        subUserId: 9,
        eventId: 1292,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 11).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 223,
        roomId: 1,
        userId: 9,
        subUserId: null,
        eventId: 1291,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 11).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 222,
        roomId: 1,
        userId: 11,
        subUserId: 9,
        eventId: 1290,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 11).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 221,
        roomId: 1,
        userId: 9,
        subUserId: null,
        eventId: 1289,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 11).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 220,
        roomId: 1,
        userId: 9,
        subUserId: null,
        eventId: 1288,
        workspaceId: 6,
        action: 'CHAT_REACTION_ADDED',
        date: subDays(new Date(), 11).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 218,
        roomId: 1,
        userId: 11,
        subUserId: 9,
        eventId: 1286,
        workspaceId: 6,
        action: 'CHAT_ATTACHMENT_UPLOAD',
        date: subDays(new Date(), 11).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 219,
        roomId: 1,
        userId: 11,
        subUserId: 9,
        eventId: 1287,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 11).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 217,
        roomId: 1,
        userId: 9,
        subUserId: null,
        eventId: 1285,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 11).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 216,
        roomId: 1,
        userId: 9,
        subUserId: 11,
        eventId: 1284,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 11).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 215,
        roomId: 1,
        userId: 11,
        subUserId: null,
        eventId: 1283,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 11).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 214,
        roomId: 1,
        userId: 11,
        subUserId: 9,
        eventId: 1282,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 11).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 213,
        roomId: 1,
        userId: 9,
        subUserId: null,
        eventId: 1281,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 11).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 212,
        roomId: 1,
        userId: 11,
        subUserId: 9,
        eventId: 1280,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 11).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 211,
        roomId: 1,
        userId: 9,
        subUserId: null,
        eventId: 1279,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 11).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 210,
        roomId: 1,
        userId: 11,
        subUserId: 9,
        eventId: 1278,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 11).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 209,
        roomId: 1,
        userId: 9,
        subUserId: null,
        eventId: 1277,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 11).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 208,
        roomId: 1,
        userId: 9,
        subUserId: 11,
        eventId: 1276,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 11).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 207,
        roomId: 1,
        userId: 9,
        subUserId: 11,
        eventId: 1275,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 11).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 206,
        roomId: 1,
        userId: 9,
        subUserId: 11,
        eventId: 1274,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 11).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 205,
        roomId: 1,
        userId: 11,
        subUserId: null,
        eventId: 1273,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 11).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 204,
        roomId: 1,
        userId: 11,
        subUserId: null,
        eventId: 1272,
        workspaceId: 6,
        action: 'CHAT_REACTION_ADDED',
        date: subDays(new Date(), 11).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 203,
        roomId: 9,
        userId: 3,
        subUserId: null,
        eventId: 1257,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 11).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 9,
            title: 'developers',
            slugId: 'AAAAqNofp2Q',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 202,
        roomId: 9,
        userId: 9,
        subUserId: null,
        eventId: 1256,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 11).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 9,
            title: 'developers',
            slugId: 'AAAAqNofp2Q',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 201,
        roomId: 9,
        userId: 1,
        subUserId: null,
        eventId: 1255,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 11).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 9,
            title: 'developers',
            slugId: 'AAAAqNofp2Q',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 200,
        roomId: 9,
        userId: 1,
        subUserId: null,
        eventId: 1254,
        workspaceId: 6,
        action: 'CHAT_REACTION_ADDED',
        date: subDays(new Date(), 11).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 9,
            title: 'developers',
            slugId: 'AAAAqNofp2Q',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 199,
        roomId: 4,
        userId: 10,
        subUserId: 11,
        eventId: 1118,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 10).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 198,
        roomId: 4,
        userId: 11,
        subUserId: null,
        eventId: 1111,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 10).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 197,
        roomId: 4,
        userId: 11,
        subUserId: 10,
        eventId: 1110,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 10).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 196,
        roomId: 4,
        userId: 10,
        subUserId: null,
        eventId: 1109,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 10).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 195,
        roomId: 4,
        userId: 10,
        subUserId: 11,
        eventId: 1108,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 10).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 194,
        roomId: 4,
        userId: 11,
        subUserId: null,
        eventId: 1104,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 9).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 193,
        roomId: 9,
        userId: 7,
        subUserId: null,
        eventId: 1048,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 9).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 9,
            title: 'developers',
            slugId: 'AAAAqNofp2Q',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 192,
        roomId: 8,
        userId: 3,
        subUserId: 11,
        eventId: 982,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 7).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 8,
            title: 'Default Chat',
            slugId: 'm0JbdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 191,
        roomId: 8,
        userId: 11,
        subUserId: null,
        eventId: 981,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 7).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 8,
            title: 'Default Chat',
            slugId: 'm0JbdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 190,
        roomId: 8,
        userId: 11,
        subUserId: 3,
        eventId: 980,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 7).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 8,
            title: 'Default Chat',
            slugId: 'm0JbdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 189,
        roomId: 8,
        userId: 3,
        subUserId: null,
        eventId: 979,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 7).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 8,
            title: 'Default Chat',
            slugId: 'm0JbdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 188,
        roomId: 6,
        userId: 11,
        subUserId: 1,
        eventId: 978,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 7).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 187,
        roomId: 6,
        userId: 1,
        subUserId: null,
        eventId: 967,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 7).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 186,
        roomId: 6,
        userId: 1,
        subUserId: 11,
        eventId: 966,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 7).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 185,
        roomId: 6,
        userId: 1,
        subUserId: 11,
        eventId: 965,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_EDITED',
        date: subDays(new Date(), 7).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 184,
        roomId: 6,
        userId: 1,
        subUserId: 11,
        eventId: 964,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_EDITED',
        date: subDays(new Date(), 7).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 183,
        roomId: 6,
        userId: 11,
        subUserId: null,
        eventId: 963,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 7).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 182,
        roomId: 6,
        userId: 11,
        subUserId: 1,
        eventId: 962,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 7).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 181,
        roomId: 6,
        userId: 1,
        subUserId: null,
        eventId: 961,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 7).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 180,
        roomId: 6,
        userId: 1,
        subUserId: 11,
        eventId: 960,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 7).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 179,
        roomId: 6,
        userId: 1,
        subUserId: 11,
        eventId: 959,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_EDITED',
        date: subDays(new Date(), 7).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 177,
        roomId: 4,
        userId: 10,
        subUserId: 11,
        eventId: 847,
        workspaceId: 6,
        action: 'CHAT_ATTACHMENT_UPLOAD',
        date: subDays(new Date(), 7).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 178,
        roomId: 4,
        userId: 10,
        subUserId: 11,
        eventId: 848,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 7).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 176,
        roomId: 4,
        userId: 10,
        subUserId: 11,
        eventId: 845,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 7).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 175,
        roomId: 4,
        userId: 11,
        subUserId: null,
        eventId: 844,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 7).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 174,
        roomId: 4,
        userId: 11,
        subUserId: null,
        eventId: 843,
        workspaceId: 6,
        action: 'CHAT_REACTION_ADDED',
        date: subDays(new Date(), 7).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 173,
        roomId: 4,
        userId: 11,
        subUserId: 10,
        eventId: 842,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 7).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 172,
        roomId: 4,
        userId: 10,
        subUserId: null,
        eventId: 841,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 7).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 171,
        roomId: 4,
        userId: 11,
        subUserId: 10,
        eventId: 840,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 7).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 170,
        roomId: 4,
        userId: 10,
        subUserId: null,
        eventId: 839,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 7).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 169,
        roomId: 4,
        userId: 10,
        subUserId: 11,
        eventId: 838,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 7).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 168,
        roomId: 4,
        userId: 11,
        subUserId: null,
        eventId: 837,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 7).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 167,
        roomId: 4,
        userId: 11,
        subUserId: 10,
        eventId: 836,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 7).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 166,
        roomId: 4,
        userId: 10,
        subUserId: null,
        eventId: 835,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 7).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 165,
        roomId: 4,
        userId: 10,
        subUserId: 11,
        eventId: 834,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 7).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 164,
        roomId: 4,
        userId: 11,
        subUserId: null,
        eventId: 833,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 7).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 163,
        roomId: 4,
        userId: 11,
        subUserId: 10,
        eventId: 832,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 7).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 162,
        roomId: 4,
        userId: 11,
        subUserId: 10,
        eventId: 831,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 7).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 161,
        roomId: 4,
        userId: 11,
        subUserId: 10,
        eventId: 830,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 7).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 160,
        roomId: 4,
        userId: 10,
        subUserId: null,
        eventId: 829,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 7).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 159,
        roomId: 4,
        userId: 10,
        subUserId: null,
        eventId: 828,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 7).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 157,
        roomId: 1,
        userId: 11,
        subUserId: 9,
        eventId: 826,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 7).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 158,
        roomId: 1,
        userId: 11,
        subUserId: 9,
        eventId: 827,
        workspaceId: 6,
        action: 'CHAT_ATTACHMENT_UPLOAD',
        date: subDays(new Date(), 7).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 156,
        roomId: 1,
        userId: 11,
        subUserId: 9,
        eventId: 825,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 7).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 155,
        roomId: 1,
        userId: 11,
        subUserId: 9,
        eventId: 824,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 7).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 154,
        roomId: 1,
        userId: 9,
        subUserId: null,
        eventId: 823,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 7).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 153,
        roomId: 1,
        userId: 11,
        subUserId: 9,
        eventId: 822,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 7).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 152,
        roomId: 1,
        userId: 9,
        subUserId: null,
        eventId: 821,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 7).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 151,
        roomId: 1,
        userId: 9,
        subUserId: 11,
        eventId: 820,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 7).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 150,
        roomId: 1,
        userId: 11,
        subUserId: null,
        eventId: 819,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 7).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 149,
        roomId: 1,
        userId: 11,
        subUserId: 9,
        eventId: 818,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 7).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 148,
        roomId: 1,
        userId: 11,
        subUserId: 9,
        eventId: 817,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 7).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 147,
        roomId: 1,
        userId: 9,
        subUserId: null,
        eventId: 816,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 7).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 146,
        roomId: 1,
        userId: 11,
        subUserId: 9,
        eventId: 815,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 7).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 145,
        roomId: 1,
        userId: 9,
        subUserId: null,
        eventId: 814,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 7).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 144,
        roomId: 1,
        userId: 9,
        subUserId: 11,
        eventId: 813,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 7).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 143,
        roomId: 1,
        userId: 9,
        subUserId: 11,
        eventId: 812,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 7).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 142,
        roomId: 1,
        userId: 9,
        subUserId: 11,
        eventId: 811,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 7).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 140,
        roomId: 1,
        userId: 9,
        subUserId: 11,
        eventId: 809,
        workspaceId: 6,
        action: 'CHAT_ATTACHMENT_UPLOAD',
        date: subDays(new Date(), 7).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 141,
        roomId: 1,
        userId: 9,
        subUserId: 11,
        eventId: 810,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 7).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 139,
        roomId: 1,
        userId: 11,
        subUserId: null,
        eventId: 808,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 7).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 138,
        roomId: 1,
        userId: 11,
        subUserId: 9,
        eventId: 807,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 7).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 137,
        roomId: 1,
        userId: 9,
        subUserId: null,
        eventId: 806,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 7).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 136,
        roomId: 1,
        userId: 11,
        subUserId: 9,
        eventId: 805,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 7).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 135,
        roomId: 1,
        userId: 9,
        subUserId: null,
        eventId: 804,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 7).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 134,
        roomId: 1,
        userId: 9,
        subUserId: 11,
        eventId: 803,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 7).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 133,
        roomId: 1,
        userId: 11,
        subUserId: null,
        eventId: 802,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 7).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 132,
        roomId: 1,
        userId: 11,
        subUserId: 9,
        eventId: 801,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 7).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 131,
        roomId: 1,
        userId: 9,
        subUserId: null,
        eventId: 800,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 7).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 130,
        roomId: 1,
        userId: 11,
        subUserId: 9,
        eventId: 799,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 7).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 129,
        roomId: 1,
        userId: 9,
        subUserId: null,
        eventId: 798,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 7).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 128,
        roomId: 1,
        userId: 11,
        subUserId: null,
        eventId: 797,
        workspaceId: 6,
        action: 'CHAT_REACTION_ADDED',
        date: subDays(new Date(), 7).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 126,
        roomId: 1,
        userId: 9,
        subUserId: 11,
        eventId: 795,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 7).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 127,
        roomId: 1,
        userId: 9,
        subUserId: 11,
        eventId: 796,
        workspaceId: 6,
        action: 'CHAT_ATTACHMENT_UPLOAD',
        date: subDays(new Date(), 7).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 125,
        roomId: 1,
        userId: 11,
        subUserId: null,
        eventId: 794,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 7).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 124,
        roomId: 1,
        userId: 11,
        subUserId: 9,
        eventId: 793,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 7).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 123,
        roomId: 1,
        userId: 11,
        subUserId: null,
        eventId: 792,
        workspaceId: 6,
        action: 'CHAT_REACTION_ADDED',
        date: subDays(new Date(), 7).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 122,
        roomId: 1,
        userId: 11,
        subUserId: 9,
        eventId: 791,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 7).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 121,
        roomId: 1,
        userId: 11,
        subUserId: 9,
        eventId: 790,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 7).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 120,
        roomId: 1,
        userId: 9,
        subUserId: null,
        eventId: 789,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 7).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 119,
        roomId: 1,
        userId: 9,
        subUserId: null,
        eventId: 788,
        workspaceId: 6,
        action: 'CHAT_REACTION_ADDED',
        date: subDays(new Date(), 7).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 118,
        roomId: 1,
        userId: 9,
        subUserId: 11,
        eventId: 787,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 7).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 116,
        roomId: 1,
        userId: 9,
        subUserId: 11,
        eventId: 785,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 7).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 117,
        roomId: 1,
        userId: 9,
        subUserId: 11,
        eventId: 786,
        workspaceId: 6,
        action: 'CHAT_ATTACHMENT_UPLOAD',
        date: subDays(new Date(), 7).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 115,
        roomId: 1,
        userId: 11,
        subUserId: null,
        eventId: 784,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 7).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 114,
        roomId: 1,
        userId: 11,
        subUserId: null,
        eventId: 783,
        workspaceId: 6,
        action: 'CHAT_REACTION_ADDED',
        date: subDays(new Date(), 7).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 113,
        roomId: 1,
        userId: 11,
        subUserId: 9,
        eventId: 782,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 7).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 112,
        roomId: 1,
        userId: 9,
        subUserId: null,
        eventId: 781,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 7).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 111,
        roomId: 5,
        userId: 11,
        subUserId: null,
        eventId: 780,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 7).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 5,
            title: '[Cart2Cart] Journal Feedback',
            slugId: 'AAAA6AlE3c0',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 110,
        roomId: 5,
        userId: 9,
        subUserId: null,
        eventId: 779,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 7).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 5,
            title: '[Cart2Cart] Journal Feedback',
            slugId: 'AAAA6AlE3c0',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 109,
        roomId: 4,
        userId: 11,
        subUserId: 10,
        eventId: 778,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 7).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 108,
        roomId: 6,
        userId: 11,
        subUserId: null,
        eventId: 777,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 7).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 107,
        roomId: 6,
        userId: 11,
        subUserId: null,
        eventId: 776,
        workspaceId: 6,
        action: 'CHAT_REACTION_ADDED',
        date: subDays(new Date(), 7).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 106,
        roomId: 4,
        userId: 10,
        subUserId: null,
        eventId: 775,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 7).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 105,
        roomId: 4,
        userId: 10,
        subUserId: null,
        eventId: 774,
        workspaceId: 6,
        action: 'CHAT_REACTION_ADDED',
        date: subDays(new Date(), 7).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 104,
        roomId: 7,
        userId: 11,
        subUserId: null,
        eventId: 763,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 6).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 7,
            title: '[Cart2Cart] ETL',
            slugId: 'AAAArpJpqHw',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 103,
        roomId: 7,
        userId: 11,
        subUserId: null,
        eventId: 762,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_EDITED',
        date: subDays(new Date(), 6).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 7,
            title: '[Cart2Cart] ETL',
            slugId: 'AAAArpJpqHw',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 102,
        roomId: 7,
        userId: 9,
        subUserId: null,
        eventId: 761,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 6).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 7,
            title: '[Cart2Cart] ETL',
            slugId: 'AAAArpJpqHw',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 101,
        roomId: 7,
        userId: 9,
        subUserId: null,
        eventId: 760,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 6).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 7,
            title: '[Cart2Cart] ETL',
            slugId: 'AAAArpJpqHw',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 100,
        roomId: 7,
        userId: 11,
        subUserId: null,
        eventId: 759,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 6).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 7,
            title: '[Cart2Cart] ETL',
            slugId: 'AAAArpJpqHw',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 99,
        roomId: 7,
        userId: 11,
        subUserId: null,
        eventId: 758,
        workspaceId: 6,
        action: 'CHAT_REACTION_ADDED',
        date: subDays(new Date(), 6).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 7,
            title: '[Cart2Cart] ETL',
            slugId: 'AAAArpJpqHw',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 98,
        roomId: 7,
        userId: 11,
        subUserId: null,
        eventId: 757,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 6).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 7,
            title: '[Cart2Cart] ETL',
            slugId: 'AAAArpJpqHw',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 97,
        roomId: 7,
        userId: 9,
        subUserId: null,
        eventId: 756,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 6).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 7,
            title: '[Cart2Cart] ETL',
            slugId: 'AAAArpJpqHw',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 96,
        roomId: 4,
        userId: 10,
        subUserId: 11,
        eventId: 755,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 6).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 95,
        roomId: 4,
        userId: 11,
        subUserId: null,
        eventId: 754,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 6).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 94,
        roomId: 4,
        userId: 11,
        subUserId: null,
        eventId: 753,
        workspaceId: 6,
        action: 'CHAT_REACTION_ADDED',
        date: subDays(new Date(), 6).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 93,
        roomId: 4,
        userId: 11,
        subUserId: 10,
        eventId: 752,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 6).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 92,
        roomId: 4,
        userId: 10,
        subUserId: null,
        eventId: 751,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 6).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 91,
        roomId: 4,
        userId: 10,
        subUserId: 11,
        eventId: 750,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 6).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 90,
        roomId: 4,
        userId: 11,
        subUserId: null,
        eventId: 749,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 6).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 89,
        roomId: 4,
        userId: 11,
        subUserId: null,
        eventId: 748,
        workspaceId: 6,
        action: 'CHAT_REACTION_ADDED',
        date: subDays(new Date(), 6).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 86,
        roomId: 6,
        userId: 1,
        subUserId: 11,
        eventId: 478,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 6).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 87,
        roomId: 6,
        userId: 1,
        subUserId: 11,
        eventId: 479,
        workspaceId: 6,
        action: 'CHAT_ATTACHMENT_UPLOAD',
        date: subDays(new Date(), 6).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 88,
        roomId: 6,
        userId: 1,
        subUserId: 11,
        eventId: 480,
        workspaceId: 6,
        action: 'CHAT_ATTACHMENT_UPLOAD',
        date: subDays(new Date(), 6).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 85,
        roomId: 6,
        userId: 11,
        subUserId: null,
        eventId: 456,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 5).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 84,
        roomId: 6,
        userId: 11,
        subUserId: 1,
        eventId: 455,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 5).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 83,
        roomId: 6,
        userId: 1,
        subUserId: null,
        eventId: 454,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 5).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 82,
        roomId: 6,
        userId: 1,
        subUserId: 11,
        eventId: 453,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 5).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 81,
        roomId: 6,
        userId: 11,
        subUserId: null,
        eventId: 442,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 5).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 6,
            title: 'Default Chat',
            slugId: 'ukDS9cAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 80,
        roomId: 3,
        userId: 9,
        subUserId: null,
        eventId: 374,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 5).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 79,
        roomId: 3,
        userId: 11,
        subUserId: null,
        eventId: 373,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 5).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 78,
        roomId: 3,
        userId: 9,
        subUserId: null,
        eventId: 372,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 5).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 77,
        roomId: 1,
        userId: 9,
        subUserId: 11,
        eventId: 371,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 5).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 76,
        roomId: 1,
        userId: 9,
        subUserId: 11,
        eventId: 370,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 5).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 75,
        roomId: 5,
        userId: 11,
        subUserId: null,
        eventId: 363,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 4).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 5,
            title: '[Cart2Cart] Journal Feedback',
            slugId: 'AAAA6AlE3c0',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 74,
        roomId: 5,
        userId: 11,
        subUserId: null,
        eventId: 362,
        workspaceId: 6,
        action: 'CHAT_REACTION_ADDED',
        date: subDays(new Date(), 4).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 5,
            title: '[Cart2Cart] Journal Feedback',
            slugId: 'AAAA6AlE3c0',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 73,
        roomId: 5,
        userId: 11,
        subUserId: null,
        eventId: 361,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 4).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 5,
            title: '[Cart2Cart] Journal Feedback',
            slugId: 'AAAA6AlE3c0',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 72,
        roomId: 1,
        userId: 11,
        subUserId: null,
        eventId: 360,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 4).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 71,
        roomId: 3,
        userId: 9,
        subUserId: null,
        eventId: 359,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 4).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 70,
        roomId: 1,
        userId: 11,
        subUserId: null,
        eventId: 358,
        workspaceId: 6,
        action: 'CHAT_REACTION_ADDED',
        date: subDays(new Date(), 4).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 69,
        roomId: 5,
        userId: 9,
        subUserId: null,
        eventId: 357,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 4).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 5,
            title: '[Cart2Cart] Journal Feedback',
            slugId: 'AAAA6AlE3c0',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 68,
        roomId: 1,
        userId: 11,
        subUserId: 9,
        eventId: 356,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 4).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 67,
        roomId: 1,
        userId: 9,
        subUserId: null,
        eventId: 355,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 4).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 66,
        roomId: 1,
        userId: 9,
        subUserId: 11,
        eventId: 354,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 4).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 65,
        roomId: 5,
        userId: 11,
        subUserId: null,
        eventId: 353,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 4).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 5,
            title: '[Cart2Cart] Journal Feedback',
            slugId: 'AAAA6AlE3c0',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 64,
        roomId: 5,
        userId: 11,
        subUserId: null,
        eventId: 352,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 4).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 5,
            title: '[Cart2Cart] Journal Feedback',
            slugId: 'AAAA6AlE3c0',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 63,
        roomId: 5,
        userId: 11,
        subUserId: null,
        eventId: 351,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 4).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 5,
            title: '[Cart2Cart] Journal Feedback',
            slugId: 'AAAA6AlE3c0',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 62,
        roomId: 5,
        userId: 11,
        subUserId: null,
        eventId: 350,
        workspaceId: 6,
        action: 'CHAT_REACTION_ADDED',
        date: subDays(new Date(), 4).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 5,
            title: '[Cart2Cart] Journal Feedback',
            slugId: 'AAAA6AlE3c0',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 61,
        roomId: 5,
        userId: 11,
        subUserId: null,
        eventId: 349,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 4).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 5,
            title: '[Cart2Cart] Journal Feedback',
            slugId: 'AAAA6AlE3c0',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 60,
        roomId: 5,
        userId: 11,
        subUserId: null,
        eventId: 348,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 4).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 5,
            title: '[Cart2Cart] Journal Feedback',
            slugId: 'AAAA6AlE3c0',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 59,
        roomId: 1,
        userId: 11,
        subUserId: null,
        eventId: 347,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 4).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 58,
        roomId: 1,
        userId: 11,
        subUserId: 9,
        eventId: 346,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 4).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 57,
        roomId: 1,
        userId: 9,
        subUserId: null,
        eventId: 345,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 4).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 56,
        roomId: 1,
        userId: 9,
        subUserId: null,
        eventId: 344,
        workspaceId: 6,
        action: 'CHAT_REACTION_ADDED',
        date: subDays(new Date(), 4).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 54,
        roomId: 2,
        userId: 12,
        subUserId: null,
        eventId: 342,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 4).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 2,
            title: 'Default Chat',
            slugId: 'iSy3F8AAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 55,
        roomId: 2,
        userId: 12,
        subUserId: null,
        eventId: 343,
        workspaceId: 6,
        action: 'CHAT_DIRECT_MESSAGE_STARTED',
        date: subDays(new Date(), 4).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 2,
            title: 'Default Chat',
            slugId: 'iSy3F8AAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 53,
        roomId: 2,
        userId: 12,
        subUserId: null,
        eventId: 341,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 4).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 2,
            title: 'Default Chat',
            slugId: 'iSy3F8AAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 52,
        roomId: 2,
        userId: 12,
        subUserId: null,
        eventId: 339,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 4).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 2,
            title: 'Default Chat',
            slugId: 'iSy3F8AAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 51,
        roomId: 2,
        userId: 12,
        subUserId: null,
        eventId: 338,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 4).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 2,
            title: 'Default Chat',
            slugId: 'iSy3F8AAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 50,
        roomId: 2,
        userId: 12,
        subUserId: null,
        eventId: 337,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 4).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 2,
            title: 'Default Chat',
            slugId: 'iSy3F8AAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 49,
        roomId: 2,
        userId: 12,
        subUserId: null,
        eventId: 336,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 4).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 2,
            title: 'Default Chat',
            slugId: 'iSy3F8AAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 48,
        roomId: 2,
        userId: 11,
        subUserId: null,
        eventId: 303,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 4).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 2,
            title: 'Default Chat',
            slugId: 'iSy3F8AAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 47,
        roomId: 2,
        userId: 11,
        subUserId: null,
        eventId: 302,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 4).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 2,
            title: 'Default Chat',
            slugId: 'iSy3F8AAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 46,
        roomId: 2,
        userId: 11,
        subUserId: null,
        eventId: 301,
        workspaceId: 6,
        action: 'CHAT_INVITE_ACCEPT',
        date: subDays(new Date(), 4).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 2,
            title: 'Default Chat',
            slugId: 'iSy3F8AAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 45,
        roomId: 2,
        userId: 11,
        subUserId: null,
        eventId: 300,
        workspaceId: 6,
        action: 'CHAT_UNREAD_TIMESTAMP_UPDATED',
        date: subDays(new Date(), 4).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 2,
            title: 'Default Chat',
            slugId: 'iSy3F8AAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 44,
        roomId: 4,
        userId: 10,
        subUserId: 11,
        eventId: 264,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 4).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 43,
        roomId: 4,
        userId: 11,
        subUserId: null,
        eventId: 263,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 4).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 42,
        roomId: 4,
        userId: 11,
        subUserId: 10,
        eventId: 262,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 4).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 41,
        roomId: 4,
        userId: 10,
        subUserId: null,
        eventId: 261,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 4).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 40,
        roomId: 4,
        userId: 10,
        subUserId: 11,
        eventId: 260,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 4).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 39,
        roomId: 4,
        userId: 10,
        subUserId: 11,
        eventId: 259,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 4).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 38,
        roomId: 4,
        userId: 11,
        subUserId: null,
        eventId: 237,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 3).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 37,
        roomId: 4,
        userId: 10,
        subUserId: 11,
        eventId: 183,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 3).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 35,
        roomId: 4,
        userId: 10,
        subUserId: 11,
        eventId: 181,
        workspaceId: 6,
        action: 'CHAT_ATTACHMENT_UPLOAD',
        date: subDays(new Date(), 3).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 36,
        roomId: 4,
        userId: 10,
        subUserId: 11,
        eventId: 182,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 3).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 34,
        roomId: 4,
        userId: 11,
        subUserId: null,
        eventId: 179,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 2).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 33,
        roomId: 4,
        userId: 11,
        subUserId: 10,
        eventId: 178,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 2).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 32,
        roomId: 4,
        userId: 10,
        subUserId: null,
        eventId: 177,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 2).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 4,
            title: 'Default Chat',
            slugId: 'x4dcDoAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 31,
        roomId: 3,
        userId: 9,
        subUserId: null,
        eventId: 33,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 1).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 30,
        roomId: 3,
        userId: 9,
        subUserId: null,
        eventId: 32,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 1).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 29,
        roomId: 3,
        userId: 9,
        subUserId: null,
        eventId: 31,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 1).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 28,
        roomId: 3,
        userId: 11,
        subUserId: null,
        eventId: 30,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 1).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 27,
        roomId: 3,
        userId: 11,
        subUserId: null,
        eventId: 29,
        workspaceId: 6,
        action: 'CHAT_REACTION_ADDED',
        date: subDays(new Date(), 1).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 26,
        roomId: 3,
        userId: 11,
        subUserId: null,
        eventId: 28,
        workspaceId: 6,
        action: 'CHAT_REACTION_ADDED',
        date: subDays(new Date(), 1).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 3,
            title: '[Cart2Cart] Native Shopify App',
            slugId: 'AAAAcphYLxc',
            workspaceId: 6,
            type: 'SPACE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 25,
        roomId: 1,
        userId: 11,
        subUserId: 9,
        eventId: 27,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 1).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 24,
        roomId: 1,
        userId: 11,
        subUserId: 9,
        eventId: 26,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 1).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 23,
        roomId: 1,
        userId: 9,
        subUserId: null,
        eventId: 25,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 1).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 22,
        roomId: 2,
        userId: 11,
        subUserId: null,
        eventId: 24,
        workspaceId: 6,
        action: 'CHAT_UNREAD_TIMESTAMP_UPDATED',
        date: subDays(new Date(), 1).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 2,
            title: 'Default Chat',
            slugId: 'iSy3F8AAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 21,
        roomId: 1,
        userId: 9,
        subUserId: 11,
        eventId: 23,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 1).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 20,
        roomId: 2,
        userId: 11,
        subUserId: 12,
        eventId: 22,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 1).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 2,
            title: 'Default Chat',
            slugId: 'iSy3F8AAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 19,
        roomId: 2,
        userId: 11,
        subUserId: 12,
        eventId: 21,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 1).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 2,
            title: 'Default Chat',
            slugId: 'iSy3F8AAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 18,
        roomId: 1,
        userId: 11,
        subUserId: null,
        eventId: 20,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 1).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 17,
        roomId: 1,
        userId: 11,
        subUserId: 9,
        eventId: 19,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 1).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 16,
        roomId: 1,
        userId: 11,
        subUserId: 9,
        eventId: 18,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 1).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 15,
        roomId: 1,
        userId: 9,
        subUserId: null,
        eventId: 17,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 1).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 14,
        roomId: 1,
        userId: 9,
        subUserId: 11,
        eventId: 16,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 1).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 13,
        roomId: 1,
        userId: 9,
        subUserId: 11,
        eventId: 15,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 1).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 12,
        roomId: 1,
        userId: 9,
        subUserId: 11,
        eventId: 14,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 1).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 11,
        roomId: 1,
        userId: 11,
        subUserId: null,
        eventId: 13,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 1).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 10,
        roomId: 1,
        userId: 11,
        subUserId: 9,
        eventId: 12,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 1).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 9,
        roomId: 1,
        userId: 11,
        subUserId: 9,
        eventId: 11,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 1).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 8,
        roomId: 1,
        userId: 9,
        subUserId: null,
        eventId: 10,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 1).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 7,
        roomId: 1,
        userId: 9,
        subUserId: 11,
        eventId: 9,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 1).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 6,
        roomId: 1,
        userId: 9,
        subUserId: 11,
        eventId: 8,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 1).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 5,
        roomId: 1,
        userId: 11,
        subUserId: null,
        eventId: 7,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 1).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 4,
        roomId: 1,
        userId: 11,
        subUserId: null,
        eventId: 6,
        workspaceId: 6,
        action: 'CHAT_REACTION_ADDED',
        date: subDays(new Date(), 1).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 3,
        roomId: 1,
        userId: 11,
        subUserId: 9,
        eventId: 5,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 1).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 2,
        roomId: 1,
        userId: 9,
        subUserId: null,
        eventId: 4,
        workspaceId: 6,
        action: 'CHAT_CONVERSATION_READ',
        date: subDays(new Date(), 1).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 1,
        roomId: 1,
        userId: 9,
        subUserId: 11,
        eventId: 3,
        workspaceId: 6,
        action: 'CHAT_MESSAGE_POSTED',
        date: subDays(new Date(), 1).toISOString(),
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        room: {
            id: 1,
            title: 'Default Chat',
            slugId: 'tq4TdcAAAAE',
            workspaceId: 6,
            type: 'USER_TO_USER_DIRECT_MESSAGE',
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    }
];
